{
  "brand": {
    "name": "CoreWay",
    "product": "DispatchOS",
    "motto": "One System. Every Carrier. A Stronger Tomorrow.",
    "tagline": "Dispatch Smarter. Move Further.",
    "mottoLine1": "One System.",
    "mottoLine2": "Every Carrier.",
    "mottoLine3": "A Stronger Tomorrow.",
    "version": "v{{version}}"
  },
  "layout": {
    "menu": "Menu",
    "openMenu": "Open menu",
    "openMenuUnread": "Open menu, {{count}} unread conversations",
    "closeMenu": "Close menu"
  },
  "nav": {
    "dashboard": "Dashboard",
    "documentation": "Documentation",
    "brokers": "Brokers",
    "brokersCreditCheck": "Credit Check",
    "brokersRateConfirmations": "Rate Confirmations",
    "brokersBolsPods": "BOLs / PODs",
    "brokersReceipts": "Receipts",
    "carriers": "Carriers",
    "carriersPackages": "Packages",
    "carriersInvoices": "Invoices",
    "carriersTrucks": "Trucks",
    "carriersDrivers": "Drivers",
    "reports": "Reports",
    "dispatchers": "Dispatchers",
    "dispatchersAssignedDrivers": "Assigned Drivers",
    "dispatchersDispatch": "Dispatch",
    "loads": "Loads",
    "tasks": "Tasks",
    "chat": "Chat",
    "support": "Support",
    "expand": "Expand {{section}}",
    "collapse": "Collapse {{section}}",
    "brokersSetups": "Broker Setups",
    "brokersPayments": "Broker Payments",
    "carriersOwnerStatements": "Owner Statements",
    "carriersDriverSettlements": "Driver Settlements",
    "dispatchersPay": "Dispatcher Pay",
    "activity": "Activity",
    "toInvoiceBadge_one": "{{count}} load to invoice",
    "toInvoiceBadge_other": "{{count}} loads to invoice",
    "brokersFacilities": "Facilities"
  },
  "topbar": {
    "searchPlaceholder": "Search loads, carriers, drivers, brokers…",
    "searchLabel": "Global search",
    "notifications": "Notifications",
    "notificationCount_one": "{{count}} unread notification",
    "notificationCount_other": "{{count}} unread notifications",
    "workspace": "Workspace",
    "noWorkspace": "No agency loaded",
    "switchAgency": "Switch agency (current: {{agency}})",
    "agencies": "Your agencies",
    "switched": "Now working in {{agency}}."
  },
  "search": {
    "open": "Search",
    "short": "Search",
    "title": "Search",
    "help": "Loads by number, broker reference or city; drivers; carriers by name, MC or DOT; trucks by unit or VIN; brokers by name or MC.",
    "hint": "Type at least 2 characters: a load number, broker reference or city, a driver, a carrier, MC or DOT, a truck unit or VIN, a broker.",
    "loading": "Searching…",
    "empty": "Nothing matches “{{query}}” in this agency.",
    "error": "The search failed. Try again.",
    "results": "Results",
    "kinds": {
      "load": "Load",
      "driver": "Driver",
      "carrier": "Carrier",
      "truck": "Truck",
      "broker": "Broker"
    },
    "group": "{{kind}} · {{count}}",
    "kindsPlural": {
      "load": "Loads",
      "driver": "Drivers",
      "carrier": "Carriers",
      "truck": "Trucks",
      "broker": "Brokers"
    },
    "keys": "↑↓ to move · ↵ to open · Esc to close"
  },
  "notifications": {
    "title": "Notifications",
    "empty": "You are all caught up.",
    "error": "Could not load the notifications.",
    "unread": "Unread",
    "aDriver": "A driver",
    "chat_one": "{{driver}} sent a message",
    "chat_other": "{{driver}} sent {{count}} messages",
    "delivered": "{{load}} was delivered",
    "pod": "POD received for {{load}}",
    "kinds": {
      "chat_message": "Chat",
      "load_rejected": "Load rejected",
      "task_assigned": "Task",
      "document_expiring": "Document",
      "invoice_overdue": "Invoice",
      "load_delivered": "Delivered",
      "pod_received": "POD",
      "receivable_overdue": "Broker payment",
      "load_canceled": "Load canceled"
    },
    "tabs": {
      "forMe": "For me",
      "activity": "Activity"
    },
    "tabCount": "{{count}} unread",
    "activityEmpty": "No team activity yet.",
    "activityError": "Could not load the activity.",
    "viewAllActivity": "View all activity",
    "activityOff": "Activity notifications are off.",
    "activityTurnOff": "Turn off",
    "activityTurnOn": "Turn on",
    "activityTurnOffLabel": "Turn off activity notifications",
    "activityTurnOnLabel": "Turn on activity notifications"
  },
  "user": {
    "settings": "Settings",
    "signOut": "Sign out",
    "roleUnknown": "Role pending",
    "roleLoading": "Loading role…",
    "roleNone": "No office role",
    "roleSuspended": "Access paused"
  },
  "auth": {
    "title": "Sign in",
    "subtitle": "Dispatch Smarter. Move Further.",
    "email": "Email",
    "emailPlaceholder": "you@agency.com",
    "password": "Password",
    "passwordPlaceholder": "Your password",
    "submit": "Sign in",
    "submitting": "Signing in…",
    "invalidCredentials": "Wrong email or password.",
    "checking": "Checking your session…",
    "link": {
      "toggle": "Email me a sign-in link instead",
      "usePassword": "Sign in with a password",
      "title": "Get a sign-in link",
      "body": "Enter your email and we will send you a link that signs you in. No password needed.",
      "submit": "Email me a link",
      "sending": "Sending…",
      "emailRequired": "Enter your email address.",
      "sent": "If {{email}} has a Coreway account, we sent it a sign-in link. Open it in this browser.",
      "sendAgain": "Send again",
      "sendAgainIn": "Send again in {{seconds}} s",
      "sentAgain": "Sent again.",
      "forgot": "Forgot it? Email me a sign-in link"
    },
    "linkSignedIn": {
      "title": "Signed in as {{email}}",
      "continue": "Continue",
      "notYou": "Not you? Sign out"
    },
    "oauth": {
      "google": "Continue with Google",
      "apple": "Continue with Apple",
      "redirecting": "Opening {{provider}}…",
      "or": "or"
    },
    "errors": {
      "tooManyEmails": "Too many emails were sent to this address. Wait a few minutes and try again.",
      "invalidEmail": "Not a valid email address.",
      "linkExpired": "That sign-in link has expired or was already used. Send a new one.",
      "linkOtherBrowser": "This sign-in link was asked for in another browser. Open it there, or send a new one from here.",
      "otherAccount": "This link is for another account ({{email}}). Sign out first to use it, then ask for a new link.",
      "weakPassword": "Choose a stronger password: at least 8 characters.",
      "samePassword": "That is already your password. Choose a new one.",
      "invalidCredentials": "Wrong email or password.",
      "network": "Could not reach the server. Check your connection and try again.",
      "generic": "Something went wrong. Try again.",
      "oauthCancelled": "Sign-in was canceled. Try again when you're ready.",
      "oauthFailed": "We couldn't sign you in with that account. Try again, or use your email.",
      "oauthUnavailable": "This sign-in option isn't available right now. Use your email instead.",
      "identityTaken": "That account is already linked to another Coreway account.",
      "otherAccountOAuth": "That account ({{email}}) belongs to another Coreway account. You're still signed in here; sign out first to use it."
    },
    "signup": {
      "title": "Start your free trial",
      "subtitle": "30 days free. No card needed.",
      "body": "Enter your email and we will send you a link that creates your account. Then you name your agency and start dispatching.",
      "sent": "We sent a link to {{email}}. Open it in this browser to continue.",
      "haveAccount": "Already have an account?",
      "signIn": "Sign in",
      "steps": {
        "enter": "Enter your email",
        "open": "Open the link we send you, in this browser",
        "name": "Name your agency and start dispatching"
      },
      "stepsLabel": "How it works"
    },
    "startTrial": "New to Coreway?",
    "startTrialLink": "Start a free trial",
    "showPassword": "Show password",
    "show": "Show",
    "hide": "Hide"
  },
  "empty": {
    "notBuilt": "Coming soon",
    "explain": "This screen is on its way. Everything else in the portal works as usual."
  },
  "primitives": {
    "featureOff": {
      "hint": "Nothing to show while this is off."
    },
    "meter": {
      "milesLeft": "{{value}} mi left",
      "milesOver": "{{value}} mi overdue",
      "daysLeft_one": "{{count}} day left",
      "daysLeft_other": "{{count}} days left",
      "daysOver_one": "{{count}} day overdue",
      "daysOver_other": "{{count}} days overdue",
      "moneyLeft": "${{amount}} left",
      "moneyOver": "${{amount}} over",
      "unknown": "No reading yet"
    },
    "rows": {
      "max": "Up to {{max}} lines."
    },
    "pageHelp": "About {{title}}",
    "table": {
      "rows_one": "{{count}} row",
      "rows_other": "{{count}} rows"
    },
    "filters": {
      "label": "Filters",
      "more": "More filters",
      "moreCount": "More filters ({{count}})",
      "clear": "Clear filters",
      "remove": "Remove filter: {{label}}"
    },
    "kpi": {
      "more": "More figures",
      "less": "Fewer figures"
    },
    "settingsNav": "Settings sections"
  },
  "kpi": {
    "scope": "Month to date · agency time",
    "short": {
      "dispatchFeesMtd": "Dispatch fees",
      "loadedMiles": "Loaded miles",
      "deadheadMiles": "Deadhead",
      "totalMiles": "Total miles",
      "carrierRevenue": "Carrier revenue"
    },
    "activeLoads": "Active loads",
    "deliveredThisWeek": "Delivered · week",
    "grossRevenue": "Revenue (MTD)",
    "avgRatePerMile": "Avg $/mi (MTD)",
    "dispatchFeesMtd": "Dispatch fees (MTD)",
    "loadedMiles": "Loaded miles (MTD)",
    "deadheadMiles": "Deadhead (MTD)",
    "totalMiles": "Total miles (MTD)",
    "carrierRevenue": "Carrier revenue (MTD)",
    "outstandingInvoices": "Open invoices",
    "tasksDue": "Tasks due today",
    "deltaUp": "{{percent}}%",
    "up": "up",
    "down": "down",
    "loading": "Loading KPIs…",
    "error": "The KPIs could not be loaded."
  },
  "status": {
    "booked": "Booked",
    "dispatched": "Dispatched",
    "accepted": "Accepted",
    "atPickup": "At Pickup",
    "loaded": "Loaded",
    "inTransit": "In Transit",
    "delivered": "Delivered",
    "podReceived": "POD Received"
  },
  "invoiceStatus": {
    "draft": "Draft",
    "sent": "Sent",
    "paid": "Paid",
    "overdue": "Overdue",
    "canceled": "Canceled"
  },
  "invoices": {
    "title": "Invoices",
    "loading": "Loading invoices…",
    "error": "The invoices could not be loaded.",
    "retry": "Try again",
    "empty": "No invoices to show.",
    "dismiss": "Dismiss",
    "daysOverdue_one": "{{count}} day overdue",
    "daysOverdue_other": "{{count}} days overdue",
    "confirmVoid": "Void invoice {{number}}? A draft is deleted and its number freed; a sent invoice is canceled.",
    "columns": {
      "number": "Invoice #",
      "status": "Status",
      "carrier": "Carrier",
      "issued": "Issued",
      "due": "Due",
      "amount": "Amount",
      "actions": "Actions",
      "email": "Email"
    },
    "raise": {
      "carrierLabel": "Carrier",
      "carrierPlaceholder": "Select a carrier…",
      "action": "Raise invoice",
      "help": "Bills the carrier's unbilled dispatch fees as a new draft."
    },
    "actions": {
      "send": "Send",
      "void": "Void",
      "download": "Download PDF",
      "downloadFor": "Download PDF of {{number}}",
      "preparing": "Preparing PDF",
      "emailAgain": "Email again",
      "downloadIn": "Download PDF ({{language}})",
      "voidMenu": "Void invoice…"
    },
    "penalty": {
      "descriptionLabel": "Penalty description",
      "descriptionPlaceholder": "e.g. Backed out of load CW-1048",
      "amountLabel": "Amount",
      "action": "Add penalty"
    },
    "charge": {
      "open": "Add charge",
      "help": "Starts a new invoice with this charge. Any unbilled dispatch fees of the carrier go on it too.",
      "hasDraft": "{{carrier}} has draft {{number}}: open it below and add the charge there.",
      "descriptionLabel": "Charge description",
      "amountLabel": "Charge amount",
      "submit": "Raise invoice with this charge",
      "raised": "Invoice raised with the charge"
    },
    "lines": {
      "loading": "Loading lines…",
      "error": "The lines could not be loaded.",
      "empty": "This invoice has no lines yet.",
      "columns": {
        "lineNo": "#",
        "kind": "Kind",
        "description": "Description",
        "quantity": "Qty",
        "unitAmount": "Unit",
        "amount": "Amount"
      },
      "kinds": {
        "dispatch_fee": "Dispatch fee",
        "penalty": "Penalty",
        "fee_true_up": "POD adjustment",
        "other": "Other line"
      },
      "provisional": "In transit (provisional)",
      "provisionalHelp": "Billed at the Friday close while the load was on the road. Any difference in the fee at the POD goes on a later invoice as a POD adjustment."
    },
    "errors": {
      "forbidden": "You are not allowed to do that.",
      "badState": "The invoice is not in a state that allows this.",
      "duplicate": "That load is already billed on an invoice.",
      "constraint": "That line is not valid for its kind.",
      "notFound": "That carrier or invoice no longer exists.",
      "generic": "The action failed: {{message}}",
      "nothingToBill": "Nothing to bill for this carrier: every fee is already on an invoice or on hold. Only loads with the POD received are billed, plus loads already picked up when the carrier is set to bill in transit.",
      "noRecipient": "This carrier has no billing or contact email. Add one, or mark the invoice as sent without email.",
      "hasDraft": "This carrier already has draft {{number}}: add the charge to it."
    },
    "payments": {
      "balanceColumn": "Balance",
      "paidLine": "Paid {{amount}}",
      "writtenOffLine": "Written off {{amount}}",
      "record": "Record payment",
      "recordFor": "Record payment for {{number}}",
      "writeOff": "Write off",
      "voidBlocked": "Reverse its payments before voiding it.",
      "voidTitle": "Void invoice {{number}}?",
      "voidConfirm": "Void invoice",
      "voided": "{{number}} voided",
      "sent": "{{number}} sent",
      "raised": "Invoice raised",
      "penaltyAdded": "Penalty added",
      "title": "Payments",
      "loading": "Loading payments…",
      "error": "The payments could not be loaded.",
      "empty": "No payments recorded yet.",
      "columns": {
        "date": "Date",
        "kind": "Kind",
        "amount": "Amount",
        "reference": "Reference / reason",
        "recorded": "Recorded",
        "state": "State",
        "action": "Action"
      },
      "writeOffKind": "Write-off",
      "reversed": "Reversed",
      "reversedBy": "by {{name}}, {{date}}: {{reason}}",
      "recordedBy": "{{name}}, {{date}}",
      "reverse": "Reverse",
      "reverseWriteOffLabel": "Reverse the {{amount}} write-off",
      "reverseLabel": "Reverse the {{amount}} payment",
      "dialog": {
        "title": "Record payment for {{number}}",
        "amount": "Amount",
        "balanceHelp": "Balance {{amount}}",
        "paidOn": "Paid on",
        "method": "Method",
        "methodPlaceholder": "Select a method…",
        "reference": "Reference",
        "notes": "Notes",
        "after": "After this payment the balance is {{amount}}.",
        "afterZero": "The invoice will be marked paid and its reminders stop.",
        "submit": "Record payment",
        "done": "Payment of {{amount}} recorded on {{number}}"
      },
      "writeOffDialog": {
        "title": "Write off {{number}}?",
        "body": "Closes the remaining {{amount}} of {{number}} as uncollectable. The invoice counts as paid and its reminders stop. An admin can reverse it.",
        "confirm": "Write off",
        "done": "{{number}} written off"
      },
      "reverseDialog": {
        "title": "Reverse this payment?",
        "body": "The {{amount}} payment is kept in the history as reversed. The invoice goes back to sent, or overdue if its due date has passed, and its reminders resume.",
        "confirm": "Reverse",
        "titleWriteOff": "Reverse this write-off?",
        "bodyWriteOff": "The {{amount}} write-off is kept in the history as reversed. The invoice goes back to sent, or overdue if its due date has passed, and its reminders resume.",
        "doneWriteOff": "Write-off reversed",
        "done": "Payment reversed"
      }
    },
    "noAccess": "Carrier invoices are for the admin and accounting only.",
    "send": {
      "title": "Email invoice {{number}}",
      "body": "{{carrier}} gets the invoice as a PDF at {{email}}. The invoice becomes Sent and can no longer be edited.",
      "noEmail": "{{carrier}} has no billing or contact email.",
      "noEmailBody": "Add an email to the carrier and send it, or mark it sent and hand the PDF over yourself. The invoice can no longer be edited after that.",
      "addEmail": "Add an email to the carrier",
      "withoutEmail": "Mark as sent without email",
      "confirm": "Send",
      "done": "Invoice {{number}} sent to {{email}}",
      "doneWithoutEmail": "Invoice {{number}} marked sent"
    },
    "again": {
      "title": "Email invoice {{number}} again",
      "body": "The same PDF the carrier got, in the language it was first sent. Change the address to send it somewhere else.",
      "confirm": "Email again",
      "done": "Emailing invoice {{number}}"
    },
    "email": {
      "queued": "Emailing",
      "sent": "Emailed {{date}} to {{email}}",
      "failed": "Email failed",
      "failedHelp": "The email to {{email}} failed. The task in Tasks has the reason.",
      "none": "Not emailed"
    },
    "kpi": {
      "outstanding": "Outstanding balance",
      "drafts": "Drafts to send",
      "overdue": "Overdue",
      "paidThisMonth": "Paid this month",
      "paidHint": "By last payment date",
      "invoices_one": "{{count}} invoice",
      "invoices_other": "{{count}} invoices",
      "draftsHint": "Not emailed yet"
    },
    "filters": {
      "status": "Invoice status",
      "search": "Search invoice #"
    },
    "totals_one": "Totals · {{count}} invoice",
    "totals_other": "Totals · {{count}} invoices"
  },
  "board": {
    "title": "Dispatch Board",
    "filtersLabel": "Filter the board by load status",
    "filters": {
      "all": "All Loads",
      "booked": "Booked",
      "inTransit": "In Transit",
      "delivered": "Delivered",
      "dispatched": "Waiting for an answer"
    },
    "loading": "Loading loads…",
    "error": "The board could not be loaded.",
    "retry": "Try again",
    "empty": "No active loads right now.",
    "columns": {
      "number": "Load #",
      "carrier": "Carrier",
      "driver": "Driver / unit",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "status": "Status",
      "rate": "Rate",
      "actions": "Actions",
      "route": "Route"
    },
    "actions": {
      "view": "View load {{load}}",
      "documents": "Documents of load {{load}}",
      "track": "Track load {{load}}"
    },
    "dispatch": "Dispatch {{load}}",
    "noBroker": "No broker",
    "foot": {
      "loads_one": "{{count}} load",
      "loads_other": "{{count}} loads",
      "withBooked_one": "{{count}} load · {{booked}} waiting for a driver",
      "withBooked_other": "{{count}} loads · {{booked}} waiting for a driver"
    },
    "free": {
      "label": "Drivers and trucks free",
      "now": "Free now",
      "nobody": "Nobody",
      "next": "Next free",
      "at": "{{name}} {{date}}",
      "link": "Availability"
    },
    "miles": "{{miles}} mi"
  },
  "detail": {
    "title": "Load Details – {{load}}",
    "tabsLabel": "Load detail sections",
    "tabs": {
      "overview": "Overview",
      "stops": "Stops",
      "documents": "Documents",
      "financials": "Financials",
      "tracking": "Tracking",
      "notes": "Notes"
    },
    "tracking": {
      "notStarted": "Tracking starts when the driver accepts the load.",
      "checkIns": "Stop check-ins",
      "notYet": "Not arrived yet"
    },
    "notes": {
      "load": "Load notes",
      "none": "No notes on this load.",
      "edit": "Edit the notes on the load page"
    }
  },
  "documents": {
    "title": "Documents",
    "kinds": {
      "rateConfirmation": "Rate Confirmation",
      "bol": "BOL",
      "pod": "POD",
      "lumperReceipt": "Lumper Receipt"
    },
    "uploadedOn": "Uploaded {{date}}",
    "notUploaded": "Not uploaded yet",
    "upload": "Upload",
    "download": "Download",
    "viewAll": "View All Documents",
    "uploadKind": "Upload {{kind}}",
    "downloadKind": "Download {{kind}}",
    "warning": {
      "image_unconverted": "{{file}} could not be added to the packet. Download it from the load.",
      "pdf_unreadable": "{{file}} is protected or damaged and was not merged.",
      "logo_missing": "The logo could not be found; the PDF was drawn without it.",
      "logo_unreadable": "The logo could not be read; the PDF was drawn without it.",
      "generic": "A page of this PDF could not be drawn."
    },
    "failed": "The PDF could not be prepared. Try again.",
    "timeout": "The PDF is taking longer than usual. Try again in a minute.",
    "tooMany": "Too many documents are being prepared. Try again in a minute.",
    "retry": "Try again",
    "chooseLanguage": "Choose the language of {{label}}",
    "languages": {
      "en": "English",
      "es": "Español"
    },
    "errors": {
      "packetTooBig": "The load documents are larger than 30 MB together. Download them one by one from the load.",
      "throttleMinute": "This document was emailed a moment ago. Try again in a minute.",
      "throttleDay": "This document was already emailed 10 times today.",
      "notSent": "Only a sent invoice can be emailed.",
      "notInvoiced": "Mark the load invoiced first.",
      "typeEmail": "Type the email address to send it to.",
      "brokerNoEmail": "The broker has no email on file. Type one."
    }
  },
  "timeline": {
    "title": "Load Status Timeline",
    "steps": {
      "dispatched": "Dispatched",
      "arrivedAtShipper": "Arrived at Shipper",
      "loaded": "Loaded",
      "inTransit": "In Transit",
      "arrivedAtReceiver": "Arrived at Receiver",
      "delivered": "Delivered",
      "podReceived": "POD Received"
    },
    "empty": "Nothing happened on this load yet.",
    "line": "{{title}} {{channel}}",
    "reason": "“{{reason}}”",
    "kinds": {
      "created": "Created",
      "declined": "Declined",
      "dispatchedTo": "{{driver}} · Unit {{unit}}",
      "stopArrived": "Arrived at {{stop}}",
      "stopDeparted": "Left {{stop}}",
      "stopRescheduled": "{{stop}}: appointment moved",
      "rescheduledFromTo": "From {{from}} to {{to}}",
      "appointmentCleared": "{{stop}}: appointment removed",
      "stopRemoved": "{{stop}} removed",
      "repriced": "Repriced",
      "repricedDetail": "Rate {{linehaul}}, accessorial {{accessorial}}",
      "feeDisputed": "Fee disputed",
      "feeDisputeCleared": "Fee dispute cleared",
      "feeReversed": "Fee reversed",
      "documentAdded": "{{kind}} uploaded",
      "documentArchived": "{{kind}} archived",
      "documentReplaced": "{{kind}} replaced",
      "quickPayRequested": "Quick pay requested",
      "other": "Updated",
      "stopRestamped": "{{stop}}: time corrected",
      "restampedArrive": "Arrival from {{from}} to {{to}}",
      "restampedDepart": "Departure from {{from}} to {{to}}",
      "accessorialChanged": "{{kind}} {{action}}: {{amount}}",
      "accessorialChangedGeneric": "Accessorials changed"
    },
    "channel": {
      "app": "in the app",
      "phone": "by phone (entered by {{name}})",
      "phoneAnon": "by phone",
      "office": "by the office"
    },
    "shortcut": "Recorded with “Delivered (date/time)”",
    "accessorialAction": {
      "added": "added",
      "updated": "changed",
      "removed": "removed",
      "adopted": "itemized from Price"
    }
  },
  "charts": {
    "revenueByCarrier": "Revenue by Carrier",
    "barLabel": "{{carrier}}: {{amount}}",
    "topBrokers": "Top Brokers (by Revenue)",
    "thisMonthDelivered": "Delivered this month",
    "viewReport": "View report",
    "others": "Others",
    "loading": "Loading…",
    "error": "This card could not be loaded.",
    "retry": "Try again",
    "emptyMonth": "No delivered loads this month yet.",
    "loadsCount_one": "{{formatted}} load",
    "loadsCount_other": "{{formatted}} loads"
  },
  "tasks": {
    "title": "Upcoming Tasks",
    "sources": {
      "loadRejected": "{{load}} was declined: {{reason}}. Dispatch it again.",
      "loadRejectedNoReason": "{{load}} was declined. Dispatch it again.",
      "loadRejectedGeneric": "A load was declined. Dispatch it again.",
      "driverAccountDeleted": "{{driver}} deleted their app account. {{load}} is still assigned to them: reassign it.",
      "driverAccountDeletedNoDriver": "The driver of {{load}} deleted their app account. Reassign it.",
      "driverAccountDeletedGeneric": "A driver deleted their app account. Reassign their load.",
      "invoiceOverdue_one": "Invoice {{invoice}} is {{count}} day overdue. Collect it.",
      "invoiceOverdue_other": "Invoice {{invoice}} is {{count}} days overdue. Collect it.",
      "invoiceOverdueGeneric": "An overdue invoice needs collection.",
      "documentExpiry": "A document is about to expire.",
      "documentExpiring": "{{kind}} of {{owner}} expires {{date}}. Get the new one.",
      "documentExpired": "{{kind}} of {{owner}} expired {{date}}. Get the new one.",
      "invoiceNotEmailed": "Invoice {{invoice}} was not emailed: the carrier has no email. Add one, then use Email again.",
      "invoiceEmailFailed": "The email of invoice {{invoice}} failed. Check the address and use Email again.",
      "invoiceDeliveryGeneric": "An invoice could not be emailed.",
      "brokerInvoiceEmailFailed": "The email of invoice {{invoice}} to the broker failed ({{load}}). Check the address and send it again.",
      "brokerInvoiceEmailFailedNoLoad": "The email of invoice {{invoice}} to the broker failed. Check the address and send it again.",
      "brokerInvoiceDeliveryGeneric": "An invoice to a broker could not be emailed.",
      "maintenanceMilesLeft": "{{label}} on truck {{truck}}: {{miles}} mi left. Book the service.",
      "maintenanceMilesOverdue": "{{label}} on truck {{truck}} is overdue. Book the service.",
      "maintenanceDueOn": "{{label}} on truck {{truck}} is due {{date}}. Book the service.",
      "maintenanceWasDue": "{{label}} on truck {{truck}} was due {{date}}. Book the service.",
      "maintenanceDueGeneric": "A truck has a service coming up.",
      "maintenanceOverdueGeneric": "A truck has an overdue service.",
      "receivableOverdue_one": "Load {{load}}: {{broker}} owes {{amount}}, {{count}} day past due ({{date}}). Follow up.",
      "receivableOverdue_other": "Load {{load}}: {{broker}} owes {{amount}}, {{count}} days past due ({{date}}). Follow up.",
      "receivableOverdueSince": "Load {{load}}: {{broker}} owes {{amount}}, past due since {{date}}. Follow up.",
      "receivableOverdueGeneric": "A broker payment is overdue.",
      "unknownBroker": "The broker",
      "podMissing": "{{load}} was delivered {{hours}} h ago and has no POD yet. Ask the driver for it.",
      "podMissingGeneric": "A delivered load has no POD yet.",
      "loadCanceled": "{{load}} was canceled: {{reason}}.",
      "loadCanceledNoReason": "{{load}} was canceled.",
      "loadCanceledGeneric": "A load was canceled.",
      "podMissingOn": "{{load}} delivered {{date}} and has no POD yet. Ask the driver for it.",
      "podMissingLoad": "{{load}} was delivered and has no POD yet."
    },
    "priority": {
      "low": "Low",
      "normal": "Normal",
      "high": "High"
    },
    "empty": "No open tasks.",
    "loading": "Loading tasks…",
    "error": "The tasks could not be loaded.",
    "dueAt": "Due {{date}}",
    "openLoad": "Open {{load}}",
    "new": "New task",
    "viewAll": "View all",
    "completedOn": "Done {{date}}",
    "view": {
      "label": "Show",
      "mine": "My tasks",
      "all": "All tasks"
    },
    "statusFilter": {
      "label": "Status",
      "open": "Open",
      "completed": "Done",
      "all": "All"
    },
    "sourceFilter": {
      "label": "Source",
      "any": "Any source"
    },
    "sourceNames": {
      "manual": "Typed by the office",
      "document_expiry": "Expiring document",
      "load_rejected": "Declined load",
      "invoice_overdue": "Overdue invoice",
      "driver_account_deleted": "Deleted driver account",
      "invoice_delivery": "Invoice email",
      "broker_invoice_delivery": "Broker invoice email",
      "maintenance_due": "Truck maintenance",
      "receivable_overdue": "Broker payment overdue",
      "pod_missing": "Missing POD",
      "load_canceled": "Load canceled"
    },
    "dueFilter": {
      "label": "Due",
      "any": "Any time",
      "overdue": "Overdue",
      "today": "Due today",
      "week": "Due this week",
      "none": "No due date"
    },
    "due": {
      "overdue": "Overdue since {{date}}",
      "none": "No due date"
    },
    "list": {
      "empty": "No tasks here.",
      "emptyFiltered": "No task matches these filters.",
      "clearFilters": "Clear filters",
      "capped": "Showing the newest {{count}} tasks. Narrow the filters to see older ones.",
      "sorted": "Sorted by due date, then priority",
      "count_one": "{{count}} task",
      "count_other": "{{count}} tasks"
    },
    "assignee": {
      "none": "Unassigned",
      "former": "Former member",
      "meNamed": "{{name}} (me)"
    },
    "links": {
      "load": "Load {{load}}",
      "driver": "Driver {{name}}",
      "receivable": "Broker payment {{load}}"
    },
    "actions": {
      "complete": "Mark done",
      "completeNamed": "Mark done: {{title}}",
      "reopenNamed": "Reopen: {{title}}",
      "snooze": "Snooze",
      "snoozeNamed": "Snooze to tomorrow: {{title}}",
      "edit": "Edit",
      "editNamed": "Edit: {{title}}",
      "completed": "Task done",
      "reopened": "Task reopened",
      "snoozed": "Snoozed to {{date}}"
    },
    "form": {
      "createTitle": "New task",
      "editTitle": "Edit task",
      "createHint": "Say what needs doing, by when, and who owns it.",
      "editHint": "Change what needs doing, by when, or who owns it.",
      "title": "Title",
      "detail": "Notes",
      "dueDate": "Due date",
      "dueTime": "Time",
      "zoneHelp": "In {{city}} time, the agency's clock.",
      "priority": "Priority",
      "assignee": "Assign to",
      "links": "Related to",
      "carrier": "Carrier",
      "load": "Load",
      "driver": "Driver",
      "noCarrier": "No carrier",
      "noLoad": "No load",
      "noDriver": "No driver",
      "systemNote": "Coreway raised this task; its title follows what raised it. You can change the due date, the priority and who owns it.",
      "created": "Task created",
      "saved": "Task saved",
      "optional": "optional"
    },
    "errors": {
      "notFound": "That task no longer exists, or it is not one you can see.",
      "canceled": "That task was canceled.",
      "titleRequired": "Give the task a title.",
      "titleTooLong": "Keep the title under 200 characters.",
      "detailTooLong": "Keep the notes under 2,000 characters.",
      "assignee": "Pick someone who is an active member of this agency.",
      "outOfScope": "That load, carrier or driver is outside the ones you work with.",
      "carrierMismatch": "That load belongs to another carrier.",
      "systemTitle": "The title of a task Coreway raised cannot be changed."
    },
    "columns": {
      "task": "Task",
      "priority": "Priority",
      "assignee": "Assignee"
    }
  },
  "expiring": {
    "title": "Expiring Documents",
    "viewAll": "View all",
    "empty": "Nothing is expiring or expired right now.",
    "error": "The documents could not be loaded."
  },
  "config": {
    "title": "The portal is not configured",
    "hint": "Copy web/config.example.js to web/config.js and fill it in, then reload."
  },
  "pages": {
    "dashboard": {
      "title": "Dashboard",
      "blurb": "The five KPI tiles, revenue by carrier, and the loads that need attention today."
    },
    "documentation": {
      "title": "Documentation",
      "blurb": "Every document in one place: carrier packets, driver licences and medical cards, truck registrations and insurance, each with its expiry date."
    },
    "brokers": {
      "title": "Brokers",
      "blurb": "The broker directory: name, MC and DOT numbers, contacts, and the loads booked with each one."
    },
    "brokersCreditCheck": {
      "title": "Credit Check",
      "blurb": "Broker credit and days-to-pay, so a load is not booked with someone who will not pay for it."
    },
    "brokersRateConfirmations": {
      "title": "Rate Confirmations",
      "blurb": "The rate confirmation of every load, and the loads still missing one."
    },
    "brokersBolsPods": {
      "title": "BOLs / PODs",
      "blurb": "Delivered loads waiting for their paperwork: check the POD and BOL, then confirm the POD received."
    },
    "brokersPayments": {
      "title": "Broker Payments",
      "blurb": "What brokers and factoring companies owe your carriers, load by load: invoiced, received, short paid, disputed."
    },
    "brokersReceipts": {
      "title": "Receipts",
      "blurb": "What the carrier bills back to the broker: lumper, fuel, toll and scale receipts, detention and TONU proof."
    },
    "carriers": {
      "title": "Carriers",
      "blurb": "Owner-operators with their own MC and carrier companies, with their trucks and drivers underneath."
    },
    "carriersPackages": {
      "title": "Carrier Packages",
      "blurb": "What each carrier's onboarding package is missing, one place to upload it, a printable cover sheet and the whole package in one download."
    },
    "carriersInvoices": {
      "title": "Carrier Invoices",
      "blurb": "What the carrier owes the agency, and the driver settlement behind it."
    },
    "carriersTrucks": {
      "title": "Trucks",
      "blurb": "The fleet: unit number, VIN, plate, registration and insurance."
    },
    "carriersDrivers": {
      "title": "Drivers",
      "blurb": "The drivers of each carrier, their documents, and the app account they sign in with."
    },
    "reports": {
      "title": "Reports",
      "blurb": "Delivered loads by carrier, driver, truck, dispatcher and broker: revenue, loaded and deadhead miles, rate per mile, dispatch fees and invoices."
    },
    "dispatchers": {
      "title": "Dispatchers",
      "blurb": "The agency's own members, what each one is allowed to see, and how much each one moved."
    },
    "dispatchersAssignedDrivers": {
      "title": "Assigned Drivers",
      "blurb": "Which drivers belong to which dispatcher."
    },
    "dispatchersDispatch": {
      "title": "Dispatch",
      "blurb": "The dispatch board: open loads, available trucks, and the assignment that connects them."
    },
    "loads": {
      "title": "Loads",
      "blurb": "Every load from booked to paid, with rate, loaded and total miles, expenses and the status timeline."
    },
    "tasks": {
      "title": "Tasks",
      "blurb": "What has to happen next, and who owes it."
    },
    "chat": {
      "title": "Chat",
      "blurb": "The conversation between dispatcher and driver, alongside the load it is about."
    },
    "support": {
      "title": "Support",
      "blurb": "How to reach a person, and what to send so we can help."
    },
    "notFound": {
      "title": "Page not found",
      "blurb": "That address does not belong to the portal.",
      "back": "Back to the dashboard",
      "search": "Search"
    },
    "brokersSetups": {
      "title": "Broker Setups",
      "blurb": "Which carrier is set up with which broker: status, setup date and the last time someone checked."
    },
    "settings": {
      "title": "Agency settings",
      "blurb": "Who works in the office, what each role may do, the agency's rules, and your own profile."
    },
    "loadNew": {
      "title": "New load",
      "blurb": "Type the load from its rate confirmation: carrier, broker, stops, rate and miles."
    },
    "loadPage": {
      "title": "Load",
      "blurb": "One load from the rate confirmation to the POD: its stops, documents, money and every event."
    },
    "carriersOwnerStatements": {
      "title": "Owner Statements",
      "blurb": "What each carrier pays the owners of the trucks leased onto it, week by week: loads minus the commission, weekly charges, deductions and last week's balance."
    },
    "carriersDriverSettlements": {
      "title": "Driver Settlements",
      "blurb": "What your agency, or a truck owner, pays each company driver week by week: his loads, minus his deductions, plus adjustments."
    },
    "dispatchersPay": {
      "title": "Dispatcher Pay",
      "blurb": "What the agency owes each dispatcher, week by week: commission on the loads they ran, weekly salary, what was paid and what is left."
    },
    "activity": {
      "title": "Activity",
      "blurb": "What the team and the drivers did, newest first. Filter by person, driver, kind or dates."
    },
    "brokersFacilities": {
      "title": "Facilities",
      "blurb": "Shippers and receivers you use again. Pick one when you add a stop to fill its address, contact and hours."
    },
    "announcements": {
      "title": "Announcements",
      "blurb": "Everything the Coreway team sent you: news, maintenance windows, and changes to terms and prices. Read or not, it stays here."
    }
  },
  "footer": {
    "tagline": "Control Every Carrier. Track Every Load. Build a Stronger Tomorrow.",
    "attribution": "Powered by LUXERAN LLC"
  },
  "roles": {
    "admin": "Admin",
    "manager": "Manager",
    "dispatcher": "Dispatcher",
    "accounting": "Accounting"
  },
  "agency": {
    "noAgencyTitle": "No agency on this account",
    "noAgencyBody": "This account is not a member of any agency. Drivers use the Coreway Driver app.",
    "removed": {
      "title": "Your access to {{agency}} was removed",
      "titleMany": "Your access to your agencies was removed",
      "body": "Ask an admin of {{agency}} if you need it back.",
      "bodyMany": "Removed from: {{agencies}}. Ask an admin of the agency if you need it back."
    },
    "loadError": "Could not load your agency. Actions stay hidden until it loads.",
    "retry": "Retry",
    "pendingInvites": {
      "title": "You have an invitation to an agency",
      "body": "Open it to join. Until then this account is not a member of any agency.",
      "line": "You were invited to {{agency}} as {{role}} by {{name}}.",
      "lineNoInviter": "You were invited to {{agency}} as {{role}}.",
      "open": "Open invitation",
      "banner": "Pending invitations"
    },
    "suspended": {
      "title": "Access to {{agency}} is paused",
      "titleMany": "Access to your agencies is paused",
      "body": "Paused since {{date}}. The agency's data is kept.",
      "line": "{{agency}}: paused since {{date}}.",
      "bodyMany": "Each agency's data is kept.",
      "contact": "To restore access, write to <mail>{{email}}</mail>.",
      "contactNoEmail": "To restore access, contact Coreway support.",
      "billingBody": "Paused since {{date}} because a payment is past due. The agency's data is kept.",
      "billingLine": "{{agency}}: paused since {{date}}, a payment is past due.",
      "amountDue": "Amount due: {{amount}}",
      "payNow": "Pay now",
      "payNowFor": "Pay now for {{agency}}",
      "payHint": "Access comes back within a minute of the payment.",
      "askAdmin": "Ask an admin of {{agency}} to pay the open invoice. Access comes back within a minute of the payment.",
      "payContact": "To pay and restore access, write to <mail>{{email}}</mail>.",
      "payContactNoEmail": "To pay and restore access, contact Coreway support."
    },
    "selfCreate": {
      "cta": "Create my agency",
      "intro": "Run your own dispatch agency on Coreway. Create it now and start your 30-day free trial. No card needed.",
      "name": "Agency name",
      "timeZone": "Time zone",
      "timeZoneHelp": "The agency's days, due dates and invoices follow this zone.",
      "zone": "{{city}} time",
      "submit": "Create agency",
      "creating": "Creating…",
      "unavailable": "Creating an agency from here is not available right now. Write to Coreway support and we will set it up for you.",
      "check": "Security check",
      "checkHelp": "Complete the check to create the agency. It keeps automated sign-ups out.",
      "checkLoadError": "The security check did not load. Reload the page and try again.",
      "referralCode": "Promoter code",
      "referralCodeHint": "Optional. If someone referred you to Coreway, enter their code."
    }
  },
  "inviteAccept": {
    "boot": {
      "title": "Checking your invitation…"
    },
    "linkError": {
      "title": "That sign-in link has expired or was already used.",
      "body": "Enter the email address the invitation was sent to and we will send you a new one."
    },
    "linkOtherBrowser": {
      "title": "This sign-in link was asked for in another browser.",
      "body": "Open it in the browser where you asked for it, or enter the email address the invitation was sent to and we will send you a new one here."
    },
    "signedOut": {
      "title": "You were invited to join an agency on Coreway",
      "body": "Enter the email address the invitation was sent to and we will email you a sign-in link. No password needed."
    },
    "havePassword": "I have a password",
    "linkSent": {
      "title": "Check {{email}}",
      "body": "Open the link in this browser: it brings you back here.",
      "otherEmail": "Use a different email"
    },
    "resolving": {
      "title": "Opening your invitation…"
    },
    "card": {
      "title": "Join {{agency}}",
      "role": "Role",
      "invitedBy": "Invited by {{name}}",
      "expiresInDays_one": "Expires in {{count}} day",
      "expiresInDays_other": "Expires in {{count}} days",
      "expiresInHours_one": "Expires in {{count}} hour",
      "expiresInHours_other": "Expires in {{count}} hours",
      "expiresSoon": "Expires within the hour",
      "joiningAs": "Joining as {{email}}",
      "confirmed": "Confirmed. Accept to join {{agency}}.",
      "accept": "Accept and join",
      "accepting": "Joining…",
      "decline": "Decline",
      "notYou": "Not you? Use another email",
      "declineTitle": "Decline the invitation to {{agency}}?",
      "declineBody": "You will not join {{agency}}. To join later, ask whoever invited you to send a new invitation.",
      "declineConfirm": "Decline invitation"
    },
    "roleSummary": {
      "admin": "Runs the whole agency: people, permissions, carriers, loads and money.",
      "manager": "Runs the office day to day: every carrier and load, and assigns carriers to dispatchers.",
      "dispatcher": "Books and runs loads for the carriers assigned to you.",
      "accounting": "Handles invoices, payments and the ledgers."
    },
    "proofSent": {
      "title": "Confirm it's you",
      "body": "To confirm it's you, open the link we just sent to {{email}}. A password alone is not enough to join an agency.",
      "bodyRecent": "A sign-in link went to {{email}} a moment ago: open it to confirm it's you. A password alone is not enough to join an agency.",
      "bodyNotSent": "To confirm it's you, open a sign-in link sent to {{email}}. A password alone is not enough to join an agency.",
      "orProvider": "Or confirm with a Google or Apple account that uses {{email}}."
    },
    "inactive": {
      "title": "Your membership in {{agency}} is inactive",
      "titleUnnamed": "Your membership in this agency is inactive",
      "body": "Ask its admin to reactivate you."
    },
    "joined": {
      "title": "You joined {{agency}} as {{role}}.",
      "already": "You are already a member of {{agency}}.",
      "alreadyUnnamed": "You are already a member of this agency.",
      "passwordTitle": "Set a password for next time (optional)",
      "passwordBody": "You can also sign in with a link sent to your email.",
      "goToBoard": "Go to the board"
    },
    "notFound": {
      "title": "We could not find this invitation",
      "body": "We could not find this invitation for {{email}}. It may have been sent to another address, canceled, or it expired.",
      "hint": "Ask whoever invited you to send it again.",
      "appleRelay": "Apple hid your email. Sign in again and choose Share My Email, or use the address the invite was sent to."
    },
    "declined": {
      "title": "You declined the invitation to {{agency}}."
    },
    "error": {
      "networkTitle": "Could not reach the server",
      "genericTitle": "Something went wrong"
    },
    "useAnotherEmail": "Use another email",
    "signOut": "Sign out"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "close": "Close",
    "retry": "Retry",
    "search": "Search",
    "clear": "Clear",
    "edit": "Edit",
    "moreActions": "More actions",
    "discard": "Discard",
    "discardTitle": "Discard changes?",
    "discardBody": "What you typed in this form is lost.",
    "keepEditing": "Keep editing",
    "confirm": "Confirm",
    "done": "Done",
    "copy": "Copy",
    "copied": "Copied",
    "copyLink": "Copy link",
    "unknownPerson": "Former member",
    "noResults": "No results for this search.",
    "loading": "Loading…",
    "error": "Could not load this list.",
    "readOnly": "Read only",
    "none": "None",
    "all": "All",
    "dismiss": "Dismiss",
    "changeStatus": "Change status",
    "clearSearch": "Clear search"
  },
  "entities": {
    "agency": "agency",
    "carrier": "carrier",
    "owner": "owner",
    "truck": "truck",
    "driver": "driver",
    "broker": "broker",
    "seat": "seat",
    "invoice": "invoice",
    "payment": "payment",
    "receipt": "receipt",
    "load": "load",
    "member": "member",
    "invite": "invitation",
    "stop": "stop",
    "document": "document"
  },
  "fields": {
    "legalName": "Legal name",
    "dba": "DBA",
    "mcNumber": "MC number",
    "dotNumber": "DOT number",
    "ein": "EIN",
    "addressLine1": "Address line 1",
    "addressLine2": "Address line 2",
    "city": "City",
    "state": "State",
    "postalCode": "ZIP code",
    "contactName": "Contact name",
    "contactPhone": "Contact phone",
    "contactEmail": "Contact email",
    "factoringCompany": "Factoring company",
    "paymentTermsDays": "Payment terms (days)",
    "minimumRatePerMile": "Minimum rate per mile ($)",
    "ownerId": "Owner",
    "notes": "Notes",
    "unitNumber": "Unit number",
    "vin": "VIN",
    "year": "Year",
    "make": "Make",
    "model": "Model",
    "plate": "Plate",
    "plateState": "Plate state",
    "vehicleType": "Vehicle type",
    "cargoType": "Cargo type",
    "maxWeight": "Max weight (lb)",
    "lengthFt": "Length (ft)",
    "widthFt": "Width (ft)",
    "heightFt": "Height (ft)",
    "name": "Name",
    "phone": "Phone",
    "email": "Email",
    "licenseNumber": "License number",
    "licenseState": "License state",
    "website": "Website",
    "status": "Status",
    "setupDate": "Setup date",
    "displayName": "Name",
    "locale": "Language",
    "reference": "Reference",
    "invoiceNumber": "Invoice number",
    "invoicedOn": "Invoiced on",
    "dueOn": "Due on",
    "paidOn": "Paid on",
    "factored": "Factored",
    "brokerTermsDays": "Broker payment terms",
    "loadNumber": "Load number",
    "brokerReference": "Broker reference",
    "commodity": "Commodity",
    "weight": "Weight (lb)",
    "loadedMiles": "Loaded miles",
    "deadheadMiles": "Deadhead miles",
    "company": "Company",
    "referenceNumber": "Reference #",
    "linehaul": "Rate",
    "accessorial": "Accessorial",
    "appointmentAt": "Appointment",
    "at": "Time",
    "driver": "Driver",
    "truck": "Truck",
    "billingEmail": "Billing email",
    "documentLocale": "Document language",
    "factoringAddress": "Factoring remit address",
    "factoringPhone": "Factoring phone",
    "factoringEmail": "Factoring email",
    "brokerInvoicePrefix": "Broker invoice prefix",
    "brokerInvoiceNext": "Next broker invoice number",
    "paymentInstructions": "How to pay you",
    "invoiceNote": "Note under the totals",
    "to": "Send to",
    "remitAddress": "Remit-to address",
    "noaOnFile": "Notice of assignment (NOA) on file",
    "noaReceivedOn": "NOA received on",
    "factoringId": "Factoring company",
    "freeTimeMinutes": "Free time (minutes)",
    "detentionHourlyRate": "Detention per hour ($)",
    "kind": "Kind",
    "timeZone": "Time zone",
    "hours": "Hours",
    "feePct": "Fee %"
  },
  "validation": {
    "required": "Required.",
    "tooLong": "At most {{max}} characters.",
    "authority": "1 to 8 digits (an MC or DOT prefix is fine).",
    "ein": "9 digits, for example 12-3456789.",
    "state": "Two-letter state code, for example TX.",
    "postal": "Letters, digits, spaces and dashes only.",
    "email": "Not a valid email address.",
    "phone": "Digits, spaces and + ( ) . - only.",
    "vin": "17 letters and digits, without I, O or Q.",
    "wholeNumber": "A whole number.",
    "number": "A number.",
    "range": "Between {{min}} and {{max}}.",
    "decimals": "At most {{scale}} decimals.",
    "noSpaces": "No spaces.",
    "dateFormat": "A date (YYYY-MM-DD).",
    "dateInFuture": "Cannot be after today.",
    "license": "Letters, digits and dashes only.",
    "amountPositive": "Enter an amount greater than zero.",
    "amountMax": "At most {{max}}.",
    "dateBeforeInvoice": "Cannot be before the invoice date.",
    "dueBeforeInvoice": "Cannot be before the invoice date.",
    "passwordShort": "At least 8 characters.",
    "passwordMismatch": "The two passwords do not match.",
    "fileType": "Use a PDF, JPEG, PNG, HEIC or WebP file.",
    "fileTooLarge": "At most 25 MB.",
    "fileEmpty": "The file is empty.",
    "stateRequired": "Type the state.",
    "timeRequired": "Type both the date and the time, or neither.",
    "timeInFuture": "The time can't be in the future.",
    "prefix": "1 to 10 letters or digits.",
    "windowNeedsTime": "Type the appointment date and time first.",
    "windowEnd": "The window ends before it starts."
  },
  "errors": {
    "network": "Could not reach the server. Check your connection and try again.",
    "sessionExpired": "Your session expired. Sign in again.",
    "notAllowed": "Your role cannot: {{action}}. Ask the agency admin if you need it.",
    "outsideScope": "That carrier is not one of yours.",
    "driverOutsideScope": "This driver also drives for carriers you do not run. End his seat on your carrier instead.",
    "driverOnTruckOutsideScope": "This driver is on a truck of a carrier you do not run. Ask whoever runs that carrier to take him off it first.",
    "adminOnly": "Only the agency admin can change this.",
    "forbidden": "You are not allowed to do that.",
    "notFound": "That {{thing}} no longer exists. Reload the page.",
    "notFoundGeneric": "Something this action needs no longer exists. Reload the page.",
    "noSeat": "That driver does not drive for this truck's carrier. Add him to the carrier on the Drivers screen first.",
    "adminAlways": "The admin role always has every permission.",
    "dateInFuture": "The date cannot be after today.",
    "outdated": "The portal is older than the server. Reload the page.",
    "invalidField": "Check the field: {{field}}.",
    "invalid": "The server refused these values. Check the form.",
    "duplicateCarrierMc": "Another carrier in this agency already has this MC number.",
    "duplicateCarrierDot": "Another carrier in this agency already has this DOT number.",
    "duplicateBrokerMc": "Another broker in this agency already has this MC number.",
    "duplicateBrokerDot": "Another broker in this agency already has this DOT number.",
    "duplicateUnit": "This carrier already has a truck with that unit number.",
    "duplicateVin": "A truck with this VIN already exists.",
    "duplicate": "That value is already in use.",
    "notActive": "That {{thing}} is not active.",
    "badState": "This record changed in the meantime. Reload the page.",
    "constraint": "The server refused these values. Check the form.",
    "driverLinked": "This driver already uses the app. No code needed.",
    "driverDuplicatePhone": "A driver with this phone already exists in this agency.",
    "testFence": "Test records and real records cannot be mixed.",
    "termsChanged": "The Terms were updated while you were reading. Review the new version.",
    "truckCap": "Your plan covers up to {{cap}} active trucks. Contact us for an Enterprise plan to add more.",
    "truckCapNoNumber": "Your plan does not cover more active trucks. Contact us for an Enterprise plan to add more.",
    "retry": "Someone else changed this at the same moment. Try again.",
    "generic": "Something went wrong ({{code}}). Try again.",
    "confirmEmail": "Confirm your email address first: open the sign-in link we sent you.",
    "onlyAdminGrants": "Only an admin can give the admin or manager role.",
    "onlyAdminChanges": "Only an admin can change an admin or a manager.",
    "mailboxProof": "To confirm it's you, open the sign-in link sent to your email.",
    "inviteDailyLimit": "This agency sent its invitation emails for today. Try again tomorrow.",
    "inviteSendLimit": "This invitation was sent 5 times. Revoke it and invite again.",
    "inviteCooldown": "Wait a minute before sending this invitation again.",
    "limitReached": "A limit was reached. Try again later.",
    "inviteNotFound": "We could not find this invitation for your email address, or it expired.",
    "lastAdmin": "The agency needs at least one active admin. Make someone else admin first.",
    "alreadyMember": "This person is already a member of the agency.",
    "inactiveMember": "This person is an inactive member. Reactivate them instead.",
    "inviteNotPending": "This invitation is no longer pending.",
    "alreadyJoined": "You are already a member of this agency.",
    "membershipInactive": "Your membership is inactive. Ask the agency admin to reactivate you.",
    "invoiceDraft": "This invoice is a draft. Send it first.",
    "invoicePaid": "This invoice is already paid.",
    "invoiceCanceled": "This invoice is canceled.",
    "nothingToWriteOff": "Nothing is left to write off on this invoice.",
    "alreadyReversed": "This was already reversed.",
    "invoiceHasPayments": "This invoice has payments. Reverse them before voiding it.",
    "alreadyInvoiced": "This load is already invoiced to the broker.",
    "notPodReceived": "Only a load with its POD received, or a canceled load with a TONU, can be invoiced to the broker.",
    "notInvoiced": "This load is not invoiced to the broker.",
    "receivableClosed": "This receivable is closed. Reopen it first.",
    "receivableOpen": "This receivable is still open.",
    "reverseReceiptsFirst": "Reverse its receipts before unmarking it.",
    "unmarkBeforeCancel": "This load is invoiced to the broker. Unmark it before canceling.",
    "unmarkBeforeEdit": "This load is invoiced to the broker. Unmark it in Broker payments before changing the broker or the load number.",
    "loadNotEditable": "A canceled or paid load can't be edited.",
    "amountOverBalance": "The amount is more than the balance of {{balance}}.",
    "invalidAmount": "Check the amount.",
    "amountBelowReceived": "The amount cannot be below what was already received ({{received}}).",
    "dateBeforeInvoice": "The date cannot be before the invoice date.",
    "dueBeforeInvoice": "The due date cannot be before the invoice date.",
    "reasonRequired": "Write a reason.",
    "reasonTooLong": "The reason is too long (500 characters at most).",
    "factoringRequired": "Name the factoring company of a factored load.",
    "invalidEmail": "Not a valid email address.",
    "onlyDispatcherCarriers": "Only a dispatcher is assigned carriers.",
    "duplicateInvoiceNumber": "This carrier already used invoice number {{number}}.",
    "notAllowedRun": "Your role can't run loads for this carrier.",
    "stopGone": "That stop is no longer on the load. Reload the page.",
    "uploadMissing": "The file did not reach the server. Upload it again.",
    "loadMoved": "Someone else changed this load. It is now {{status}}.",
    "loadFinished": "This load is finished: its itinerary can't change.",
    "stopVisited": "The driver already visited this stop.",
    "stopAlreadyArrived": "The arrival at this stop is already recorded.",
    "stopAlreadyDeparted": "The departure from this stop is already recorded.",
    "stopNotArrived": "Record the arrival before the departure.",
    "lastStopOfKind": "It is the only stop of its kind, and the driver would be left with no itinerary.",
    "feeOnInvoice": "The fee of this load is on a carrier invoice. Remove the line before cancelling.",
    "feeInvoiceSent": "The fee is on a carrier invoice that was already sent: it can't be repriced.",
    "needsStops": "Add a pickup and a delivery before dispatching.",
    "driverNotSeated": "This driver does not hold an active seat on the load's carrier.",
    "truckNotOfCarrier": "This truck does not belong to the load's carrier.",
    "noFeePlan": "Set this carrier's dispatch % and the load's rate before confirming the POD.",
    "useReprice": "The fee is already earned: use Reprice instead.",
    "duplicateLoadNumber": "That load number is already used in this agency.",
    "stampBeforeArrival": "The departure can't be before the arrival.",
    "fileTooLarge": "The file is too large: at most 25 MB.",
    "fileType": "This type of file is not accepted: use PDF, JPEG, PNG, HEIC or WebP.",
    "storageUnreachable": "The file server did not answer. Nothing was uploaded.",
    "tonuState": "A TONU applies only to a load whose truck was ordered and not yet loaded.",
    "tonuOnLiveLoad": "A TONU is recorded when the load is canceled.",
    "tonuNotZero": "A TONU recorded at the cancel cannot be repriced to zero. Type the amount the broker pays.",
    "extrasBelowParts": "The extras total is below the itemized TONU, detention and lumper. Edit the itemized amounts instead.",
    "unassignRolling": "The driver already reached a stop on this load, so it cannot be taken back. Cancel the load instead.",
    "unassignNeedsReason": "The driver already accepted this load. Write a reason to take it back.",
    "onStop": "Stop {{n}}: {{reason}}",
    "windowNeedsStart": "Type the appointment time before the end of the window.",
    "windowBeforeStart": "The window ends before it starts.",
    "invoicePackageIncomplete": "The packet is missing {{docs}}.",
    "invoicePackageIncompleteGeneric": "The packet is missing documents.",
    "invoicePackageBlocked": "Your agency requires a complete packet. Missing: {{docs}}.",
    "invoicePackageBlockedGeneric": "Your agency requires a complete packet.",
    "arrivalAfterDeparture": "The arrival can't be after the departure.",
    "noStampToCorrect": "That time was never recorded, so there is nothing to correct. Record it instead.",
    "facilityGone": "That facility was retired or is not in this agency. Pick another one or type the address.",
    "routeMilesThrottled": "Route miles were just requested. Try again in a minute.",
    "accessorialsLocked": "The fee is already earned on this load: its accessorials can no longer change.",
    "useAccessorialsList": "This amount comes from the accessorials list. Change it there.",
    "onlyLumperDriverPaid": "Only a lumper can be paid by the driver.",
    "reimbursementFollowsLoad": "A reimbursement follows the lumper on its load. Change it on the load."
  },
  "fleetStatus": {
    "active": "Active",
    "suspended": "Suspended",
    "out_of_service": "Out of service",
    "inactive": "Inactive",
    "ended": "Ended",
    "current": "Current",
    "consequence": {
      "carrier": {
        "active": "Works normally: new loads, dispatch, all of it.",
        "suspended": "This agency does not allow new loads for suspended carriers. Loads in progress finish. Nothing is deleted.",
        "suspendedLoadsAllowed": "This agency allows creating loads for a suspended carrier, but they cannot be dispatched to a truck until it is active again. Nothing is deleted.",
        "inactive": "No new loads. Work in progress finishes. Nothing is deleted."
      },
      "owner": {
        "active": "Can be linked to carriers and trucks.",
        "inactive": "Kept on record; cannot be linked to new carriers or trucks."
      },
      "truck": {
        "active": "Available for loads.",
        "out_of_service": "In the shop: no new loads. Its drivers stay on it.",
        "inactive": "Sold or retired. No new loads.",
        "inactiveEnds_one": "Also ends {{count}} driver assignment on unit {{unit}}.",
        "inactiveEnds_other": "Also ends {{count}} driver assignments on unit {{unit}}."
      },
      "driver": {
        "active": "Can be assigned to trucks and loads.",
        "inactive": "No new loads. A load he is running still finishes.",
        "inactiveTruck": "Takes {{name}} off unit {{unit}}.",
        "inactiveInvite": "Cancels his pending app code."
      }
    }
  },
  "setupStatus": {
    "not_started": "Not started",
    "in_progress": "In progress",
    "submitted": "Submitted",
    "approved": "Approved",
    "rejected": "Rejected"
  },
  "carriers": {
    "new": "New carrier",
    "createTitle": "New carrier",
    "editTitle": "Edit carrier",
    "saved": "Carrier saved",
    "created": "Carrier created",
    "addTruck": "Add a truck",
    "addDriver": "Add a driver",
    "empty": "No carriers yet. Add the first one to start dispatching.",
    "emptyReadOnly": "No carriers yet.",
    "emptyStatus": "No carriers with this status.",
    "tabs": "Carriers and owners",
    "tabCarriers": "Carriers",
    "tabOwners": "Owners",
    "search": "Search by name, DBA, MC or DOT",
    "statusFilter": "Carrier status",
    "brokerSetups": "Broker setups",
    "viewTrucks": "Trucks of {{name}}",
    "viewDrivers": "Drivers of {{name}}",
    "noOwner": "No owner",
    "col": {
      "carrier": "Carrier",
      "mc": "MC",
      "dot": "DOT",
      "owner": "Owner",
      "trucks": "Trucks",
      "drivers": "Drivers",
      "dispatchPct": "Dispatch %",
      "status": "Status",
      "actions": "Actions",
      "authority": "Authority",
      "package": "Package"
    },
    "sections": {
      "identity": "Identity",
      "address": "Address",
      "contact": "Contact",
      "business": "Business terms",
      "owner": "Owner",
      "notes": "Notes",
      "billing": "Billing and documents",
      "factoring": "Factoring",
      "numbering": "Broker invoice numbering"
    },
    "localeDefault": "Agency default",
    "billingEmailHelp": "The weekly invoice goes here. Empty: the contact email.",
    "nextBrokerInvoice": "Next broker invoice: {{number}}",
    "nextBrokerInvoiceEstimate": "Next broker invoice, if not used yet: {{number}}",
    "numberingHelp": "Invoices to brokers for this carrier's loads follow its own series. A number already used is skipped.",
    "factoringHelp": "Brokers pay this company on factored loads; its remit-to prints on the broker invoice. Manage the list in Settings > Factoring.",
    "noFactoring": "None: the carrier is paid directly",
    "factoringInactive": "{{name}} (inactive)",
    "notOnFile": "Not on file",
    "noMc": "No MC",
    "packageShort": "{{done}} of {{total}}",
    "packageOf": "Package of {{name}}: {{done}} of {{total}} required on file",
    "foot": "{{carriers}} · {{trucks}} · {{drivers}}",
    "footCarriers_one": "{{count}} carrier",
    "footCarriers_other": "{{count}} carriers",
    "footTrucks_one": "{{count}} truck",
    "footTrucks_other": "{{count}} trucks",
    "footDrivers_one": "{{count}} driver",
    "footDrivers_other": "{{count}} drivers",
    "sectionsNav": "Sections of the form",
    "requiredNote": "Only Legal name is required"
  },
  "owners": {
    "new": "New owner",
    "createTitle": "New owner",
    "editTitle": "Edit owner",
    "saved": "Owner saved",
    "created": "Owner created",
    "empty": "No owners yet.",
    "emptyStatus": "No owners with this status.",
    "search": "Search by name, DBA or EIN",
    "statusFilter": "Owner status",
    "col": {
      "legalName": "Legal name",
      "dba": "DBA",
      "ein": "EIN",
      "contact": "Contact",
      "carriers": "Carriers",
      "status": "Status",
      "actions": "Actions"
    },
    "sections": {
      "identity": "Identity",
      "address": "Address",
      "contact": "Contact",
      "notes": "Notes"
    },
    "emptyExplain": "An owner sits above one or more carriers, or leases trucks to them. Add one to group his carriers and build his weekly owner statements."
  },
  "trucks": {
    "new": "New truck",
    "createTitle": "New truck",
    "editTitle": "Edit truck",
    "saved": "Truck saved",
    "created": "Truck created",
    "empty": "No trucks yet.",
    "emptyStatus": "No trucks with this status.",
    "unassigned": "Unassigned",
    "search": "Search by unit, VIN, plate, make or model",
    "statusFilter": "Truck status",
    "carrierFilter": "Carrier",
    "allCarriers": "All carriers",
    "carrier": "Carrier",
    "carrierPick": "Choose a carrier",
    "noOwner": "No owner",
    "unit": "Unit {{unit}}",
    "dimensions": "{{length}} x {{width}} x {{height}} ft",
    "manageDrivers": "Drivers on unit {{unit}}",
    "manageDriversName": "{{shown}}, drivers on unit {{unit}}",
    "assignTitle": "Drivers on unit {{unit}}",
    "assignCurrent": "On this truck",
    "assignNobody": "Nobody drives this truck yet.",
    "assignPick": "Put a driver on it",
    "assignPickPlaceholder": "Choose a driver",
    "assign": "Assign",
    "unassign": "Take {{name}} off",
    "movesFrom": "Moves {{name}} from unit {{unit}}.",
    "noCandidates": "No active driver holds a seat on {{carrier}}. Add him to the carrier on the Drivers screen.",
    "assigned": "{{name}} is on unit {{unit}}",
    "unassignedToast": "{{name}} is off unit {{unit}}",
    "col": {
      "unit": "Unit",
      "carrier": "Carrier",
      "vehicle": "Vehicle",
      "equipment": "Equipment",
      "plate": "Plate",
      "drivers": "Drivers",
      "status": "Status",
      "actions": "Actions",
      "owner": "Owner"
    },
    "sections": {
      "identity": "Truck",
      "registration": "Registration",
      "equipment": "Equipment",
      "owner": "Owner"
    },
    "cargoTypes": {
      "dry_van": "Dry van",
      "reefer": "Reefer",
      "flatbed": "Flatbed",
      "step_deck": "Step deck",
      "power_only": "Power only",
      "hotshot": "Hotshot",
      "box_truck": "Box truck",
      "tanker": "Tanker",
      "car_hauler": "Car hauler",
      "other": "Other"
    },
    "ownerUnavailable": "Owner not available",
    "leasedBadge": "Leased {{pct}}%",
    "noPlate": "No plate",
    "noVehicle": "Vehicle not set",
    "noEquipment": "No equipment set",
    "assignDriver": "+ Assign driver",
    "foot": "{{trucks}} · {{withDriver}}",
    "footTrucks_one": "{{count}} truck",
    "footTrucks_other": "{{count}} trucks",
    "footWithDriver_one": "{{count}} with a driver",
    "footWithDriver_other": "{{count}} with a driver",
    "searchPlaceholder": "Unit, VIN, plate or model",
    "requiredNote": "Carrier and Unit number are required"
  },
  "drivers": {
    "new": "New driver",
    "createTitle": "New driver",
    "editTitle": "Edit driver",
    "saved": "Driver saved",
    "added": "{{name}} was added to {{carrier}}.",
    "empty": "No drivers yet.",
    "emptyStatus": "No drivers with this status.",
    "search": "Search by name, phone, email or license",
    "statusFilter": "Driver status",
    "carrierFilter": "Carrier",
    "allCarriers": "All carriers",
    "carrier": "Carrier",
    "carrierPick": "Choose a carrier",
    "showEnded": "Show ended seats",
    "noTruck": "No truck",
    "appCode": "App code",
    "sendCodeNow": "Send app code now",
    "app": {
      "linked": "Linked",
      "pending": "Code pending, expires {{when}}",
      "expired": "Code expired",
      "none": "Not invited"
    },
    "col": {
      "name": "Name",
      "carriers": "Carriers",
      "phone": "Phone",
      "truck": "Truck",
      "app": "App",
      "status": "Status",
      "actions": "Actions"
    },
    "sections": {
      "identity": "Driver",
      "license": "License",
      "notes": "Notes",
      "seats": "Carriers he drives for"
    },
    "seats": {
      "since": "Since {{date}}",
      "endedOn": "Ended {{date}}",
      "none": "He holds no seat on any carrier.",
      "end": "End seat",
      "endLabel": "End seat on {{carrier}}",
      "endTitle": "End the seat on {{carrier}}?",
      "endBody": "Ends his assignment on {{carrier}}'s trucks. His loads in progress finish.",
      "ended": "Seat ended",
      "add": "Add to carrier",
      "addPick": "Carrier",
      "addPlaceholder": "Choose a carrier",
      "added": "Seat added",
      "nothingToAdd": "He already holds a seat on every active carrier."
    },
    "createDescription": "Add a driver to one of your carriers. You can send him the app code right after.",
    "duplicate": {
      "title": "This phone is already in your agency",
      "inScope": "{{name}} is already in your drivers ({{carriers}}).",
      "inScopeNoSeats": "{{name}} is already in your drivers.",
      "addPrompt": "Add him to {{carrier}} instead of creating a second record?",
      "pickCarrier": "Choose a carrier above to add him to it.",
      "alreadySeated": "{{name}} already drives for {{carrier}}.",
      "inactive": "{{name}} is already in your drivers but inactive. Open him to reactivate.",
      "outOfScope": "A driver with this phone already exists on carriers you don't manage. Ask an admin or manager to add him to this carrier.",
      "addToCarrier": "Add to carrier",
      "openDriver": "Open driver",
      "createAnyway": "Create a separate record anyway",
      "forced": "Saving creates a separate record with this phone.",
      "samePhone": "Same phone as {{names}}"
    },
    "searchShort": "Search name, phone, email or license",
    "noEmail": "No email",
    "noCarrier": "No carrier",
    "truckLink": "Unit {{unit}}, the truck of {{name}}",
    "sendCode": "Send app code",
    "resendCode": "Resend code",
    "sendCodeTo": "Send app code to {{name}}",
    "resendCodeTo": "Resend the app code to {{name}}",
    "phoneHelp": "WhatsApp opens on this number with the app code.",
    "adoption": {
      "count": "{{linked}} of {{count}} drivers use the app.",
      "consequence_one": "The other one cannot accept loads or send PODs from his phone.",
      "consequence_other": "The other {{count}} cannot accept loads or send PODs from their phone."
    },
    "foot": "{{drivers}} · {{linked}}",
    "footDrivers_one": "{{count}} driver",
    "footDrivers_other": "{{count}} drivers",
    "footLinked_one": "{{count}} linked to the app",
    "footLinked_other": "{{count}} linked to the app"
  },
  "invite": {
    "share": "{{name}}, your Coreway Driver code is {{code}}. Install the Coreway Driver app, sign in, and enter the code. It expires {{expires}} ({{zone}} time).",
    "revoked": "Code canceled",
    "title": "App code for {{name}}",
    "minting": "Creating the code…",
    "confirmBody": "{{name}} has a pending code until {{when}}. A new one replaces it.",
    "newCode": "Create a new code",
    "revoke": "Revoke code",
    "codeLabel": "App code",
    "copyCode": "Copy code",
    "validUntil": "Valid until {{when}} ({{zone}} time)",
    "onceWarning": "This code is shown only once. Copy it or send it now.",
    "messageLang": "Message language",
    "langEs": "Español",
    "langEn": "English",
    "langHint": "Drivers mostly read Spanish; switch if {{name}} prefers English.",
    "preview": "Message",
    "copyMessage": "Copy message",
    "openWhatsapp": "Open WhatsApp",
    "failed": "Could not create the code.",
    "description": "Send this code to {{name}}: he enters it in the Coreway Driver app."
  },
  "brokers": {
    "new": "New broker",
    "createTitle": "New broker",
    "editTitle": "Edit broker",
    "saved": "Broker saved",
    "empty": "No brokers yet.",
    "emptyHint": "Add the brokers your dispatchers book with, so every carrier's setup with them can be tracked.",
    "sheetHelp": "The broker list is shared by the whole agency.",
    "search": "Search brokers",
    "searchPlaceholder": "Name, MC or DOT",
    "count_one": "{{count}} broker",
    "count_other": "{{count}} brokers",
    "setupsCount": "{{approved}} approved of {{total}}",
    "noSetups": "None yet",
    "sections": {
      "identity": "Broker",
      "contact": "Contact",
      "address": "Address",
      "detention": "Detention"
    },
    "columns": {
      "broker": "Broker",
      "mc": "MC",
      "dot": "DOT",
      "location": "Location",
      "phone": "Phone",
      "email": "Email",
      "setups": "Setups",
      "actions": "Actions",
      "mcDot": "MC · DOT",
      "contact": "Contact"
    },
    "billingEmailHelp": "The broker's accounts payable (AP) address. Invoices go here, else to the email above.",
    "payStats": {
      "title": "Payment history",
      "help": "From the broker ledger of the carriers you can see.",
      "none": "No invoice to this broker yet.",
      "invoiced": "Invoices",
      "open": "Open",
      "openBalance": "Open balance",
      "closed": "Closed",
      "avgDays": "Average days to pay",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "shortPays": "Short pays",
      "lastPaid": "Last payment",
      "error": "The payment history could not be read."
    },
    "detentionHelp": "Leave blank to use the agency's free time. The hourly rate fills the detention notice on a load; nothing is billed by itself.",
    "dotLine": "DOT {{dot}}"
  },
  "brokerSetups": {
    "saved": "Setup saved",
    "approvedTodayHint": "Today's date will be recorded.",
    "verifiedToday": "I verified this setup today",
    "never": "Never",
    "sheetTitle": "{{carrier}} with {{broker}}",
    "sheetHelp": "Where this carrier stands with this broker, and when someone last checked.",
    "lastVerified": "Last verified: {{when}}",
    "view": {
      "label": "View",
      "carrier": "By carrier",
      "broker": "By broker"
    },
    "carrierSelect": "Carrier",
    "brokerSelect": "Broker",
    "searchBrokers": "Search brokers",
    "searchCarriers": "Search carriers",
    "searchPlaceholder": "Name or MC",
    "statusFilter": "Setup status",
    "noCarriers": "No carriers yet. Add one on the Carriers screen first.",
    "noneInStatus": "No setups with this status.",
    "columns": {
      "broker": "Broker",
      "carrier": "Carrier",
      "mc": "MC",
      "status": "Setup status",
      "setupDate": "Setup date",
      "lastVerified": "Last verified",
      "notes": "Notes",
      "actions": "Actions"
    },
    "goToBrokers": "Go to Brokers",
    "noBrokersTitle": "No brokers yet",
    "noBrokersHint": "Add one on the Brokers screen first; each carrier then gets a Not started row per broker.",
    "noBrokersOption": "No brokers yet",
    "noCarriersOption": "No carriers yet"
  },
  "settings": {
    "tabs": {
      "label": "Settings sections",
      "team": "Team",
      "permissions": "Permissions and rules",
      "profile": "My profile",
      "fees": "Fees",
      "pay": "Driver pay",
      "company": "Company",
      "billing": "Billing",
      "factoring": "Factoring",
      "groups": {
        "account": "Your account",
        "office": "Office",
        "money": "Money",
        "coreway": "Coreway"
      },
      "onThisPage": "On this page"
    },
    "agencyRules": {
      "title": "Agency rules",
      "intro": "How the agency treats suspended carriers, the brokers that owe it money, and the free time at a stop before detention counts.",
      "readOnlyNote": "Only the agency admin changes these rules.",
      "save": "Save agency rules",
      "saved": "Agency rules saved"
    },
    "brokerTerms": {
      "label": "Broker payment terms",
      "suffix": "days",
      "help": "When a load is invoiced to a broker, its due date is the invoice date plus the days to pay of the broker's latest credit check, or this number when there is none. Example: 30 days: invoiced Sep 1, due Oct 1."
    },
    "disputeHoldsFee": {
      "label": "Broker disputes hold the agency fee",
      "help": "On (default): while a broker disputes a load, the agency's fee on it stays off the carrier's weekly invoice until the dispute is cleared. Off: the fee bills as usual. A fee already on an invoice is never pulled back.",
      "saved": "Setting saved"
    },
    "permissions": {
      "title": "Permissions",
      "intro": "Choose what each office role may do. Example: turn off Add and edit trucks for Dispatcher, and only managers and admins will add trucks.",
      "adminHelp": "Admins can always do everything, so the agency can never lock itself out.",
      "readOnlyNote": "Only the agency admin changes these. You can see what each role may do.",
      "scopeNote": "A dispatcher still acts only on the carriers assigned to that dispatcher, whatever this table says.",
      "custom": "Custom",
      "reset": "Reset to default",
      "defaultOn": "Default: on",
      "defaultOff": "Default: off",
      "cellLabel": "{{action}} for {{role}}",
      "resetCell": "Reset to default: {{cell}}",
      "actionHeader": "Action",
      "adminLocked": "Always allowed",
      "loadError": "Could not load the permissions.",
      "savesOnChange": "Switches save on change.",
      "find": "Find an action",
      "summary": "{{count}} actions. Groups show how many each role has on; “—”: admin and accounting only.",
      "expandAll": "Expand all",
      "collapseAll": "Collapse all",
      "adminAlwaysOn": "Admin: always on",
      "noMatch": "No action matches this search.",
      "notForRole": "Admin and accounting only",
      "groupCount": "{{on}} of {{total}} on for {{role}}"
    },
    "suspended": {
      "saved": "Setting saved",
      "readOnlyNote": "Only the agency admin changes this setting.",
      "title": "Loads for suspended carriers",
      "label": "Suspended carriers can still get new loads",
      "help": "Off (default): nobody can create a load for a suspended carrier. On: loads can be created for it, for example to keep booking while its insurance is being renewed, but they cannot be dispatched to a truck until the carrier is active again. Inactive carriers never get new loads."
    },
    "dispatchConflict": {
      "title": "Busy driver or truck at dispatch",
      "intro": "Busy means the driver or the truck is on another load, from Dispatched through In Transit, whose appointment times overlap this load's. A load without appointment times counts as overlapping.",
      "policyLabel": "When the driver or truck is busy",
      "policy": {
        "off": "Off",
        "warn": "Warn (default)",
        "block": "Block"
      },
      "policyHelp": {
        "off": "Not checked.",
        "warn": "The dialog shows the other load and asks you to confirm. Recorded on the load.",
        "block": "Dispatch is refused until the other load is finished or reassigned."
      },
      "saved": "Setting saved"
    },
    "dispatchDocs": {
      "title": "Documents and broker setup at dispatch",
      "intro": "The driver's and the truck's documents marked required under Requirements, and the carrier's setup with the load's broker. An expired document is the issue; a missing one (never uploaded here) or one about to expire is only a notice. The broker setup is checked only when the load has a broker.",
      "policyLabel": "When a required document is expired or the broker setup is not in order",
      "policy": {
        "off": "Off",
        "warn": "Warn (default)",
        "block": "Block"
      },
      "policyHelp": {
        "off": "Not checked.",
        "warn": "The dialog lists the documents and the setup and asks you to confirm when one is expired or not approved. Recorded on the load.",
        "block": "Dispatch is refused until expired documents are renewed and the carrier is approved with the broker. Missing documents never block."
      },
      "saved": "Setting saved"
    },
    "receivableOverdue": {
      "label": "Tasks for overdue broker payments",
      "help": "On (default): when a broker invoice passes its due date unpaid, Coreway opens a task for accounting, managers and the carrier's dispatchers; it turns high priority after 15 days and closes by itself when the payment is recorded, the invoice is unmarked or disputed, or the due date moves. The broker is never emailed. Off: no new tasks, and the open ones close within the hour. Example: a $1,250 invoice due Oct 6 opens its task on Oct 7.",
      "saved": "Setting saved",
      "loadError": "Could not load this setting."
    },
    "freeTime": {
      "label": "Free time at a stop",
      "suffix": "minutes",
      "help": "How long a truck can wait at a shipper or receiver before detention counts. A broker can have its own (Brokers › Detention). The load shows a notice when a stop goes past it; nothing is billed by itself. Example: 120 minutes, arrived 8:00, left 11:00: 60 minutes over.",
      "loadError": "Could not load this setting.",
      "range": "Enter whole minutes from 0 to 1440."
    },
    "messageTemplates": {
      "title": "Quick messages",
      "intro": "Short messages the office inserts in a driver chat with one click. Up to 20. New agencies start with six.",
      "legend": "Messages",
      "label": "Name",
      "body": "Message",
      "add": "Add a message",
      "remove": "Remove {{label}}",
      "unnamed": "this message",
      "save": "Save quick messages",
      "saved": "Quick messages saved",
      "readOnly": "Only the agency admin can change these.",
      "empty": "No quick messages yet.",
      "readFailed": "Couldn't read the quick messages. Reload the page.",
      "errors": {
        "labelRequired": "Give it a name.",
        "labelTooLong": "Up to 40 characters.",
        "bodyRequired": "Write the message.",
        "bodyTooLong": "Up to 4000 characters.",
        "tooMany": "Up to 20 messages."
      }
    },
    "saveBar": {
      "example": "Example",
      "noChanges": "No changes",
      "changed_one": "{{count}} field changed",
      "changed_other": "{{count}} fields changed",
      "discard": "Discard",
      "savesOnChange": "Each change saves as you make it."
    }
  },
  "permissionGroups": {
    "owner": "Owners",
    "carrier": "Carriers",
    "truck": "Trucks",
    "maintenance": "Truck maintenance",
    "driver": "Drivers",
    "broker": "Brokers",
    "credit": "Broker credit",
    "invoice": "Carrier invoices",
    "receivable": "Broker receivables",
    "team": "Team",
    "owner_fee": "Owner fees (leased trucks)",
    "billing": "Coreway plan and billing",
    "dispatcher_pay": "Dispatcher pay",
    "activity": "Activity",
    "driver_pay": "Driver pay"
  },
  "permissions": {
    "owner": {
      "manage": {
        "label": "Manage owners",
        "help": "Add and edit carrier owners, and link an owner to a carrier or a leased truck. Example: record Luis Mierez as the owner of both of his MCs."
      }
    },
    "carrier": {
      "create": {
        "label": "Add carriers",
        "help": "Create a new carrier in the agency's book. Example: the agency signs Panthers Express and enters its MC and DOT."
      },
      "edit": {
        "label": "Edit carrier details",
        "help": "Change a carrier's name, MC, DOT, address, contact, factoring company and notes. Example: the carrier switches factoring company."
      },
      "edit_terms": {
        "label": "Edit carrier terms",
        "help": "Change payment terms (days) and the minimum rate per mile. Example: the carrier now takes loads from $2.10 a mile."
      },
      "set_status": {
        "label": "Suspend or deactivate carriers",
        "help": "Mark a carrier active, suspended or inactive. Example: suspend a carrier whose insurance lapsed."
      }
    },
    "truck": {
      "manage": {
        "label": "Add and edit trucks",
        "help": "Add trucks and edit unit number, VIN, plate and equipment. Example: the carrier buys unit 112, a 53 ft reefer."
      },
      "set_status": {
        "label": "Take trucks out of service",
        "help": "Mark a truck active, out of service or inactive; inactive also takes its drivers off it. Example: unit 104 goes to the shop for a week."
      },
      "assign_driver": {
        "label": "Assign drivers to trucks",
        "help": "Put a driver on a truck or take him off. A driver runs one truck at a time: assigning him elsewhere moves him. Example: Pedro moves from unit 98 to unit 104."
      }
    },
    "maintenance": {
      "manage": {
        "label": "Track truck maintenance",
        "help": "Turn maintenance tracking on for a truck, set its service plans (every N miles or days) and record services with their cost. Example: oil change on unit 104 every 25,000 mi."
      }
    },
    "odometer": {
      "record": {
        "label": "Record odometer readings",
        "help": "Enter a truck's odometer, or void a wrong reading with a reason. Miles plans count from these readings. Example: unit 104 reads 412,350 mi at the fuel stop."
      }
    },
    "driver": {
      "edit": {
        "label": "Add and edit drivers",
        "help": "Add drivers, edit their contact and license, and add or end their seat on a carrier. Example: Pedro starts driving for a second carrier too."
      },
      "set_status": {
        "label": "Deactivate drivers",
        "help": "Mark a driver active or inactive; inactive takes him off his truck and cancels his pending app code, and a load he is running still finishes. Example: a driver quits."
      }
    },
    "broker": {
      "manage": {
        "label": "Manage the broker list",
        "help": "Add brokers and edit their details; the list is shared by the whole agency. Example: a dispatcher books with a new broker found on DAT."
      }
    },
    "broker_credit": {
      "record": {
        "label": "Record broker credit checks",
        "help": "Save what DAT, Truckstop, the factoring company or FMCSA says about a broker, with a decision: approved, caution or declined. Example: TQL shows A 94 and 28 days to pay on DAT today."
      }
    },
    "broker_incident": {
      "manage": {
        "label": "Record broker incidents",
        "help": "Record, resolve and reopen what went wrong with a broker: late pay, non payment, a dispute, suspected double brokering. Example: the broker is 20 days late on load CW-1042."
      }
    },
    "broker_setup": {
      "manage": {
        "label": "Update broker setups",
        "help": "Record whether a carrier is set up with a broker: status, setup date, last check. Example: TQL approved the Panthers setup today."
      }
    },
    "invoice": {
      "record_payment": {
        "label": "Record carrier invoice payments",
        "help": "Record a payment the carrier made on the agency's weekly invoice, in full or in part; a paid invoice stops its reminders. The invoice list itself stays visible to admin and accounting only. Example: Panthers Express pays $450 of this week's invoice by Zelle."
      },
      "reverse_payment": {
        "label": "Reverse carrier invoice payments",
        "help": "Undo a recorded payment, with a reason, when it bounced or was entered by mistake; the invoice opens again and its reminders resume. Example: a check from Panthers Express bounces."
      },
      "write_off": {
        "label": "Write off carrier invoices",
        "help": "Close what is left of an invoice as uncollectable, with a reason; the invoice counts as paid. Example: a carrier that shut down still owes $120 the agency will never collect."
      }
    },
    "receivable": {
      "mark_invoiced": {
        "label": "Mark loads invoiced to the broker",
        "help": "Record that the carrier, or its factoring company, billed the broker for a load whose POD was received: invoice number, amount and due date. Example: load CW-1040 goes to TQL as invoice A1-001, due in 30 days."
      },
      "record_payment": {
        "label": "Record broker payments",
        "help": "Record what the broker or the factoring company paid for a load; paid in full, the load becomes paid, and a short pay can be closed with a reason. Example: the factoring company funds $2,150 for load CW-1040."
      },
      "dispute": {
        "label": "Dispute broker receivables",
        "help": "Flag that the broker disputes a load's invoice, with a reason; when the agency setting is on, the agency's fee on that load is held until the dispute is cleared. Example: the broker refuses a $150 detention charge."
      },
      "correct": {
        "label": "Correct broker receivables",
        "help": "Fix a receivable's details, reverse a receipt, reopen a closed receivable or unmark a load invoiced by mistake. Example: a check was applied to the wrong load and has to be reversed."
      }
    },
    "report": {
      "receivables": {
        "label": "See broker receivables in reports",
        "help": "Show what brokers owe in Reports > Explore: invoice number and dates, amount, received, balance, collection status, aging and factoring, and the Pending collection view. Without it those columns are left out. Example: a dispatcher sees loads and gross, but not what TQL still owes."
      }
    },
    "lockedField": "Your role cannot change this: {{action}}.",
    "deniedHint": "Your role cannot do this. Ask the agency admin.",
    "member": {
      "invite": {
        "label": "Invite people to the office",
        "help": "Invite a person by email, and resend or cancel pending invitations. Without admin rights you invite dispatchers and accounting only. Example: invite Ana, the new dispatcher, with the carriers Ana will run."
      },
      "manage": {
        "label": "Manage office members",
        "help": "Change a member's role, and deactivate or reactivate a member. Without admin rights: dispatchers and accounting only, never yourself. The agency always keeps one active admin. Example: Pedro moves from dispatch to accounting."
      }
    },
    "dispatcher": {
      "assign_carriers": {
        "label": "Assign carriers to dispatchers",
        "help": "Choose which carriers each dispatcher runs: each one sees and works only those. Example: give Ana the Panthers Express carrier."
      }
    },
    "fee_settings": {
      "edit": {
        "label": "Edit fee settings",
        "help": "Change what the agency's percentage applies to, the lease defaults and the owner statement rules. Example: set the agency's percentage on detention to 5%."
      }
    },
    "lease": {
      "manage": {
        "label": "Manage leases",
        "help": "Lease a truck onto a carrier, change its commission and weekly charges, end the lease. Example: T-12 of Pedro leased onto Panthers at 15 % with $250 insurance a week."
      }
    },
    "owner_statement": {
      "manage": {
        "label": "Prepare owner statements",
        "help": "Generate a statement, add a deduction or a credit, waive a weekly charge, move a load to next week. Example: add the fuel card to Pedro's statement."
      },
      "finalize": {
        "label": "Finalize owner statements",
        "help": "Close a draft statement so it can be paid; a final statement no longer changes. Example: finalize OS-1001 on Friday after checking it."
      },
      "cancel": {
        "label": "Cancel owner statements",
        "help": "Cancel a draft or a final statement with a reason; its loads go back to be stated again. Example: cancel OS-1001 because the fuel card was typed twice."
      }
    },
    "billing": {
      "manage": {
        "label": "Manage the Coreway plan and billing",
        "help": "See the plan and the invoices Coreway sends the agency, add a card, subscribe and pay an open invoice. Example: let Accounting pay the monthly invoice."
      }
    },
    "dispatcher_pay": {
      "manage": {
        "label": "Set dispatcher pay",
        "help": "Choose each dispatcher's pay plan (and on an invitation), the pay bases the agency uses and the default plan. Also needs the admin or accounting role. Example: move Ana from 25% of the fee to 30% starting Monday."
      },
      "record_payment": {
        "label": "Record dispatcher payments",
        "help": "Mark a dispatcher's week paid, in full or in part. Also needs the admin or accounting role. Example: record the $450 Zelle sent to Ana on Friday."
      },
      "reverse_payment": {
        "label": "Reverse dispatcher payments",
        "help": "Undo a payment recorded by mistake, with a reason; the payment stays listed as reversed. Example: the Zelle was recorded twice."
      }
    },
    "activity": {
      "read": {
        "label": "See team activity",
        "help": "The Activity tab of the bell and the Activity page: what the team and the drivers do on the loads, carriers, trucks and drivers this role can see. A dispatcher sees only the carriers assigned to that dispatcher. Example: Ana arrived at the pickup of CW-1046."
      },
      "office": {
        "label": "See office activity",
        "help": "Also the office actions that belong to no carrier: invitations and roles, brokers and factoring, agency settings. These are agency wide, so a dispatcher with this permission sees them all. Example: Maria invited a new dispatcher."
      },
      "money": {
        "label": "See money activity",
        "help": "Also the money events: carrier invoices, owner statements, leases, pay plans and fee settings, plus the money documents. The feed never shows an amount, only that something happened. Example: an invoice was raised for Panthers Express."
      }
    },
    "driver_settlement": {
      "manage": {
        "label": "Prepare driver settlements",
        "help": "Build the weekly settlement of a driver your agency or an owner pays, add or remove lines and enter hours. Also needs the admin or accounting role. Example: add a $50 fuel advance adjustment to Pedro's week."
      },
      "finalize": {
        "label": "Finalize driver settlements",
        "help": "Close a reviewed settlement so its numbers stop changing. Also needs the admin or accounting role. Example: finalize Pedro's week on Friday after checking his loads."
      },
      "cancel": {
        "label": "Cancel driver settlements",
        "help": "Cancel a settlement with a reason; its loads and deductions go back to the next one. Admin only by default. Example: the week was built for the wrong payer."
      },
      "record_payment": {
        "label": "Record driver payments",
        "help": "Mark a final settlement paid (date, method, reference) or undo that mark. Also needs the admin or accounting role. Example: record the Zelle sent to Pedro on Friday."
      }
    },
    "driver_deduction": {
      "manage": {
        "label": "Manage driver deductions",
        "help": "Create, change and retire a driver's recurring deductions and advances, and the agency's deduction catalog. Also needs the admin or accounting role. Example: $150 a week of insurance for Pedro."
      }
    }
  },
  "credit": {
    "chip": {
      "ok": "Approved",
      "caution": "Caution",
      "declined": "Declined",
      "expired": "Expired",
      "no_check": "Not checked",
      "watch": "Watch",
      "overridden": "Overridden",
      "blocked": "Blocked",
      "authority_inactive": "No authority"
    },
    "decision": {
      "approved": "Approved",
      "caution": "Caution",
      "declined": "Declined"
    },
    "decisionHelp": {
      "approved": "Good to book.",
      "caution": "Book with care: short terms, a weak score.",
      "declined": "Do not book. Blocks new loads."
    },
    "source": {
      "dat": "DAT",
      "truckstop": "Truckstop",
      "factoring": "Factoring company",
      "fmcsa": "FMCSA",
      "other": "Other",
      "manual": "Manual"
    },
    "flag": {
      "declined": "Declined on the last credit check.",
      "caution": "Caution on the last credit check.",
      "expired": "The last credit check expired on {{date}}.",
      "no_check": "No credit check on record for this broker.",
      "overdue_invoices_one": "{{count}} invoice to this broker is overdue, by {{days}} days.",
      "overdue_invoices_other": "{{count}} invoices to this broker are overdue, the oldest by {{days}} days.",
      "open_incidents_one": "{{count}} open incident with this broker.",
      "open_incidents_other": "{{count}} open incidents with this broker.",
      "authority_inactive": "FMCSA says this broker’s authority is not active (last FMCSA check)."
    },
    "blocked": {
      "declined": "A declined broker cannot take a new load until a new check approves it or an agency admin overrides.",
      "policy": "Your agency blocks new loads for a broker with any of these warnings. Record a new check, or ask an agency admin to override."
    },
    "override": {
      "action": "Override",
      "title": "Let {{broker}} through",
      "body": "For the next 24 hours new loads can be booked with this broker despite the credit block. Your name and the reason are kept in the activity log. A new credit check ends the override.",
      "confirm": "Override for 24 hours",
      "saved": "{{broker}} can be booked for the next 24 hours",
      "active": "Overridden by an admin until {{until}}: {{reason}}"
    },
    "hint": {
      "loading": "Checking the broker's credit…",
      "unavailable": "The broker's credit could not be read. You can still save.",
      "ok": "Credit approved ({{source}}), valid until {{date}}.",
      "title": "Check {{broker}}'s credit before booking",
      "recordNow": "Record check now",
      "askAdmin": "Only an agency admin can override.",
      "open": "Open credit check",
      "blockedSubmit": "This broker's credit blocks the load. Record a new check or ask an agency admin to override."
    },
    "check": {
      "action": "Record check",
      "title": "Credit check: {{broker}}",
      "intro": "What the load board, the factoring company or FMCSA says today. Coreway keeps every check with its date.",
      "decision": "Your decision",
      "source": "Source",
      "sourcePlaceholder": "Where did you check?",
      "checkedOn": "Checked on",
      "tooOld": "At most one year ago.",
      "score": "Score or rating",
      "scoreHelp": "As the source shows it, for example A 94 or 88.",
      "daysToPay": "Days to pay",
      "daysToPayHelp": "The source's average. Also sets the due date of the next invoice to this broker.",
      "creditLimit": "Credit limit",
      "authority": "Authority status",
      "authorityHelp": "From FMCSA, for example Active.",
      "submit": "Save check",
      "saved": "Credit check saved for {{broker}}"
    },
    "incident": {
      "add": "Record incident",
      "title": "Incident with {{broker}}",
      "intro": "Something that went wrong with this broker. Open incidents warn everyone who books it.",
      "kind": "What happened",
      "kindPlaceholder": "Choose one",
      "occurredOn": "When",
      "carrier": "Carrier",
      "carrierHelp": "Optional. Only your carriers.",
      "noCarrier": "No carrier",
      "otherCarrier": "Another carrier",
      "load": "Load",
      "loadHelp": "Optional. A TONU or a dispute names its load; its carrier comes with it.",
      "noLoad": "No load",
      "amount": "Amount",
      "submit": "Save incident",
      "saved": "Incident saved for {{broker}}",
      "open": "Open",
      "resolve": "Resolve",
      "resolveTitle": "Resolve: {{kind}}",
      "resolveBody": "Write how it was sorted out. The incident stays on record.",
      "resolved": "Incident resolved",
      "resolvedOn": "Resolved on {{date}}",
      "reopen": "Reopen",
      "reopened": "Incident reopened",
      "noDetail": "No details",
      "ledgerOwned": "From Broker Payments: reopen the load's receivable to change it."
    },
    "incidentKind": {
      "slow_pay": "Late pay",
      "non_payment": "Non payment",
      "dispute": "Dispute",
      "double_brokering": "Double brokering suspected",
      "claim": "Claim",
      "tonu": "TONU",
      "unpaid_detention": "Unpaid detention",
      "other": "Other",
      "short_pay": "Short pay"
    },
    "sheet": {
      "external": "External credit check",
      "coreway": "Coreway history",
      "corewayNote": "Loads, invoices and overdue counts cover the whole agency. The money lines cover your carriers.",
      "checked": "Checked",
      "checkedBy": "{{when}} by {{who}}",
      "validUntil": "Valid until",
      "expiredOn": "Expired {{date}}",
      "noCheck": "No credit check recorded yet.",
      "loads": "Loads",
      "lastLoad": "last {{date}}",
      "invoices": "Invoices paid",
      "invoicesPaid": "{{paid}} of {{total}}",
      "avgDays": "Real days to pay",
      "days_one": "{{count}} day",
      "days_other": "{{count}} days",
      "overdue": "Overdue invoices",
      "overdueValue_one": "{{count}}, {{days}} days late",
      "overdueValue_other": "{{count}}, the oldest {{days}} days late",
      "none": "None",
      "myOpen": "Open balance (your carriers)",
      "myShort": "Short pays (your carriers)",
      "setups": "Carrier setups and factoring approval",
      "openSetups": "Open broker setups",
      "incidents_one": "Incidents ({{count}} open)",
      "incidents_other": "Incidents ({{count}} open)",
      "noIncidents": "No incidents recorded.",
      "history": "Check history",
      "detailError": "The history could not be read."
    },
    "list": {
      "search": "Search brokers",
      "searchPlaceholder": "Name, MC or DOT",
      "filter": "Credit",
      "all": "All",
      "attention": "Needs attention",
      "blocked": "Blocked",
      "never": "Never checked",
      "checked": "Checked {{date}} on {{source}}",
      "validUntil": "valid until {{date}}",
      "expired": "expired {{date}}",
      "checkDays_one": "{{count}} day to pay",
      "checkDays_other": "{{count}} days to pay",
      "paidIn_one": "paid your invoices in {{days}} days on average ({{count}} paid)",
      "paidIn_other": "paid your invoices in {{days}} days on average ({{count}} paid)",
      "overdue_one": "{{count}} overdue",
      "overdue_other": "{{count}} overdue",
      "incidents_one": "{{count}} open incident",
      "incidents_other": "{{count}} open incidents",
      "error": "The brokers' credit could not be read.",
      "policyWarn": "A credit check is valid for <b>{{days}} days</b>. A broker with a warning can still be booked; a declined one cannot.",
      "policyBlock": "A credit check is valid for <b>{{days}} days</b>. Your agency blocks new loads for any broker with a warning.",
      "emptyTitle": "No brokers yet",
      "emptyHint": "Every broker of the agency appears here with its last check, days to pay and open incidents.",
      "goToBrokers": "Go to Brokers"
    },
    "settings": {
      "title": "Broker credit",
      "expiryLabel": "A credit check is valid for",
      "days": "days",
      "expiryHelp": "After this many days the broker shows Expired and the New load form asks for a new check. Example: 30 days: checked Sep 1, expired on Oct 1.",
      "policyLabel": "When a broker has a warning",
      "policy": {
        "warn": "Warn (default)",
        "block": "Block"
      },
      "policyHelp": {
        "warn": "The New load form shows the warning and lets the load be saved. Only a declined broker is blocked.",
        "block": "No check, an expired or caution check, overdue invoices or an open incident block the load until someone records a new check or an admin overrides."
      },
      "saved": "Setting saved"
    },
    "errors": {
      "blocked": "This broker's credit blocks the load. Record a new credit check, or ask an agency admin to override.",
      "alreadyResolved": "This incident is already resolved.",
      "notResolved": "This incident is not resolved.",
      "ledgerShortPay": "This short pay comes from Broker Payments. Reopen the load's receivable to change it.",
      "checkTooOld": "A credit check can be at most one year old.",
      "resolvedBefore": "An incident cannot be resolved before it happened.",
      "loadNotOnBroker": "That load is not on this broker.",
      "incidentNotFound": "This incident no longer exists or is not one of yours."
    },
    "noNumbers": "No MC or DOT on file",
    "unknownMember": "a former member",
    "fmcsa": {
      "title": "FMCSA authority",
      "help": "Looks the broker up in FMCSA’s public records. One lookup per click; within 10 minutes you get the last result again.",
      "action": "Check FMCSA",
      "checking": "Checking FMCSA",
      "notConfigured": "Not configured",
      "notConfiguredHint": "The FMCSA lookup needs its access key, which is not set up yet. Ask the Coreway operator.",
      "authority": {
        "active": "Authority active",
        "inactive": "Authority not active",
        "not_found": "Not found in FMCSA"
      },
      "notFoundHelp": "FMCSA has no record for {{number}}. Check that the number on the broker is right, then look it up on the FMCSA website.",
      "recent": "Checked {{when}}, less than 10 minutes ago: this is that result.",
      "checkedBy": "Checked {{when}} by {{who}}",
      "legalName": "Legal name",
      "dba": "DBA",
      "allowed": "Allowed to operate",
      "yes": "Yes",
      "no": "No",
      "brokerAuthority": "Broker authority",
      "commonAuthority": "Common authority",
      "contractAuthority": "Contract authority",
      "code": {
        "A": "Active",
        "I": "Inactive",
        "N": "None",
        "unknown": "{{value}}"
      },
      "bipd": "Liability (BIPD) on file",
      "cargo": "Cargo insurance on file",
      "bond": "Bond on file",
      "insuranceValue": "${{value}}K",
      "none": "None",
      "safetyRating": "Safety rating",
      "rating": {
        "S": "Satisfactory",
        "C": "Conditional",
        "U": "Unsatisfactory",
        "none": "Not rated"
      },
      "oosDate": "Out of service since",
      "address": "Address",
      "matches_one": "{{count}} record matched this number; the first is shown.",
      "matches_other": "{{count}} records matched this number; the first is shown.",
      "error": {
        "in_flight": "A lookup of this broker is already running.",
        "no_identifier": "Add the broker’s MC or DOT number first.",
        "unavailable": "FMCSA did not answer. Try again in a moment.",
        "key_rejected": "FMCSA refused Coreway’s access key. Tell the Coreway operator.",
        "forbidden": "Your role cannot record credit checks.",
        "not_found": "This broker is not in your agency.",
        "not_configured": "The FMCSA lookup is not configured.",
        "failed": "The FMCSA lookup failed. Try again."
      },
      "inactiveReason": {
        "not_allowed": "FMCSA does not allow this entity to operate.",
        "no_broker_authority": "No active broker authority. A carrier brokering loads without broker authority is the double-brokering pattern: do not book until it is cleared."
      }
    }
  },
  "receivableStatus": {
    "open": "Open",
    "partially_paid": "Partially paid",
    "overdue": "Overdue",
    "disputed": "Disputed",
    "paid": "Paid",
    "short_paid": "Short paid"
  },
  "paymentMethod": {
    "ach": "ACH",
    "zelle": "Zelle",
    "check": "Check",
    "wire": "Wire",
    "cash": "Cash",
    "card": "Card",
    "other": "Other"
  },
  "payer": {
    "broker": "Broker",
    "factoring": "Factoring company"
  },
  "receivables": {
    "tableLabel": "Broker payments",
    "tabsLabel": "Receivables",
    "tabs": {
      "ready": "To invoice",
      "open": "Open",
      "overdue": "Overdue",
      "disputed": "Disputed",
      "closed": "Closed",
      "all": "All"
    },
    "summary": {
      "label": "Summary",
      "openBalance": "Open balance",
      "onLoads_one": "on {{count}} load",
      "onLoads_other": "on {{count}} loads",
      "overdue": "Overdue",
      "disputed": "Disputed"
    },
    "filters": {
      "carrier": "Carrier",
      "allCarriers": "All carriers",
      "broker": "Broker",
      "allBrokers": "All brokers",
      "search": "Search broker payments",
      "searchPlaceholder": "Load, invoice, broker or carrier"
    },
    "columns": {
      "load": "Load",
      "carrier": "Carrier",
      "broker": "Broker",
      "invoiceNumber": "Invoice #",
      "invoiced": "Invoiced",
      "due": "Due",
      "amount": "Amount",
      "received": "Received",
      "balance": "Balance",
      "status": "Status",
      "dispatcher": "Dispatcher",
      "rate": "Rate",
      "note": "Note",
      "actions": "Actions",
      "age": "Age"
    },
    "noBroker": "No broker",
    "factored": "Factored",
    "overdueBy_one": "{{count}} day overdue",
    "overdueBy_other": "{{count}} days overdue",
    "dueIn_one": "Due in {{count}} day",
    "dueIn_other": "Due in {{count}} days",
    "dueToday": "Due today",
    "paidIn_one": "Paid in {{count}} day",
    "paidIn_other": "Paid in {{count}} days",
    "empty": "Nothing in this list.",
    "invoicedLine": "Invoiced {{date}}",
    "receivedLine": "Received {{amount}}",
    "emptyWithReady": "Nothing here yet. A load joins this list when you mark it invoiced in To invoice.",
    "emptyReady": "Nothing to invoice. A load shows up here when its POD is received.",
    "adoption": "Marked invoiced before receivables existed: record its invoice",
    "tonuTag": "TONU",
    "tonuNote": "Canceled with a TONU: bill the broker for it. The load stays canceled.",
    "actions": {
      "recordReceipt": "Record receipt",
      "recordReceiptFor": "Record receipt for {{load}}",
      "markInvoiced": "Mark invoiced",
      "markInvoicedFor": "Mark {{load}} invoiced",
      "closeShort": "Close short",
      "closeZero": "Close as paid",
      "dispute": "Dispute",
      "clearDispute": "Clear dispute",
      "edit": "Edit invoice",
      "unmark": "Unmark invoiced",
      "reopen": "Reopen",
      "details": "Details",
      "more": "More"
    },
    "blocked": {
      "unmark": "Reverse its receipts first."
    },
    "sheet": {
      "title": "Load {{load}}",
      "money": "Money",
      "amount": "Amount",
      "received": "Received",
      "balance": "Balance",
      "invoicedOn": "Invoiced on",
      "dueOn": "Due on",
      "daysOutstanding": "Days outstanding",
      "daysToPay": "Days to pay",
      "carrier": "Carrier",
      "broker": "Broker",
      "dispatcher": "Dispatcher",
      "invoiceNumber": "Invoice #",
      "notes": "Notes",
      "noNotes": "No notes.",
      "receipts": "Receipts",
      "noReceipts": "No receipts recorded yet.",
      "receiptsError": "The receipts could not be loaded.",
      "factoringFee": "Factoring fee {{pct}} % ≈ {{fee}} · net ≈ {{net}}",
      "factoringFeeHelp": "Estimate with the factor's fee when invoiced. The broker still owes the full amount.",
      "factoringFeeMissing": "No fee % on file for {{factor}}"
    },
    "banners": {
      "disputed": "Disputed since {{date}}: {{reason}}",
      "feeHeld": "The agency fee on this load is held off the weekly invoice until the dispute is cleared.",
      "shortPaid": "Closed short by {{amount}}: {{reason}}. The agency fee did not change.",
      "zero": "Everything is received. Close it to mark the load paid."
    },
    "history": {
      "date": "Date",
      "payer": "Payer",
      "reference": "Reference",
      "amount": "Amount",
      "recorded": "Recorded",
      "state": "State",
      "payerFactoring": "Factoring: {{company}}",
      "reversed": "Reversed",
      "reversedBy": "by {{name}}, {{date}}: {{reason}}",
      "recordedBy": "{{name}}, {{date}}",
      "reverseLabel": "Reverse the {{amount}} receipt"
    },
    "reason": {
      "label": "Reason",
      "counter": "{{count}} of {{max}} characters"
    },
    "mark": {
      "title": "Mark {{load}} invoiced",
      "invoiceNumber": "Invoice number",
      "invoiceNumberHelp": "Unique per carrier",
      "invoicedOn": "Invoiced on",
      "amount": "Amount",
      "amountHelp": "The rate: {{amount}}",
      "dueOn": "Due on",
      "dueHelp": "Empty: the broker's days to pay from its latest credit check, or this agency's default of {{days}} days (Settings, Agency rules)",
      "factored": "Factored",
      "factoredHelp": "The factoring company collects from the broker; receipts default to it",
      "factoringCompany": "Factoring company",
      "notes": "Notes",
      "submit": "Mark invoiced",
      "done": "Marked invoiced: {{load}}",
      "package": {
        "warnTitle": "The packet is incomplete",
        "warnBody": "Missing: {{docs}}. Brokers usually hold an invoice without them.",
        "anyway": "Mark invoiced anyway",
        "blockTitle": "Upload the missing documents first",
        "blockBody": "Missing: {{docs}}. Your agency requires a complete packet (Settings, Company)."
      }
    },
    "receipt": {
      "title": "Record receipt for {{load}}",
      "shortTitle": "Close {{load}} short",
      "zeroTitle": "Close {{load}} as paid",
      "amount": "Amount",
      "balanceHelp": "Balance {{amount}}",
      "nothingMore": "Enter 0 when nothing more will arrive.",
      "paidOn": "Paid on",
      "paidOnZeroHelp": "The day the last money arrived",
      "payer": "Paid by",
      "reference": "Reference",
      "closeShort": "Close as short paid",
      "shortReason": "Reason",
      "shortBy": "Short by {{amount}}. The agency fee does not change: it follows the rate confirmation.",
      "incident": "A short-pay incident is recorded for {{broker}}.",
      "zeroBody": "Everything is received. The receivable closes as paid and the load is marked paid.",
      "submit": "Record receipt",
      "submitShort": "Close short",
      "submitZero": "Close as paid",
      "done": "Receipt of {{amount}} recorded",
      "doneShort": "{{load}} closed short",
      "doneZero": "{{load}} closed as paid"
    },
    "dispute": {
      "title": "Dispute {{load}}",
      "holds": "While disputed, the agency fee on this load stays off the carrier's weekly invoice (unless it is already on one). Change this in Settings, Agency rules.",
      "noHold": "The agency fee still bills as usual (Settings, Agency rules).",
      "confirm": "Dispute",
      "done": "{{load}} disputed",
      "incidentOffer": "Also record a broker incident",
      "incidentOfferHelp": "Adds a dispute to {{broker}}'s credit record with this load, the open balance and the reason.",
      "incidentNotNow": "Not now"
    },
    "clear": {
      "title": "Clear the dispute on {{load}}?",
      "body": "The held fee, if any, is released.",
      "confirm": "Clear dispute",
      "done": "Dispute cleared on {{load}}"
    },
    "edit": {
      "title": "Edit the invoice of {{load}}",
      "belowReceived": "Cannot be below what was already received ({{amount}})",
      "done": "Invoice of {{load}} updated"
    },
    "unmark": {
      "title": "Unmark {{load}} invoiced?",
      "body": "The receivable is removed and the load goes back to POD received.",
      "confirm": "Unmark",
      "done": "{{load}} unmarked"
    },
    "reopen": {
      "title": "Reopen {{load}}?",
      "body": "The load goes back to invoiced; a short-pay incident is marked resolved.",
      "confirm": "Reopen",
      "done": "{{load}} reopened"
    },
    "reverse": {
      "title": "Reverse this receipt?",
      "body": "The {{amount}} receipt is kept in the history as reversed and the balance grows back by it. A closed receivable reopens.",
      "confirm": "Reverse",
      "done": "Receipt reversed"
    },
    "invoice": {
      "numberOptional": "Invoice number (optional)",
      "numberAuto": "Automatic: {{number}}",
      "numberHelp": "Leave it empty to use the carrier's next number, or type the number the factoring company gave you."
    },
    "docs": {
      "title": "Documents",
      "invoicePdf": "Invoice PDF",
      "packetPdf": "Packet PDF (invoice, {{docs}})",
      "packetPdfNeutral": "Packet PDF (invoice with the load documents)",
      "packetPdfNone": "Packet PDF (invoice only, no load documents yet)",
      "kinds": {
        "rate_confirmation": "RC",
        "bol": "BOL",
        "pod": "POD",
        "lumper_receipt": "lumper receipt",
        "fuel_receipt": "fuel receipt",
        "toll_receipt": "toll receipt",
        "scale_receipt": "scale ticket",
        "detention": "detention",
        "tonu": "TONU"
      },
      "emailBroker": "Email to broker",
      "factoredWarning": "This load is factored: the factoring company usually submits the invoice. Send it anyway?",
      "attach": {
        "label": "Attach",
        "packet": "Invoice with {{docs}}",
        "packetNeutral": "Invoice with the load documents",
        "packetNone": "Invoice and load documents (none yet)",
        "invoice": "Invoice only"
      },
      "history": "History",
      "noHistory": "Nothing prepared or emailed yet.",
      "version": "{{file}}, version {{version}}, {{pages}} pages, {{date}}",
      "emailed": "Emailed {{date}} to {{email}}",
      "emailing": "Emailing to {{email}}",
      "emailFailed": "Email to {{email}} failed: {{error}}",
      "latestWarnings": "In the latest version:",
      "email": {
        "title": "Email invoice {{number}} to {{broker}}",
        "body": "The broker's accounts payable gets the PDF; replies go to your billing email.",
        "confirm": "Send",
        "done": "Emailing invoice {{number}}"
      },
      "packageWarning": "The packet is missing {{docs}}. Sending is your confirmation.",
      "packageBlocked": "The packet is missing {{docs}}; your agency requires it complete. You can send the invoice alone."
    },
    "errors": {
      "numbersExhausted": "This carrier used every number of its series. Set a new prefix on the carrier."
    },
    "age_one": "Since {{date}}, {{count}} day",
    "age_other": "Since {{date}}, {{count}} days",
    "ageToday": "Since today",
    "footTotal_one": "{{count}} receivable · {{amount}} balance",
    "footTotal_other": "{{count}} receivables · {{amount}} balance",
    "footReady_one": "{{count}} load to invoice",
    "footReady_other": "{{count}} loads to invoice"
  },
  "inviteState": {
    "pending": "Pending",
    "expired": "Expired",
    "accepted": "Accepted",
    "declined": "Declined",
    "revoked": "Revoked",
    "superseded": "Replaced"
  },
  "members": {
    "deletedUser": "Deleted user",
    "deletedNoReactivate": "This account was deleted by its owner and cannot be reactivated. To bring the person back, invite them again."
  },
  "memberStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "profile": {
    "title": "Your details",
    "intro": "Your team sees this name on the loads, payments and invitations you record.",
    "name": "Name",
    "phone": "Phone",
    "language": "Language",
    "languageHelp": "Emails Coreway sends you, and the portal's language.",
    "email": "Email",
    "emailHelp": "The address you sign in with. It cannot be changed here.",
    "languages": {
      "en": "English",
      "es": "Español"
    },
    "save": "Save profile",
    "saving": "Saving…",
    "saved": "Profile saved",
    "noChanges": "Nothing to save: no field changed.",
    "loadError": "Could not load your profile.",
    "password": {
      "title": "Set a new password",
      "description": "Useful if you joined with a sign-in link. You can still sign in with a link sent to your email.",
      "new": "New password",
      "repeat": "Type it again",
      "help": "At least 8 characters.",
      "submit": "Set password",
      "saving": "Saving…",
      "saved": "Password saved. Use it next time you sign in."
    },
    "banner": {
      "text": "Add your name so your team sees who did what.",
      "action": "Add my name",
      "dismiss": "Dismiss"
    },
    "methods": {
      "title": "Sign-in methods",
      "intro": "The ways you can sign in to this account.",
      "provider": {
        "email": "Email",
        "google": "Google",
        "apple": "Apple",
        "phone": "Phone"
      },
      "link": "Link {{provider}}",
      "unlink": "Unlink",
      "unlinkTitle": "Unlink {{provider}}?",
      "unlinkBody": "You won't be able to sign in with {{provider}} ({{email}}) anymore.",
      "needed": "Needed to sign in",
      "linked": "{{provider}} is linked. You can sign in with it next time.",
      "unlinked": "{{provider}} was unlinked.",
      "loadError": "Couldn't load your sign-in methods.",
      "notLinked": "Not linked"
    },
    "emailNotices": {
      "title": "Email notices",
      "intro": "Coreway emails you when a load you dispatch is declined by its driver or canceled. Admins and managers get them for every load. Each email links to the load.",
      "loadRejected": "A driver declines a load",
      "loadCanceled": "A load is canceled",
      "saved": "Saved",
      "failed": "Couldn't save. Try again."
    }
  },
  "team": {
    "block": {
      "self": "You cannot change your own membership. Ask an admin.",
      "onlyAdminChanges": "Only an admin can change an admin or a manager.",
      "onlyAdminGrants": "Only an admin can give the admin or manager role.",
      "lastAdmin": "The agency needs at least one active admin. Make someone else admin first."
    },
    "title": "Members",
    "count_one": "{{count}} member",
    "count_other": "{{count}} members",
    "invite": "Invite someone",
    "statusFilter": "Member status",
    "search": "Search by name or email",
    "you": "You",
    "noName": "No name yet",
    "emptyStatus": "No members with this status.",
    "inactiveSince": "since {{date}}",
    "col": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "carriers": "Carriers",
      "phone": "Phone",
      "joined": "Joined",
      "status": "Status",
      "actions": "Actions"
    },
    "carriers": {
      "count_one": "{{count}} carrier",
      "count_other": "{{count}} carriers",
      "none": "None yet",
      "noneHelp": "Sees no loads until carriers are assigned.",
      "all": "All carriers",
      "edit": "Carriers of {{name}}: {{summary}}"
    },
    "roleSummary": {
      "admin": "Everything, including the team, permissions and agency rules.",
      "manager": "Runs the fleet and brokers, and assigns carriers to dispatchers.",
      "dispatcher": "Runs loads for the assigned carriers.",
      "accounting": "Invoices, payments and both ledgers."
    },
    "roleConsequence": {
      "admin": "{{name}} can do everything, including this page.",
      "manager": "{{name}} can manage the fleet and assign carriers to dispatchers, as this agency's permissions say.",
      "dispatcher": "{{name}} starts with no carriers: assign them after saving.",
      "accounting": "{{name}} works invoices and payments, as this agency's permissions say.",
      "leaveDispatcher_one": "{{name}} loses {{count}} carrier. Back as a dispatcher, {{name}} starts with none.",
      "leaveDispatcher_other": "{{name}} loses {{count}} carriers. Back as a dispatcher, {{name}} starts with none."
    },
    "sheet": {
      "readOnlyNote": "Each person edits their own name and phone in My profile.",
      "details": "Details",
      "joined": "Joined",
      "invitedBy": "Invited by",
      "role": "Role",
      "saveRole": "Save role",
      "roleSaved": "Role saved",
      "access": "Access",
      "activeNote": "Active: can sign in to this agency.",
      "inactiveNote": "Inactive since {{date}}: cannot sign in to this agency.",
      "deactivate": "Deactivate",
      "reactivate": "Reactivate",
      "deactivateTitle": "Deactivate {{name}}?",
      "deactivateBody": "{{name}} loses access to this agency now: the next screen in the portal shows nothing of it, and signing in to it is refused. The carrier assignments of {{name}} are kept for a reactivation, and the name stays on past records.",
      "deactivated": "{{name}} deactivated",
      "reactivated": "{{name}} reactivated",
      "carriers": "Carriers",
      "noCarriers": "No carriers yet: no loads to see.",
      "editCarriers": "Edit carriers"
    },
    "assign": {
      "title": "Carriers of {{name}}",
      "description": "This member sees and works only the carriers checked here.",
      "search": "Search carriers",
      "save": "Save carriers",
      "empty": "No carriers match.",
      "planning": "Assigning a carrier that is not active is allowed, for planning.",
      "inactiveNoAdd": "Reactivate {{name}} to assign carriers. Removing stays allowed.",
      "resultAdded_one": "{{count}} added for {{name}}",
      "resultAdded_other": "{{count}} added for {{name}}",
      "resultRemoved_one": "{{count}} removed for {{name}}",
      "resultRemoved_other": "{{count}} removed for {{name}}",
      "result": "{{added}} added, {{removed}} removed for {{name}}",
      "nothing": "Nothing changed.",
      "partial": "Some changes were not applied. The rest were saved.",
      "failure": "{{name}}: {{message}}",
      "none": "No carriers yet. You can assign them later."
    },
    "dispatchers": {
      "column": "Dispatcher",
      "unassigned": "Unassigned",
      "more": "+{{count}}",
      "manage": "Dispatchers of {{name}}: {{summary}}",
      "title": "Dispatchers of {{name}}",
      "description": "Each dispatcher checked here sees and works this carrier.",
      "empty": "No active dispatchers in the agency yet. Invite one from Settings, Team.",
      "save": "Save dispatchers"
    },
    "roleConfirm": {
      "title": "Make {{name}} {{role}}?",
      "body": "{{name}} will be taken off these carriers: {{carriers}}. To run them again later, they are assigned by hand.",
      "confirm": "Change role"
    }
  },
  "memberInvite": {
    "block": {
      "onlyAdmin": "Only an admin can resend or cancel an admin or manager invitation.",
      "notPending": "This invitation already ended.",
      "sendLimit": "Sent {{count}} times. Revoke it and invite again.",
      "cooldown": "You can send it again in {{seconds}} s."
    },
    "dialog": {
      "title": "Invite someone",
      "description": "We email a link to join this agency. It works for 7 days.",
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "carriers": "Carriers",
      "carriersHelp": "Optional. You can also assign carriers later.",
      "carriersSearch": "Search carriers",
      "language": "Email language",
      "languageHelp": "The invitation email is written in this language.",
      "submit": "Send invitation",
      "sending": "Sending…",
      "sent": "Invitation sent to {{email}}",
      "showMember": "Show member",
      "openMember": "Open the membership"
    },
    "card": {
      "title": "Invitations",
      "description": "People invited to the office who have not joined yet, and what happened to past invitations.",
      "filter": "Invitations",
      "tabPending": "Pending",
      "tabHistory": "History",
      "historyNote": "Invitations that ended in the last 90 days.",
      "emptyHistory": "No invitation ended in the last 90 days.",
      "emptyPendingTitle": "No pending invitations",
      "emptyPendingHint": "Use Invite someone to add a person to the office."
    },
    "col": {
      "person": "Person",
      "role": "Role",
      "state": "State",
      "email": "Email",
      "invitedBy": "Invited by",
      "actions": "Actions"
    },
    "expires": "Expires {{date}}",
    "delivery": {
      "failed": "Not delivered",
      "sending": "Sending",
      "sent": "Sent {{when}}",
      "none": "Not sent yet",
      "sends": "{{count}} of {{max}} sends",
      "providerMessage": "Provider message"
    },
    "resend": "Resend",
    "resendFor": "Resend the invitation to {{email}}",
    "resendExpired": "Resending gives it 7 more days.",
    "resent": "Sent again. It now expires {{date}}",
    "copyLinkFor": "Copy link for {{email}}",
    "linkCopied": "Link copied",
    "linkNote": "The link works only for {{email}}: they confirm it with a sign-in link sent to that address.",
    "revoke": "Revoke",
    "revokeFor": "Revoke the invitation of {{email}}",
    "revokeTitle": "Revoke the invitation of {{name}}?",
    "revokeBody": "{{name}}'s link stops working. An email not delivered yet is dropped.",
    "revoked": "Invitation revoked",
    "invitedByLine": "Invited by {{name}}"
  },
  "loadStatus": {
    "potential": "Potential",
    "booked": "Booked",
    "dispatched": "Dispatched",
    "accepted": "Accepted",
    "atPickup": "At Pickup",
    "loaded": "Loaded",
    "inTransit": "In Transit",
    "delivered": "Delivered",
    "podReceived": "POD Received",
    "invoiced": "Invoiced",
    "paid": "Paid",
    "canceled": "Canceled",
    "unknown": "Unknown status"
  },
  "loads": {
    "tableLabel": "Loads",
    "tabsLabel": "Filter loads by status",
    "tabs": {
      "active": "Active",
      "delivered": "Delivered",
      "billing": "Billing",
      "closed": "Closed",
      "all": "All"
    },
    "columns": {
      "load": "Load",
      "carrier": "Carrier",
      "driverTruck": "Driver / unit",
      "route": "Route",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "broker": "Broker",
      "rate": "Rate",
      "status": "Status",
      "docs": "Docs",
      "dispatcher": "Dispatcher",
      "actions": "Actions",
      "podBol": "POD / BOL",
      "carrierBroker": "Carrier / broker"
    },
    "unit": "Unit {{unit}}",
    "unassigned": "Unassigned",
    "route": "{{origin}} → {{destination}}",
    "noRoute": "No stops yet",
    "moreStops_one": "+{{count}} stop",
    "moreStops_other": "+{{count}} stops",
    "ratePerMile": "{{rate}}/mi",
    "belowMinimum": "Below the carrier's minimum of {{min}}/mi",
    "noRate": "No rate",
    "waitingMinutes_one": "Waiting {{count}} min",
    "waitingMinutes_other": "Waiting {{count}} min",
    "waitingHours": "Waiting {{hours}} h {{minutes}} min",
    "docMarks": {
      "rateCon": "RC",
      "bol": "BOL",
      "pod": "POD"
    },
    "docPresent": "{{kind}} uploaded",
    "docMissing": "{{kind}} missing",
    "search": "Search loads",
    "searchPlaceholder": "Load #, reference, carrier, driver, broker or city",
    "filters": {
      "label": "Filters",
      "toggle": "Filters ({{count}})",
      "toggle_zero": "Filters",
      "carrier": "Carrier",
      "allCarriers": "All carriers",
      "driver": "Driver",
      "allDrivers": "All drivers",
      "dispatcher": "Dispatcher",
      "allDispatchers": "All dispatchers",
      "broker": "Broker",
      "allBrokers": "All brokers",
      "pickupFrom": "Pickup from",
      "pickupTo": "Pickup to",
      "clear": "Clear filters",
      "pickup": "Pickup",
      "anyDate": "Any date",
      "range": "{{from}} – {{to}}",
      "rangeFrom": "from {{from}}",
      "rangeTo": "until {{to}}",
      "all": "All"
    },
    "empty": {
      "noLoads": "No loads yet. Create the first one from its rate confirmation.",
      "noMatch": "No load matches these filters.",
      "podReview": "No delivered load is waiting for its paperwork."
    },
    "cap": "Showing the {{count}} most recent. Narrow the dates to see older loads.",
    "loading": "Loading loads…",
    "error": "The loads could not be loaded.",
    "newLoad": "New load",
    "rowActions": {
      "open": "Open {{load}}",
      "openFullPage": "Open full page",
      "more": "More actions for {{load}}"
    },
    "podReview": {
      "from": "{{kind}} from {{name}}",
      "fromApp": "{{kind}} from {{name}} (app)",
      "at": "{{time}}",
      "nothing": "No POD or BOL yet",
      "deliveredAt": "Delivered {{time}}",
      "oldestFirst": "oldest delivery first"
    },
    "chips": {
      "latePickup": "Late to pickup",
      "lateDelivery": "Late to delivery",
      "lateStop": "Late to stop {{n}}",
      "atDockMinutes_one": "At dock {{count}} min",
      "atDockMinutes_other": "At dock {{count}} min",
      "atDockHours": "At dock {{hours}} h {{minutes}} min"
    },
    "sort": {
      "label": "Sort by",
      "created": "Newest first",
      "nextStop": "Next stop"
    },
    "view": {
      "label": "View",
      "list": "List",
      "today": "Today",
      "availability": "Availability"
    },
    "today": {
      "label": "Today's pickups and deliveries by driver",
      "empty": "No pickups or deliveries today.",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "stops_one": "{{count}} stop",
      "stops_other": "{{count}} stops",
      "emptyHint": "The next stops are in the list sorted by next stop.",
      "showNextStops": "List · sort by next stop"
    },
    "availability": {
      "title": "Who is free when",
      "drivers": "Drivers",
      "trucks": "Trucks",
      "name": "Name",
      "current": "Current load",
      "nextStop": "Next stop",
      "freeFrom": "Free from",
      "freeNow": "Free now",
      "open": "Open (no time on the last delivery)",
      "empty": "No active drivers or trucks.",
      "help": "From the dispatched and rolling loads: free from the last delivery's departure, else its window end or appointment, in the agency time zone.",
      "active_one": "{{count}} active",
      "active_other": "{{count}} active"
    },
    "flag": {
      "minutes": "{{count}} min",
      "hours": "{{count}} h",
      "waiting": "{{time}}",
      "atDock": "at dock {{time}}"
    },
    "noBroker": "No broker",
    "routeTo": "→ {{destination}}",
    "countOf": "{{shown}} of {{total}} loads",
    "foot_one": "{{count}} load · {{sort}}",
    "foot_other": "{{count}} loads · {{sort}}"
  },
  "loadForm": {
    "sections": {
      "parties": "Carrier and load",
      "stops": "Stops",
      "money": "Rate and miles",
      "rateCon": "Rate confirmation",
      "notes": "Notes"
    },
    "carrier": "Carrier",
    "carrierPlaceholder": "Choose a carrier",
    "noCarriers": "No active carrier to create a load for.",
    "broker": "Broker",
    "brokerNone": "No broker yet",
    "brokerOption": "{{name}} · MC {{mc}}",
    "brokerReferenceHelp": "The broker's load or PO number.",
    "loadNumberPlaceholder": "Auto-assigned",
    "weightUnit": "lb",
    "frozenNote": "You can change these later from the load, with Edit details.",
    "setup": {
      "approved": "Set up with {{broker}} on {{date}}.",
      "approvedNoDate": "Set up with {{broker}}.",
      "notApproved": "{{carrier}} is not set up with {{broker}} yet ({{status}}). You can still save.",
      "none": "{{carrier}} is not set up with {{broker}} yet. You can still save.",
      "open": "Open broker setups"
    },
    "rate": "Rate (linehaul)",
    "rateMissing": "Without a rate the POD can't be confirmed.",
    "loadedMiles": "Loaded miles",
    "deadheadMiles": "Deadhead miles",
    "preview": {
      "title": "Estimated",
      "totalMiles": "Total miles",
      "rpmLoaded": "Rate / loaded mile",
      "rpmTotal": "Rate / total mile",
      "belowMinimum": "Below {{carrier}}'s minimum of {{min}}/mi.",
      "estimatedAt": "Estimated at {{pct}}%",
      "fee": "Dispatch fee",
      "carrierNet": "Carrier net",
      "noCarrier": "Choose a carrier to estimate the fee.",
      "noPlan": "No dispatch % set for this carrier: set it before the POD.",
      "feeHidden": "The dispatch fee is visible to admin and accounting.",
      "noRate": "Add the rate to see the money.",
      "detentionUnknown": "Detention is estimated at 0%; the agency's detention rate applies when the fee is earned.",
      "detentionAt": "Detention at {{pct}}%."
    },
    "rateCon": {
      "drop": "Drop the broker's rate confirmation here, or choose a file",
      "choose": "Choose file",
      "remove": "Remove file",
      "accepted": "PDF, JPEG, PNG, HEIC or WebP, at most 25 MB.",
      "none": "No file chosen. You can upload it later."
    },
    "status": {
      "label": "Status",
      "booked": "Booked",
      "bookedHelp": "Confirmed with the broker.",
      "potential": "Potential",
      "potentialHelp": "Still negotiating.",
      "createAs": "Create as"
    },
    "submit": "Create load",
    "steps": {
      "create": "Creating the load…",
      "upload": "Uploading the rate confirmation…",
      "register": "Attaching the rate confirmation…",
      "label": "Form sections",
      "required": "required"
    },
    "created": "{{load}} created",
    "dispatchNow": "Dispatch now",
    "result": {
      "title": "{{load}} was created, but not everything was saved.",
      "upload": "The rate confirmation could not be uploaded: {{reason}} Upload it again below.",
      "register": "The rate confirmation was uploaded but not attached: {{reason}} Try again below.",
      "uploadAgain": "Upload again",
      "attachAgain": "Attach it again"
    },
    "extras": {
      "title": "Extras",
      "help": "Paid by the broker on top of the rate. The agency's percentage applies to the rate; detention has its own rate; lumper and other reimbursements never count.",
      "detention": "Detention",
      "lumper": "Lumper",
      "other": "Other",
      "tonu": "TONU"
    },
    "copiedFrom": "Copied from {{load}}. Stop dates, times and reference numbers were left blank.",
    "copiedCarrierDropped": "The carrier of {{load}} can't take new loads now, so it was left blank. Pick one.",
    "copiedBrokerDropped": "The broker of {{load}} is no longer in your list, so it was left blank.",
    "copySourceMissing": "The load to copy was not found or is not one of yours. Start from a blank form.",
    "copyLoading": "Loading the load to copy…"
  },
  "addressSearch": {
    "label": "Search address",
    "help": "Pick a suggestion to pin the stop on the map. You can also type the fields below.",
    "placeholder": "Company, street or city",
    "count_one": "{{count}} suggestion",
    "count_other": "{{count}} suggestions",
    "empty": "No match. Type the address below; the stop saves without a map pin.",
    "unavailable": "Address search is not available right now. Type the address below; the stop saves without a map pin.",
    "attribution": "© OpenStreetMap contributors",
    "pin": {
      "pinned": "Pinned on the map",
      "notPinned": "Not on the map",
      "srPrefix": "Map pin:"
    }
  },
  "locationMap": {
    "title": "Location",
    "state": {
      "noDriver": "Live location starts when a driver accepts the load.",
      "notYet": "Live location starts when {{driver}} accepts the load.",
      "noApp": "{{driver}} does not use the Coreway app, so there is no live location.",
      "none": "No live location. {{driver}} has not shared a location for this load. Location is optional for drivers.",
      "fresh": "Updated {{ago}} · {{time}}",
      "stale": "Last update {{ago}} · {{time}}. The phone may be offline or the app closed.",
      "old": "No update since {{time}} ({{ago}}). The phone may be offline or the app closed.",
      "ended": "Tracking ended at delivery. Last position {{time}}.",
      "error": "Live location could not be loaded."
    },
    "call": "Call {{driver}}",
    "approx": "Approximate (within {{miles}} mi).",
    "recenter": "Recenter",
    "mapLabel": "Map of the truck and the pinned stops. {{line}}",
    "mapLabelStops": "Map of the pinned stops.",
    "truck": "Truck",
    "noTiles": "Map images are not set up (config.js has no mapboxToken).",
    "unpinnedNote": "Stops without a pin are not on the map.",
    "loading": "Loading the map…",
    "attribution": {
      "mapbox": "© Mapbox",
      "osm": "© OpenStreetMap contributors",
      "improve": "Improve this map"
    }
  },
  "stops": {
    "kinds": {
      "pickup": "Pickup",
      "delivery": "Delivery"
    },
    "label": "{{kind}} {{n}}",
    "labelCity": "{{kind}} {{n}} · {{city}}",
    "company": "Company",
    "address": "Address",
    "addressLine2": "Address line 2",
    "city": "City",
    "state": "State",
    "postal": "ZIP",
    "appointmentDate": "Appointment date",
    "appointmentTime": "Appointment time",
    "appointmentEnd": "Window ends",
    "appointmentEndHelp": "Leave it blank for a fixed appointment.",
    "contactName": "Contact name",
    "contactPhone": "Contact phone",
    "reference": "Reference #",
    "notes": "Notes",
    "zoneNames": {
      "eastern": "Eastern time",
      "central": "Central time",
      "mountain": "Mountain time",
      "arizona": "Arizona time",
      "pacific": "Pacific time",
      "alaska": "Alaska time",
      "hawaii": "Hawaii time",
      "other": "{{city}} time"
    },
    "zoneLine": "{{zone}} ({{abbrev}}), from the state",
    "zoneChosen": "{{zone}} ({{abbrev}})",
    "zoneAgency": "Agency time ({{abbrev}}): type the state to use the stop's own zone",
    "splitHint": "{{state}} spans two time zones. Check the zone.",
    "zoneSelect": "Time zone",
    "agencyTime": "{{time}} agency time",
    "noAppointment": "No appointment",
    "window": "{{start}} to {{end}}",
    "arrived": "Arrived {{time}}",
    "departed": "Departed {{time}}",
    "dwell_one": "{{count}} min on site",
    "dwell_other": "{{count}} min on site",
    "editor": {
      "addPickup": "Add pickup",
      "addDelivery": "Add delivery",
      "moveUp": "Move {{stop}} up",
      "moveDown": "Move {{stop}} down",
      "remove": "Remove {{stop}}",
      "marker": { "pickup": "P", "delivery": "D" },
      "lastPickup": "A load needs at least one pickup.",
      "lastDelivery": "A load needs at least one delivery."
    },
    "reasons": {
      "visited": "This stop was already visited.",
      "onlyPickup": "It is the only pickup of a load that is out.",
      "onlyDelivery": "It is the only delivery of a load that is out.",
      "finished": "The itinerary of a finished load can't change."
    },
    "actions": {
      "edit": "Edit {{stop}}",
      "recordArrival": "Record arrival",
      "recordDeparture": "Record departure",
      "remove": "Remove",
      "add": "Add stop",
      "correctArrival": "Correct arrival time",
      "correctDeparture": "Correct departure time"
    },
    "removeTitle": "Remove {{stop}}?",
    "removeBody": "The stop leaves the itinerary, and the driver's app drops it.",
    "addPickupTitle": "Add a pickup to {{load}}",
    "addDeliveryTitle": "Add a delivery to {{load}}",
    "editTitle": "Edit {{stop}}",
    "noChange": "Nothing changed yet.",
    "saved": "Stop saved",
    "addPartial": "Stop added, but its time zone, window end or address line 2 did not save. Edit the stop to add them.",
    "removed": "Stop removed",
    "stamp": {
      "arrivalTitle": "Record the arrival at {{stop}}",
      "departureTitle": "Record the departure from {{stop}}",
      "arrivalQuestion": "When did the driver arrive?",
      "departureQuestion": "When did the driver leave?",
      "date": "Date",
      "time": "Time",
      "zoneNote": "In the stop's time: {{zone}} ({{abbrev}}).",
      "save": "Record",
      "saved": "Time recorded"
    },
    "restamp": {
      "arrivalTitle": "Correct the arrival at {{stop}}",
      "departureTitle": "Correct the departure from {{stop}}",
      "question": "When did it really happen?",
      "current": "Recorded: {{time}}",
      "reason": "Why",
      "reasonHelp": "Kept in the load's history. Example: the driver called in the real time.",
      "save": "Save correction",
      "saved": "Time corrected"
    },
    "overFreeTime": "{{over}} min over the free time ({{free}} min)",
    "overFreeTimeAmount": "Detention ≈ {{amount}}",
    "atDockOver": "At the dock {{minutes}} min, past the {{free}} min free time. Record the departure to count detention.",
    "facility": {
      "picker": "Facility",
      "pickerPlaceholder": "Pick a saved facility",
      "saveAs": "Save as facility",
      "saved": "Saved as a facility.",
      "hoursPrefix": "Hours: {{hours}}"
    },
    "cell": {
      "to": "to {{end}}",
      "agency": "{{time}} agency"
    },
    "moreFields": "+ Address line 2, contact, reference #, notes",
    "lessFields": "Hide the optional fields"
  },
  "loadDetail": {
    "loading": "Loading the load…",
    "error": "The load could not be loaded.",
    "notFound": "This load does not exist or is not one of yours.",
    "backToLoads": "Back to loads",
    "sheetTitle": "Load {{load}}",
    "openFullPage": "Open full page",
    "dispatcher": "Dispatcher: {{name}}",
    "noDispatcher": "No dispatcher",
    "reference": "Ref. {{reference}}",
    "tabsLabel": "Load sections",
    "tabs": {
      "overview": "Overview",
      "stops": "Stops",
      "documents": "Documents",
      "financials": "Financials",
      "timeline": "Timeline",
      "chat": "Chat"
    },
    "parties": {
      "broker": "Broker",
      "carrier": "Carrier",
      "driver": "Driver",
      "truck": "Truck",
      "mc": "MC {{mc}}",
      "dot": "DOT {{dot}}",
      "app": "App",
      "noApp": "No app",
      "noDriver": "No driver yet",
      "noTruck": "No truck yet",
      "noBroker": "No broker",
      "setup": "Setup: {{status}}",
      "noSetup": "Not set up with this broker",
      "call": "Call {{name}}",
      "truckModel": "{{make}} {{model}}",
      "unit": "Unit {{unit}}"
    },
    "ends": {
      "pickup": "Pickup",
      "delivery": "Delivery"
    },
    "facts": {
      "commodity": "Commodity",
      "weight": "Weight",
      "weightValue": "{{weight}} lb",
      "length": "Length",
      "lengthValue": "{{length}} ft",
      "notes": "Notes",
      "notSet": "Not set"
    },
    "milesSummary": "{{loaded}} loaded + {{deadhead}} deadhead = {{total}} mi",
    "financials": {
      "rate": "Rate",
      "total": "Total",
      "loadedMiles": "Loaded miles",
      "deadheadMiles": "Deadhead miles",
      "totalMiles": "Total miles",
      "rpmLoaded": "Rate / loaded mile",
      "rpmTotal": "Rate / total mile",
      "minimum": "Carrier minimum",
      "belowMinimum": "Below the carrier's minimum of {{min}}/mi.",
      "notSet": "Not set",
      "feeTitle": "Dispatch fee",
      "estimatedAt": "Estimated at {{pct}}%",
      "sourceTruck": "From the truck's plan.",
      "sourceCarrier": "From the carrier's plan.",
      "frozen": "Frozen {{date}} at {{pct}}%",
      "fee": "Dispatch fee",
      "carrierNet": "Carrier net",
      "disputed": "Disputed",
      "noPlan": "No dispatch % set for this carrier.",
      "feeHidden": "The dispatch fee is visible to admin and accounting.",
      "milesLocked": "Miles can't change after the POD yet.",
      "tonuFrozen": "TONU fee earned {{date}} at {{pct}}%",
      "accessorial": "Extras",
      "route": {
        "label": "Route miles",
        "computed": "{{miles}} mi (Mapbox, {{date}})",
        "pendingWith": "{{miles}} mi · Recomputing…",
        "pending": "Recomputing…",
        "unavailable": "Not available",
        "noCoordinates": "Add a position to every stop (pick the address from the search) to compute route miles.",
        "failed": "Couldn't compute the route.",
        "recompute": "Recompute",
        "use": "Use as loaded miles",
        "help": "Driving miles over the stops in order, from Mapbox (car route, an estimate). Loaded miles stay what you enter; use this to check them."
      },
      "priceFromRoute": "From Mapbox route miles. Check before saving.",
      "groups": {
        "revenue": "Revenue",
        "miles": "Miles"
      }
    },
    "accessorials": {
      "title": "Accessorials",
      "add": "Add accessorial",
      "addTitle": "Add accessorial",
      "editTitle": "Edit accessorial",
      "edit": "Edit",
      "remove": "Remove",
      "removeTitle": "Remove this accessorial?",
      "removeBody": "It comes off the load's money and the broker invoice. The timeline keeps it.",
      "removeReason": "Reason (optional)",
      "empty": "No accessorials yet.",
      "driverPaid": "Driver paid",
      "lockedAfterFee": "The fee is earned: only notes and who paid the lumper can change.",
      "lumperNote": "Driver paid the lumper ({{amount}}). Agency- or owner-paid drivers get it back on their settlement; a carrier-paid driver is reimbursed by his carrier, outside Coreway.",
      "fromList": "From the accessorials list",
      "help": "Each line adds to its bucket on the load (detention, lumper, or other) and prints as its own line on the broker invoice."
    },
    "factsLabel": "Load parties",
    "rail": {
      "label": "Status, money and documents",
      "money": "Money",
      "toFinancials": "Financials",
      "miles": "{{loaded}} loaded + {{deadhead}} deadhead",
      "milesValue": "{{total}} mi · {{rpm}}/mi",
      "feeEstimated": "Dispatch fee (est. {{pct}}%)",
      "feeFrozen": "Dispatch fee ({{pct}}%)",
      "documents": "Documents",
      "docsCount": "{{count}} of {{total}}",
      "missing": "Missing",
      "notUploaded": "Not uploaded",
      "uploaded": "Uploaded",
      "upload": "Upload",
      "uploadKind": "Upload {{kind}}"
    },
    "late": "Late",
    "overview": {
      "route": "Route",
      "parties": "Parties",
      "details": "Details",
      "dispatcher": "Dispatcher"
    }
  },
  "loadActions": {
    "label": "Load actions",
    "book": "Book",
    "dispatch": "Dispatch",
    "accept": "Driver accepted (by phone)",
    "decline": "Driver declined (by phone)",
    "unassign": "Remove driver",
    "atPickup": "At pickup (by phone)",
    "loaded": "Loaded (by phone)",
    "inTransit": "In transit (by phone)",
    "delivered": "Delivered (by phone)",
    "podReceived": "POD received",
    "uploadPod": "Upload POD",
    "price": "Edit rate & miles",
    "reprice": "Reprice",
    "invoiceBroker": "Invoice to the broker",
    "cancel": "Cancel load",
    "editDetails": "Edit details",
    "more": "More actions",
    "block": {
      "noStops": "Add a pickup and a delivery before dispatching.",
      "noRate": "Add the rate before confirming the POD.",
      "noPlan": "Set this carrier's dispatch % before confirming the POD.",
      "receivable": "This load is invoiced to the broker. Unmark it in Broker payments before cancelling.",
      "rolling": "The driver already reached a stop. To take the load back, cancel it."
    },
    "dispatchDialog": {
      "title": "Dispatch {{load}}",
      "driver": "Driver",
      "driverApp": "{{name}} · App",
      "driverNoApp": "{{name}} · No app (answer by phone)",
      "truck": "Truck",
      "truckOption": "Unit {{unit}}",
      "truckPaired": "Unit {{unit}} · Paired with {{name}}",
      "choose": "Choose…",
      "noDrivers": "No active driver holds a seat on {{carrier}}.",
      "noTrucks": "{{carrier}} has no active truck.",
      "appLine": "{{name}} gets a push in the app and answers there.",
      "noAppLine": "{{name}} has no app: record the answer by phone.",
      "bookFirst": "The load is booked first.",
      "noBroker": "This load has no broker yet. You can dispatch it now and add the broker later with Edit details.",
      "submit": "Dispatch",
      "bookedButNotDispatched": "{{load}} was booked, but the dispatch failed: {{reason}}",
      "checking": "Checking the driver and truck…",
      "checkFailed": "Could not check for other loads and documents. The agency's rules still apply when you dispatch.",
      "activeLoad": "On {{load}}",
      "nextStop": "Next: {{city}}, {{when}}",
      "nextStopNoTime": "Next: {{city}}",
      "conflictSame": "Overlaps {{load}} ({{window}})",
      "windowRange": "{{from}} to {{to}}",
      "conflictUnbounded": "Overlaps {{load}}: no appointment times to compare",
      "conflictOther": "Busy on a load of another carrier at that time",
      "docsLabel": "Required documents",
      "setupLabel": "Broker setup",
      "setupNotApproved": "{{carrier}} is not approved with this broker yet.",
      "warnTitle": "Check before you dispatch",
      "ack": "I have checked these notes and want to dispatch anyway",
      "submitAnyway": "Dispatch anyway",
      "blockedTitle": "The agency's dispatch rules block this assignment",
      "blockedHelp": "An admin can change these rules in Settings › Permissions and rules.",
      "axis": {
        "driver_busy": "The driver is on another load at that time.",
        "truck_busy": "The truck is on another load at that time.",
        "driver_docs": "A required driver document is expired.",
        "truck_docs": "A required truck document is expired.",
        "broker_setup": "The carrier is not approved with this broker."
      },
      "blocked": "The agency's dispatch rules block this assignment: the driver or truck is busy, and a required document is expired or the broker setup is not in order.",
      "blockedBusy": "The agency's dispatch rules block this assignment: the driver or truck is on another load at that time.",
      "blockedDocs": "The agency's dispatch rules block this assignment: a required document is expired or the broker setup is not in order."
    },
    "acceptDialog": {
      "title": "{{name}} accepted {{load}}?",
      "body": "This records that {{name}} accepted by phone.",
      "submit": "Record acceptance"
    },
    "declineDialog": {
      "title": "{{name}} declined {{load}}",
      "body": "This records that {{name}} declined. The load goes back to Booked and a task is opened.",
      "reasonPlaceholder": "What did the driver say?",
      "submit": "Record decline"
    },
    "advanceDialog": {
      "title": "Mark {{load}} {{status}}?",
      "body": "{{name}}'s app shows it too.",
      "submit": "Mark {{status}}",
      "question": {
        "atPickup": "When did the driver arrive at {{stop}}?",
        "delivered": "When was it delivered at {{stop}}?",
        "noStop": "When did it happen?"
      },
      "stampNote": "This also records the arrival at {{stop}}.",
      "alreadyStamped": "{{stop}} already has its arrival ({{time}}); only the status changes.",
      "noStop": "No stop to stamp: only the status changes.",
      "departureNote": "This records the departure from {{stop}} now. If it was earlier, correct it afterwards in Stops."
    },
    "priceDialog": {
      "title": "Edit rate & miles of {{load}}",
      "submit": "Save"
    },
    "editDetailsDialog": {
      "title": "Edit details of {{load}}",
      "body": "Fix what was typed wrong or left blank when the load was created. Rate and miles are edited apart.",
      "notes": "Office notes",
      "notesHelp": "Only the office sees these notes. The driver does not.",
      "invoicedLock": "This load is invoiced to the broker: unmark it in Broker payments to change the broker or the load number.",
      "submit": "Save"
    },
    "repriceDialog": {
      "title": "Reprice {{load}}",
      "consequence": "The fee is recalculated at the frozen {{pct}}%.",
      "consequenceUnknown": "The fee is recalculated at the frozen percentage.",
      "submit": "Reprice"
    },
    "cancelDialog": {
      "title": "Cancel {{load}}?",
      "body": "The driver's app drops the load. Without a TONU the fee and the driver's pay, if any, are reversed.",
      "submit": "Cancel load",
      "tonu": "The broker pays a TONU",
      "tonuHelp": "The agency fee and the lease commission are charged on the TONU, earned today.",
      "tonuAmount": "TONU amount"
    },
    "unassignDialog": {
      "title": "Remove {{name}} from {{load}}?",
      "titleNoName": "Remove the driver from {{load}}?",
      "bodyDispatched": "The load goes back to Booked with no driver or truck, and the driver's app drops it. Then dispatch it to another driver.",
      "bodyAccepted": "The driver already accepted this load. It goes back to Booked with no driver or truck, and the driver's app drops it. Write why: it stays in the office log and the driver does not see it.",
      "optional": "Optional. The driver does not see it.",
      "submit": "Remove driver"
    },
    "podDialog": {
      "title": "Confirm the POD of {{load}}?",
      "withPod": "POD from {{name}}, {{date}}.",
      "noPod": "No POD is uploaded for {{load}}. Confirm only if you have it by email or on paper. You can upload it afterwards.",
      "uploadFirst": "Upload it first",
      "consequence": "The agency's fee is earned now.",
      "submit": "Confirm POD received",
      "detentionTitle": "Detention to bill?",
      "detentionStop": "{{stop}}: {{dwell}} min on site, {{over}} min over the free time ({{free}} min).",
      "detentionAmount": "At {{rate}}/h for {{hours}} h: {{amount}}.",
      "detentionNoRate": "This broker has no hourly detention rate. Add the amount by hand in the price.",
      "detentionNow": "Detention on the load now: {{amount}}.",
      "addDetention": "Add detention {{amount}}"
    },
    "uploadDialog": {
      "title": "Upload a document to {{load}}",
      "hint": "Pick the document type and the file. The office and the driver's app see it on the load.",
      "kind": "Document type",
      "file": "File",
      "submit": "Upload",
      "uploading": "Uploading…",
      "choose": "Choose file",
      "noFile": "No file chosen",
      "accepts": "PDF, JPG, PNG, HEIC or WebP, up to 25 MB."
    },
    "reason": "Reason",
    "noChange": "Nothing changed yet.",
    "done": {
      "booked": "{{load}} booked",
      "dispatched": "{{load}} dispatched to {{name}}",
      "accepted": "{{load}} accepted",
      "declined": "{{load}} is back to Booked",
      "advanced": "{{load}} is now {{status}}",
      "podReceived": "POD received for {{load}}",
      "priced": "Rate and miles saved",
      "repriced": "{{load}} repriced",
      "detailsSaved": "Details of {{load}} saved",
      "canceled": "{{load}} canceled",
      "uploaded": "{{kind}} uploaded",
      "unassigned": "{{load}} is back to Booked. Dispatch it to another driver.",
      "deliveredAt": "{{load}} marked delivered"
    },
    "deliveredAt": "Delivered (date/time)",
    "deliveredAtDialog": {
      "title": "Mark {{load}} delivered",
      "body": "Records At pickup, Loaded, In transit and Delivered in one step. Only the delivery's arrival gets this time.",
      "ack": "I understand the steps in between are recorded without times of their own",
      "submit": "Mark delivered"
    },
    "duplicate": "Duplicate"
  },
  "docCenter": {
    "ownerKind": {
      "label": "Owner type",
      "carrier": "Carriers",
      "truck": "Trucks",
      "driver": "Drivers",
      "one": {
        "carrier": "Carrier",
        "truck": "Truck",
        "driver": "Driver",
        "load": "Load"
      },
      "load": "Loads"
    },
    "status": {
      "valid": "Valid",
      "missing": "Missing",
      "expiresToday": "Expires today",
      "expiresIn_one": "{{count}} day left",
      "expiresIn_other": "{{count}} days left",
      "expiredAgo_one": "Expired {{count}} day ago",
      "expiredAgo_other": "Expired {{count}} days ago"
    },
    "required": "Required",
    "optional": "Optional",
    "expiresOn": "Expires {{date}}",
    "copies_one": "{{count}} copy",
    "copies_other": "{{count}} copies",
    "progress": "{{done}} of {{total}} required on file",
    "checklist": "Checklist",
    "openChecklist": "Open the documents of {{owner}}",
    "search": "Search by name",
    "loadFailed": "The documents could not be loaded.",
    "empty": {
      "carrier": "No carriers yet.",
      "truck": "No trucks yet.",
      "driver": "No drivers yet."
    },
    "filter": {
      "label": "Show",
      "all": "All",
      "attention": "Needs attention",
      "missing": "Missing documents",
      "expiring": "Expiring soon",
      "expired": "Expired",
      "complete": "Complete"
    },
    "summary": {
      "complete": "Complete",
      "missing_one": "{{count}} missing",
      "missing_other": "{{count}} missing",
      "expiring_one": "{{count}} expiring",
      "expiring_other": "{{count}} expiring",
      "expired_one": "{{count}} expired",
      "expired_other": "{{count}} expired"
    },
    "actions": {
      "upload": "Upload",
      "uploadKind": "Upload {{kind}}",
      "replace": "Replace",
      "replaceKind": "Replace {{kind}}",
      "addCopy": "Add a copy",
      "addCopyKind": "Add a copy of {{kind}}",
      "download": "Download",
      "downloadKind": "Download {{kind}}",
      "dates": "Dates",
      "datesKind": "Edit the dates of {{kind}}",
      "archive": "Archive",
      "archiveKind": "Archive {{kind}}",
      "addDocument": "Add a document"
    },
    "upload": {
      "title": "Upload a document for {{owner}}",
      "titleKind": "Upload {{kind}}",
      "forOwner": "For {{owner}}.",
      "pickHint": "Pick the kind, the file and its dates.",
      "replaceTitle": "Replace {{kind}}",
      "replaceHint": "The current copy ({{file}}) moves to the history.",
      "kind": "Document",
      "file": "File",
      "issuedOn": "Issued on",
      "expiresOn": "Expires on",
      "expiresHint": "Leave it empty if the document does not expire.",
      "submit": "Upload",
      "replaceSubmit": "Replace",
      "uploading": "Uploading…",
      "attachFailed": "The file was uploaded but not saved to the list. Try again.",
      "done": "Document saved."
    },
    "dates": {
      "title": "Correct the dates",
      "saved": "Dates saved."
    },
    "archive": {
      "title": "Archive {{kind}}?",
      "body": "It stops counting for the checklist and moves to the history, where it can still be downloaded.",
      "done": "Document archived."
    },
    "history": {
      "title": "History",
      "empty": "No replaced or archived copies.",
      "replaced": "Replaced",
      "archived": "Archived"
    },
    "requirements": {
      "open": "Requirements",
      "title": "Document requirements",
      "blurb": "What the agency requires from each carrier, truck, driver and load, and how many days before a document expires the task is raised.",
      "required": "Required",
      "requiredFor": "Required: {{kind}}",
      "warnDays": "days warning",
      "saved": "Requirement saved.",
      "loadHelp": "Load documents don't expire. A required one shows as Missing on the load and is checked when you mark the load invoiced: the rate confirmation from booking, the BOL and POD once delivered."
    },
    "errors": {
      "expiryBeforeIssue": "The expiry date cannot be before the issue date.",
      "wrongKind": "That document does not belong to this owner.",
      "alreadyReplaced": "Someone already replaced or archived this copy. Reload the checklist.",
      "notAllowed": "You cannot change this document. The money papers are for admin and accounting; everything else for the office that runs the carrier."
    },
    "package": {
      "filter": {
        "incomplete": "Incomplete packages",
        "complete": "Complete packages",
        "all": "All carriers"
      },
      "search": "Search carriers",
      "missingTitle": "Missing",
      "more": "+{{count}} more",
      "print": "Cover sheet",
      "printNow": "Print",
      "download": "Download package",
      "downloadFor": "Download the package of {{carrier}}",
      "preparing": "Preparing…",
      "partial_one": "{{count}} file could not be downloaded; the package has the rest.",
      "partial_other": "{{count}} files could not be downloaded; the package has the rest.",
      "allComplete": "Every carrier package is complete.",
      "notFound": "This carrier is not in your list.",
      "back": "Back to packages",
      "sheetTitle": "Carrier package: {{carrier}}",
      "generated": "Generated {{date}}",
      "tab": {
        "incomplete": "Incomplete",
        "complete": "Complete",
        "all": "All carriers"
      },
      "col": {
        "carrier": "Carrier",
        "required": "Required on file",
        "expiring": "Expiring",
        "actions": "Package"
      },
      "openChecklist": "Open checklist",
      "downloadShort": "Download",
      "downloadOff": "Download turns on once a file is uploaded.",
      "noneComplete": "No carrier has a complete package yet.",
      "completeRule": "A package is complete when every required document is on file.",
      "nothingRequired": "Nothing required",
      "nothingMissing": "Nothing missing",
      "nothingExpiring": "Nothing expiring",
      "foot_one": "{{count}} carrier · sorted by most missing",
      "foot_other": "{{count}} carriers · sorted by most missing",
      "notOnFile": "Not on file",
      "sheet": {
        "document": "Document",
        "status": "Status",
        "expires": "Expires",
        "file": "File",
        "dba": "DBA",
        "ein": "EIN",
        "address": "Address",
        "contact": "Contact",
        "billingEmail": "Billing email",
        "requiredOnFile": "Required on file",
        "optionalOnFile": "Optional on file",
        "missing_one": "{{count}} document missing",
        "missing_other": "{{count}} documents missing",
        "zone": "Agency time, {{zone}}",
        "paper": "Letter · portrait · prints without the portal",
        "footTitle": "Carrier package · {{carrier}}",
        "page": "Page {{page}} of {{pages}}"
      },
      "shortKind": {
        "insurance": "COI"
      }
    },
    "group": {
      "required": "Required · {{done}} of {{total}}",
      "optional": "Optional · {{done}} of {{total}}"
    },
    "table": {
      "onFile": "Required on file",
      "missing": "Missing",
      "expiring": "Expiring",
      "expired": "Expired",
      "nextExpiry": "Next expiry",
      "open": "Open",
      "ofTotal": "{{done}} of {{total}}",
      "noneRequired": "None required",
      "noExpiry": "No expiry on file",
      "foot_one": "{{count}} {{kind}} · {{missing}} required documents missing",
      "foot_other": "{{count}} {{kind}} · {{missing}} required documents missing",
      "countLegend": "Count = needs attention",
      "sorted": "Most missing first"
    }
  },
  "documentKind": {
    "rateConfirmation": "Rate confirmation",
    "bol": "BOL",
    "pod": "POD",
    "lumperReceipt": "Lumper receipt",
    "fuelReceipt": "Fuel receipt",
    "tollReceipt": "Toll receipt",
    "scaleReceipt": "Scale ticket",
    "detention": "Detention",
    "tonu": "TONU",
    "other": "Other",
    "w9": "W-9",
    "mcAuthority": "MC authority",
    "insurance": "Insurance certificate (COI)",
    "noa": "NOA letter",
    "dispatchAgreement": "Dispatch agreement",
    "factoring": "Factoring agreement",
    "cdl": "CDL",
    "medicalCard": "Medical card",
    "registration": "Registration",
    "annualInspection": "Annual inspection",
    "permit": "Permit",
    "voidCheck": "Void check",
    "zelleInfo": "Zelle information",
    "dotAuthority": "DOT authority",
    "limitedPoa": "Limited power of attorney",
    "companyProfile": "Company profile sheet",
    "truckOperationForm": "Truck operation form",
    "carrierReferences": "References",
    "cabCard": "Cab card",
    "truckPhoto": "Truck photo (company placards)",
    "vinPhoto": "VIN photo",
    "maintenanceRecord": "Maintenance record"
  },
  "loadDocs": {
    "upload": "Upload document",
    "download": "Download {{name}}",
    "newPill": "New",
    "notUploaded": "Not uploaded",
    "fromApp": "{{name}} from the app",
    "uploadedBy": "{{name}}, {{time}}",
    "sizeKb": "{{size}} KB",
    "sizeMb": "{{size}} MB",
    "empty": "No documents yet.",
    "attachFailed": "The file was uploaded but not attached. Try again.",
    "fileName": "Document",
    "replace": "Replace {{name}}",
    "archive": "Archive {{name}}",
    "replaceDialog": {
      "title": "Replace {{name}}",
      "body": "The new file takes its place on {{load}}. The old copy stays in the history, with your name and the reason.",
      "reason": "Reason (optional)",
      "submit": "Replace",
      "busy": "Replacing…"
    },
    "archiveDialog": {
      "title": "Archive {{name}}?",
      "body": "It leaves the load, the lists and the next broker packet. The file stays in the history, with your name and the reason. A packet already sent keeps its copy.",
      "confirm": "Archive"
    },
    "history": {
      "title": "Replaced and archived",
      "replaced": "{{kind}} · replaced by {{name}}, {{time}}",
      "archived": "{{kind}} · archived by {{name}}, {{time}}",
      "reason": "Reason: {{reason}}"
    },
    "done": {
      "replaced": "Document replaced.",
      "archived": "Document archived."
    },
    "errors": {
      "notAllowed": "Only the office that runs this carrier (admin, manager or its dispatcher) can replace or archive a load document.",
      "alreadyChanged": "Someone already replaced or archived this copy. Reload the load.",
      "alreadyOnLoad": "That file is already on this load. Upload the new copy again.",
      "reasonRequired": "Write why you archive it.",
      "reasonTooLong": "Keep the reason under 500 characters."
    },
    "inInvoice": "In broker invoice",
    "missing": "Missing"
  },
  "chat": {
    "inboxTitle": "Messages",
    "inboxEmpty": "No conversations yet, and no driver to write to.",
    "newMessage": "New message",
    "searchDrivers": "Search drivers",
    "pickDriver": "Who do you want to write to?",
    "pickThread": "Pick a driver on the left to open the conversation, or start a new one.",
    "youPrefix": "You:",
    "attachmentPhoto": "Photo",
    "attachmentPdf": "PDF",
    "attachmentUnavailable": "Not available",
    "openAttachment": "Open {{name}}",
    "placeholder": "Write a message",
    "send": "Send",
    "attach": "Attach a photo or PDF",
    "aboutLoad": "About load",
    "noLoad": "No load",
    "aLoad": "Load",
    "seen": "Seen",
    "sending": "Sending…",
    "failed": "Not sent. Retry",
    "today": "Today",
    "yesterday": "Yesterday",
    "earlier": "Earlier messages",
    "threadEmpty": "No messages yet. Say hello.",
    "noApp": "{{driver}} has no Coreway app yet. Your messages wait here until he signs in.",
    "noAppShort": "No app",
    "removed": "This driver was removed. The conversation is read only.",
    "removedDriver": "Removed driver",
    "formerMember": "Former team member",
    "driverSide": "Driver",
    "notAllowed": "Chat is for the driver's dispatcher, the admins and the managers.",
    "badge": "{{count}} unread conversations",
    "unreadInThread": "{{count}} unread",
    "backToInbox": "Back to messages",
    "openDriver": "Open driver",
    "toast": {
      "newMessage": "New message from {{driver}}",
      "open": "Open"
    },
    "errors": {
      "tooBig": "File too big (max 10 MB).",
      "badType": "Send a photo (JPEG, PNG, WebP) or a PDF.",
      "tooLong": "A message can have up to 4000 characters.",
      "notAllowed": "You can't write to this driver any more.",
      "gone": "This conversation is no longer available.",
      "removed": "This driver was removed.",
      "paused": "This agency is paused.",
      "generic": "Something went wrong. Try again."
    },
    "entry": {
      "message": "Message",
      "messageDriver": "Message driver",
      "loadPanelTitle": "Chat about this load",
      "loadPanelEmpty": "No messages about this load yet.",
      "openThread": "Open the whole conversation"
    },
    "loadTab": {
      "title": "Messages about this load",
      "empty": "No messages about this load yet.",
      "noDriver": "Assign a driver to message about this load. Earlier messages about it still show here.",
      "sendingTo": "Goes to {{driver}}, about {{load}}."
    },
    "templates": {
      "button": "Quick messages",
      "label": "Insert a quick message"
    },
    "attachShort": "Attach",
    "aboutLoadHint": "The driver sees the load number on the message.",
    "appShort": "App",
    "noMessagesYet": "No messages yet",
    "sections": {
      "conversations": "Conversations",
      "openThread": "Open conversation",
      "start": "Start a conversation"
    },
    "startWith": "Start a conversation with {{name}}"
  },
  "docLists": {
    "search": "Search",
    "searchPlaceholder": "Load, file, broker, carrier, driver",
    "window": "Covers the loads of the Loads list: in flight, and closed in the last 90 days.",
    "noMatch": "No document matches these filters.",
    "open": "Open",
    "columns": {
      "load": "Load",
      "kind": "Kind",
      "status": "Status",
      "broker": "Broker",
      "carrier": "Carrier",
      "pickup": "Pickup",
      "file": "File",
      "uploaded": "Uploaded",
      "actions": "Actions",
      "invoice": "In broker invoice"
    },
    "rateCons": {
      "footMissing_one": "{{count}} load without a rate confirmation",
      "footMissing_other": "{{count}} loads without a rate confirmation",
      "footOnFile_one": "{{count}} rate confirmation on file",
      "footOnFile_other": "{{count}} rate confirmations on file",
      "tabsLabel": "Rate confirmations",
      "tabs": {
        "onFile": "On file",
        "missing": "Missing"
      },
      "empty": "No rate confirmation on file yet. They are uploaded when a load is created, or from the Missing tab.",
      "noneMissing": "Every booked load has its rate confirmation.",
      "uploadFor": "Upload the rate confirmation of load {{load}}",
      "uploaded": "Rate confirmation of {{load}} uploaded."
    },
    "receipts": {
      "foot_one": "{{count}} receipt",
      "foot_other": "{{count}} receipts",
      "add": "Add receipt",
      "allKinds": "All kinds",
      "archived": "Archived",
      "includeInInvoice": "Include {{name}} in the broker invoice",
      "marked": "{{name}} goes into the broker invoice.",
      "unmarked": "{{name}} is left out of the broker invoice.",
      "showArchived": "Show archived",
      "invoiceNote": "The broker packet attaches the receipts switched on in <b>In broker invoice</b>. A new lumper receipt is switched on by itself and the older ones off.",
      "emptyTitle": "No receipts yet",
      "emptyHint": "Lumper, fuel, toll, scale, detention and TONU paperwork of your loads lands here. Add one here or from the load."
    },
    "upload": {
      "action": "Upload",
      "title": "Add a receipt",
      "hint": "Type the load number, then pick the type and the file.",
      "loadNumber": "Load number",
      "loadNumberPlaceholder": "CW-1041",
      "noSuchLoad": "No load {{number}} in your list. Check the number, or add it from the load itself."
    },
    "pickupRange": {
      "label": "Pickup",
      "any": "Any date",
      "between": "{{from}} – {{to}}",
      "since": "From {{date}}",
      "until": "Until {{date}}",
      "clear": "Clear dates"
    }
  },
  "support": {
    "mailSubject": "Coreway support ({{version}})",
    "version": "Portal version",
    "contact": {
      "title": "Contact support",
      "noEmail": "This portal has no support address configured. Use the support page.",
      "page": "Support page: hours and security contact",
      "bandBefore": "Email",
      "bandAfter": "with the details below; a person answers. Hours and the security contact are on the support page.",
      "emailButton": "Email support",
      "pageShort": "Support page"
    },
    "report": {
      "title": "How to report a problem",
      "steps": {
        "what": "What you did, and what happened instead.",
        "where": "Where: the screen, and the load, driver or carrier number.",
        "when": "When it happened (your time zone).",
        "screenshot": "A screenshot, if you can take one.",
        "diagnosticsBeside": "The details on the right, pasted into your message."
      },
      "security": "A security issue? Say so in the subject line, and do not include passwords.",
      "copy": "Copy details",
      "copied": "Details copied",
      "rawUserAgent": "Full browser string"
    }
  },
  "assignedDrivers": {
    "noDispatcher": "No dispatcher",
    "counts": "{{carriers}} · {{drivers}}",
    "noCarriers": "No carrier assigned yet.",
    "noDrivers": "No driver with an active seat on these carriers.",
    "truck": "Unit {{unit}}",
    "noTruck": "No truck",
    "hasApp": "Has the app",
    "call": "Call {{name}}",
    "manage": "Assign carriers",
    "empty": "No active dispatcher yet. Invite one from Settings > Team.",
    "emptySelf": "You have no carriers assigned yet. An admin assigns them in Settings > Team.",
    "noApp": "No app",
    "on": "On",
    "search": "Search drivers",
    "searchPlaceholder": "Driver, carrier or phone…",
    "filters": {
      "dispatcher": "Dispatcher",
      "carrier": "Carrier"
    },
    "summary": "{{dispatchers}} · {{carriers}} · {{drivers}}",
    "tableLabel": "Drivers by dispatcher",
    "columns": {
      "driver": "Driver",
      "carrier": "Carrier",
      "truck": "Paired truck",
      "app": "App",
      "phone": "Phone",
      "now": "Now"
    },
    "noMatch": "No driver matches these filters.",
    "foot": {
      "drivers_one": "{{count}} driver",
      "drivers_other": "{{count}} drivers",
      "dispatchers_one": "{{count}} dispatcher",
      "dispatchers_other": "{{count}} dispatchers",
      "loose_one": "{{count}} carrier without a dispatcher",
      "loose_other": "{{count}} carriers without a dispatcher"
    },
    "n": {
      "carriers_one": "{{count}} carrier",
      "carriers_other": "{{count}} carriers",
      "drivers_one": "{{count}} driver",
      "drivers_other": "{{count}} drivers",
      "dispatchers_one": "{{count}} dispatcher",
      "dispatchers_other": "{{count}} dispatchers"
    }
  },
  "realtime": {
    "live": "Live",
    "liveTitle": "Changes appear here as they happen.",
    "polling": "Refreshing every 20 s",
    "pollingTitle": "The live connection is down: this view refreshes every 20 seconds.",
    "announce": "{{load}} is now {{status}}",
    "announceDocument": "{{kind}} arrived for {{load}}",
    "rejected": "{{driver}} declined {{load}}: {{reason}}",
    "rejectedNoReason": "{{driver}} declined {{load}}",
    "unknownDriver": "The driver",
    "openLoad": "Open load"
  },
  "dashboard": {
    "selectLoad": "Select a load on the board",
    "sampleBadge": "Sample data",
    "sampleBadgeTitle": "These figures are not from your data yet.",
    "detailTitle": "Load Details",
    "driverPick": {
      "label": "Driver",
      "placeholder": "Search a driver",
      "unassigned": "Unassigned",
      "loading": "Loading drivers…",
      "error": "Drivers could not be loaded.",
      "inFlight_one": "{{count}} in flight",
      "inFlight_other": "{{count}} in flight",
      "noneInFlight": "No load in flight",
      "noMatch": "No driver matches \"{{q}}\"",
      "count_one": "{{count}} driver",
      "count_other": "{{count}} drivers",
      "listLabel": "{{name}}'s loads in flight",
      "current": "Current",
      "nextStop": "Next: {{place}}",
      "noNextStop": "No stop left",
      "past": "Past load",
      "pastHelp": "{{name}} has no load in flight. This is the most recent one.",
      "looking": "Looking for {{name}}'s last load…",
      "noLoads": "{{name}} has no loads yet.",
      "lookupError": "We could not look up {{name}}'s last load. Pick the driver again to retry."
    },
    "openLoad": "Open load",
    "stopEnd": "{{kind}} · {{company}}",
    "docsCount": "{{count}} of {{total}}",
    "viewAllDocs": "View all"
  },
  "legal": {
    "checking": "Checking your agreement…",
    "error": "We could not check whether you accepted the Terms. Check your connection and try again.",
    "retry": "Try again",
    "title": "Review and accept to continue",
    "body": "Before you use the Coreway Portal, read the Terms of Service and the Privacy Policy.",
    "updated": "The Terms of Service or the Privacy Policy changed since you last accepted them.",
    "record": "When you accept, we keep the versions you accepted, the date, that it was in the Portal and the language.",
    "terms": "Terms of Service",
    "privacy": "Privacy Policy",
    "version": "Version {{version}}",
    "newTab": "(opens in a new tab)",
    "agree": "I have read and agree to the Terms of Service and I have read the Privacy Policy",
    "accept": "I agree",
    "accepting": "Saving…",
    "decline": "Decline and sign out"
  },
  "ownerFees": {
    "settings": {
      "title": "Fees and owner statements",
      "intro": "How the agency's percentage is computed, the defaults a new lease starts from, and how the weekly owner statements close. Each change applies to loads whose POD is marked received after it.",
      "readOnly": "Only the agency admin (or someone granted \"Edit fee settings\") changes these.",
      "noAccess": "Fee settings are visible to the admin and accounting.",
      "saved": "Fee settings saved",
      "save": "Save fee settings",
      "exampleLabel": "Example",
      "dispatchFeeBase": {
        "label": "What the agency's percentage applies to",
        "rule": "Linehaul plus TONU. Lumper and other reimbursements are never included."
      },
      "defaultLeaseCommissionPct": {
        "label": "Default commission on leased trucks",
        "help": "The percentage a carrier keeps from each load of a truck leased onto it, prefilled when you lease a truck. Each lease can have its own. The agency's fee is part of it, not added to it.",
        "example": "15% of a $2,400 linehaul = $360.00. With the agency at 5% ($120.00), the carrier keeps $240.00."
      },
      "defaultLeaseWeeklyInsurance": {
        "label": "Default weekly insurance per leased truck",
        "help": "Prefilled as the \"Insurance\" weekly charge of a new lease. Charged once for every week the lease touches, with or without loads; you can waive it on a draft statement. 0 means no default charge.",
        "example": "$250. A week with no loads: the statement shows -$250.00."
      },
      "ownerDeficitCarryForward": {
        "label": "Carry a negative week forward",
        "help": "When a final statement ends below zero (the truck owner owes the carrier), its balance opens the next statement. Off: each week stands alone and you collect the deficit outside Coreway.",
        "example": "Week 1: insurance only, -$250.00. Week 2: $1,275.00 of loads, -$250.00 insurance, -$250.00 balance: pays $775.00."
      },
      "ownerStatementsAutoFinalize": {
        "label": "Finalize owner statements automatically",
        "help": "Off (default): Friday's close leaves drafts for you to review, add the fuel card and finalize. On: Friday's close finalizes them; a statement with a disputed load stays a draft.",
        "example": "Off: OS-1001 waits as a draft on Friday morning."
      },
      "pctInvalid": "Enter a percentage from 0 to 100, at most two decimals.",
      "dispatchDetentionPct": {
        "label": "Agency percentage on detention",
        "help": "0 (the default, \"excluding accessorial\" in the dispatch agreement): no fee on detention. A change applies to fees earned after it.",
        "example": "Linehaul $2,000, detention $150, lumper $150, 5%: at 0% the agency bills $100.00; at 5% $107.50."
      },
      "defaultLeaseDetentionPct": {
        "label": "Default commission on detention (leased trucks)",
        "help": "Prefilled on new leases. 0 leaves detention entirely to the truck owner.",
        "example": "Detention $150 at 15%: $22.50 more commission."
      },
      "tonuDriverPay": {
        "label": "Driver pay on a TONU",
        "help": "\"Driver's plan\" pays each driver per his own plan on the TONU (an owner-operator keeps the TONU minus the commission; a percent-of-linehaul driver gets nothing). \"No driver pay\" leaves every TONU out of driver pay.",
        "example": "TONU $300, lease 15%: the owner-operator's share is $255.00.",
        "plan": "Driver's plan",
        "none": "No driver pay"
      }
    },
    "lease": {
      "title": "Lease",
      "loading": "Loading the lease",
      "error": "The lease could not be loaded.",
      "ownedByCarrier": "Owned by the carrier: no owner commission on its loads.",
      "noOwner": "This truck has no owner yet. Set the owner above and save before leasing it.",
      "ownerIsCarrierOwner": "Its owner also owns the carrier: a carrier's own truck is not leased on.",
      "leasedBy": "Leased by {{owner}} since {{date}}",
      "until": "until {{date}}",
      "commission": "Commission {{pct}}% of linehaul + TONU; detention {{detention}}%",
      "charges": "Weekly charges",
      "noCharges": "No weekly charge",
      "chargeLine": "{{label}}: {{amount}} a week",
      "notes": "Notes",
      "create": "Lease this truck",
      "edit": "Edit terms",
      "end": "End lease",
      "history": "Earlier leases",
      "historyLine": "{{from}} to {{to}} · {{owner}} · {{pct}}%",
      "open": "open",
      "marginWarning": "The commission ({{pct}}%) is below the agency's fee on this truck ({{fee}}%): the carrier would lose money on each load.",
      "pastStart_one": "{{date}} is in the past. Saving charges the commission on {{count}} load of this truck delivered since then with the POD received. It goes on the owner's next statement, and any truck net paid on it drops by the commission.",
      "pastStart_other": "{{date}} is in the past. Saving charges the commission on {{count}} loads of this truck delivered since then with the POD received. They go on the owner's next statement, and any truck net paid on them drops by the commission.",
      "pastStartNone": "{{date}} is in the past. No load of this truck delivered since then is waiting for a commission, so nothing new is charged now; loads whose POD is received later pay the commission.",
      "pastStartUnknown": "{{date}} is in the past. Saving charges the commission on this truck's loads delivered since then with the POD received. They go on the owner's next statement, and any truck net paid on them drops by the commission.",
      "dialog": {
        "createTitle": "Lease truck {{unit}}",
        "editTitle": "Edit the lease of truck {{unit}}",
        "description": "{{owner}} leases this truck onto {{carrier}}. The carrier keeps the commission of each load and pays the owner the rest every week.",
        "startsOn": "Starts on",
        "startsOnHelp": "Loads delivered on or after this date (agency time) pay the commission. An earlier date also charges loads already delivered.",
        "commissionPct": "Commission %",
        "chargesLabel": "Weekly charges",
        "chargesHelp": "Charged once for every week the lease touches, with or without loads.",
        "chargeLabel": "Charge",
        "chargeAmount": "Per week",
        "addCharge": "Add a charge",
        "removeCharge": "Remove {{label}}",
        "notes": "Notes",
        "save": "Save lease",
        "created": "Truck {{unit}} is now leased",
        "saved": "Lease saved",
        "appliesNote": "A new commission applies to loads marked received from now on; loads already frozen keep theirs.",
        "detentionPct": "Commission on detention %",
        "ruleNote": "The commission % applies to linehaul plus TONU; detention has its own %; lumper and other reimbursements go to the truck owner in full."
      },
      "endDialog": {
        "title": "End the lease of truck {{unit}}",
        "body": "Loads delivered after this date (agency time) no longer pay the commission, and the weekly charges stop after that week.",
        "endsOn": "Last day",
        "confirm": "End lease",
        "done": "Lease ended",
        "beforeStart": "The last day cannot be before the lease starts ({{date}})."
      },
      "notLeased": "Not leased yet: {{owner}} owns it. No owner commission until you lease it.",
      "notLeasedHiddenOwner": "Not leased yet: no owner commission until it is leased."
    },
    "statements": {
      "weekRule": "A load goes on the first Friday close (agency time, {{timeZone}}) after its POD is marked received.",
      "pendingNote": "Disputed loads are listed here and not counted until the dispute is cleared.",
      "noAccess": "Owner statements are visible to the admin and accounting.",
      "loading": "Loading owner statements",
      "error": "The owner statements could not be loaded.",
      "retry": "Try again",
      "empty": "No owner statement for this week yet. Statements are built every Friday for each leased truck.",
      "emptyFiltered": "No statement matches these filters.",
      "filters": {
        "week": "Week",
        "allWeeks": "All weeks",
        "carrier": "Carrier",
        "owner": "Leased owner",
        "status": "Status",
        "all": "All",
        "prevWeek": "Previous week",
        "nextWeek": "Next week",
        "later": "Carrier, owner and status filters appear once statements exist."
      },
      "columns": {
        "number": "Number",
        "week": "Week",
        "carrier": "Carrier",
        "lessor": "Leased owner",
        "trucks": "Trucks",
        "loads": "Loads",
        "gross": "Gross",
        "commission": "Commission",
        "charges": "Charges",
        "adjustments": "Adjustments",
        "net": "Net",
        "status": "Status"
      },
      "totals": "Totals",
      "pendingBadge": "{{count}} pending",
      "status": {
        "draft": "Draft",
        "final": "Final",
        "canceled": "Canceled"
      },
      "weekOf": "Week of {{date}}",
      "generate": {
        "action": "Generate statement",
        "title": "Generate an owner statement",
        "body": "Builds the draft of a carrier and a leased owner for one week, or refreshes it with what arrived since. The Friday close does this on its own.",
        "key": "Carrier and leased owner",
        "keyPick": "Choose a lease",
        "noKeys": "No truck is leased yet. Lease a truck from its sheet in Trucks.",
        "week": "Week (Monday)",
        "weekHelp": "Any day of the week works; the statement starts on its Monday.",
        "confirm": "Generate",
        "done": "Statement ready",
        "nothing": "Nothing to state for that week: no loads, no weekly charges, no balance.",
        "noKeysBefore": "No truck is leased yet. Lease a truck from its row menu in",
        "noKeysLink": "Trucks",
        "noKeysAfter": "(⋯ › Lease)."
      },
      "weekRange": "{{from}} – {{to}}",
      "goToTrucks": "Go to Trucks",
      "noLease": {
        "title": "No truck is leased to an owner yet.",
        "body": "A statement is built every Friday for each truck leased to an owner. Add the owner, then set the lease from the truck's row menu in Trucks."
      }
    },
    "statement": {
      "back": "All owner statements",
      "loading": "Loading the statement",
      "error": "The statement could not be loaded.",
      "notFound": "This statement does not exist or is not visible to you.",
      "header": "{{carrier}} pays {{owner}}",
      "weekRange": "Week of {{from}} to {{to}}",
      "sections": {
        "loads": "Loads",
        "charges": "Weekly charges",
        "adjustments": "Deductions and credits",
        "balanceForward": "Balance forward",
        "pending": "Pending (disputed)",
        "totals": "Totals",
        "nextStatement": "Earned after this statement's cut (goes on the next statement)"
      },
      "columns": {
        "load": "Load",
        "truck": "Truck",
        "delivered": "Delivered",
        "earned": "Earned",
        "gross": "Gross",
        "pct": "%",
        "commission": "Commission",
        "agencyFee": "Agency fee",
        "carrierMargin": "Carrier keeps",
        "amount": "Amount",
        "description": "Description",
        "reason": "Dispute"
      },
      "officeOnly": "Agency fee and carrier keeps are office only: they are not on the owner copy.",
      "none": "None",
      "waived": "Waived",
      "waive": "Waive",
      "restore": "Restore",
      "defer": "Move to next week",
      "deferHint": "A load moved off this draft goes on next week's statement.",
      "removeLine": "Remove",
      "addDeduction": "Add deduction",
      "addCredit": "Add credit",
      "formula": {
        "loads": "Loads (net of commission)",
        "charges": "Weekly charges",
        "adjustments": "Deductions and credits",
        "balanceForward": "Balance forward",
        "netPay": "Net: pay to {{owner}}",
        "netOwes": "Net: {{owner}} owes {{amount}}"
      },
      "actions": {
        "refresh": "Refresh",
        "finalize": "Finalize",
        "cancel": "Cancel statement",
        "print": "Print owner copy",
        "csv": "Export CSV"
      },
      "refreshed": "Statement refreshed",
      "finalizeDialog": {
        "title": "Finalize {{number}}?",
        "body": "A final statement no longer changes: to correct it later you cancel it and generate the week again. Net {{net}}.",
        "confirm": "Finalize",
        "done": "{{number}} is final"
      },
      "cancelDialog": {
        "title": "Cancel {{number}}?",
        "body": "Its lines are voided and its loads go back to be stated again. The number is not reused.",
        "confirm": "Cancel statement",
        "done": "{{number}} canceled"
      },
      "canceledNote": "Canceled: {{reason}}",
      "carriedNote": "Its balance is carried by a later statement.",
      "finalNote": "Final on {{date}}.",
      "lineDialog": {
        "deductionTitle": "Add a deduction",
        "creditTitle": "Add a credit",
        "description": "Description",
        "descriptionHelp": "What the owner reads, for example Fuel card or Advance repayment.",
        "amount": "Amount",
        "truck": "Truck",
        "anyTruck": "Not about one truck",
        "save": "Add",
        "done": "Line added"
      },
      "lineRemoved": "Line removed",
      "lineWaived": "Charge waived",
      "lineRestored": "Charge restored",
      "loadDeferred": "Load moved to next week",
      "editAmount": "Edit amount",
      "edited": "Edited, was {{amount}}",
      "amountDialog": {
        "body": "{{line}}. Type the amount without a sign; it stays a charge or a credit.",
        "reason": "Reason (optional)",
        "done": "Amount changed"
      },
      "pctWithLease": "{{pct}}% (lease {{lease}}%)",
      "tonuTag": "TONU",
      "nextStatementNote": "These loads earned their commission after this week's Friday 00:00 close ({{cut}}, agency time {{timeZone}}), or were moved to next week. They go on the next statement and are not counted here.",
      "nextStatementError": "The loads for the next statement could not be listed. Reload the page to try again.",
      "canceledOn": "Canceled {{date}}",
      "changeCommission": "Change commission"
    },
    "print": {
      "title": "Owner statement",
      "language": "Language",
      "from": "Paid by",
      "to": "Paid to",
      "period": "Week",
      "number": "Statement",
      "status": "Status",
      "print": "Print",
      "back": "Back to the statement",
      "generatedOn": "Printed on {{date}}"
    },
    "matrix": {
      "moneyOnly": "{{role}}: not available. Owner money is for the admin and accounting only."
    },
    "errors": {
      "truckNoOwner": "Set the truck's owner before leasing it.",
      "ownerInactive": "The truck's owner is inactive. Reactivate the owner first.",
      "overlap": "This truck already has a lease on those dates.",
      "loadsOutside": "A load of this lease was delivered outside those dates. Keep the dates around every delivered load.",
      "onFinalStatement": "This load is on a final owner statement. Cancel the statement first.",
      "notDraft": "Only a draft statement can be changed.",
      "disputedOnFinalize": "A load on this statement is disputed. Remove it or clear the dispute.",
      "cancelOrder": "A later statement carries this one's balance. Cancel that one first.",
      "weekFinal": "That week's statement is final. Cancel it first to build it again.",
      "alreadyCanceled": "This statement is already canceled.",
      "lineState": "That line already is in that state. Reload the statement.",
      "ownTruck": "A carrier's own truck is not leased on.",
      "weekNotMonday": "Pick a week that has started (this week or earlier).",
      "notLeased": "This load's truck is not leased onto the carrier.",
      "lineWaivedAmount": "Restore the line before changing its amount.",
      "lineNotEditable": "A load line follows its commission, and a balance forward can only be waived.",
      "commissionPct": "Enter a percentage from 0 to 100, at most two decimals."
    },
    "loadCommission": {
      "block": "Owner commission",
      "title": "This load's commission",
      "useLease": "Use the lease's ({{pct}}%)",
      "dialogBody": "The truck owner's commission on this load only. The lease's is {{pct}}%; the owner statement follows while it is a draft.",
      "leasePct": "Lease",
      "loadPct": "This load",
      "commission": "Commission",
      "estimated": "Estimated {{amount}}",
      "statement": "Statement",
      "noStatement": "Not on a statement yet",
      "notFrozen": "Estimated: the commission is fixed when the load earns its fee.",
      "onFinal": "On final statement {{number}}: cancel the statement to change it.",
      "set": "Set this load's commission",
      "pct": "Commission %",
      "reason": "Reason",
      "saved": "Commission saved"
    }
  },
  "reports": {
    "download": "Download CSV",
    "carrier": "Carrier",
    "allCarriers": "All carriers",
    "rule": "Loads delivered, and TONUs, from {{from}} to {{to}}. Days follow the agency's time zone ({{timeZone}}); weeks run Monday to Sunday.",
    "summary": "Totals for the period",
    "moneyHidden": "The agency fee, carrier revenue and invoices are visible to the admin and accounting.",
    "groupBy": "Group by",
    "tableLabel": "Revenue by {{group}}",
    "loading": "Loading the report…",
    "empty": "No delivered loads in this period.",
    "error": "The report could not be loaded.",
    "retry": "Try again",
    "total": "Total",
    "formerMember": "Former member",
    "unknown": "Unknown",
    "views": {
      "label": "Report",
      "summary": "Summary",
      "loads": "Load detail",
      "explore": "Explore",
      "weekly": "Weekly by driver"
    },
    "cutDay": {
      "label": "Week ends on",
      "days": {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday"
      }
    },
    "scope": {
      "label": "Loads",
      "completed": "Completed",
      "pending": "Pending",
      "all": "Completed and pending"
    },
    "dateBy": {
      "label": "Date by",
      "pickup": "Pickup",
      "completed": "Delivery",
      "help": {
        "pickup": "A load counts in the period of its first pickup, even if it was delivered later. Its status is the one it has now.",
        "completed": "Completed loads count in the period they were delivered (a TONU, when it was canceled). Pending loads are the ones still open now."
      }
    },
    "driver": "Driver",
    "allDrivers": "All drivers",
    "detail": {
      "tableLabel": "Loads by carrier and driver",
      "rule": "Loads from {{from}} to {{to}}. Days follow the agency's time zone ({{timeZone}}).",
      "pendingRule": "Pending: booked through in transit, with the first pickup before the end of the period (or not scheduled yet), shown with their status as of now.",
      "truncated": "Only the first 20,000 loads are shown. Shorten the period to see all of them.",
      "noDriver": "No driver assigned",
      "subtotalDriver_one": "Subtotal {{name}} · {{count}} load",
      "subtotalDriver_other": "Subtotal {{name}} · {{count}} loads",
      "subtotalCarrier_one": "Subtotal {{name}} · {{count}} load",
      "subtotalCarrier_other": "Subtotal {{name}} · {{count}} loads",
      "total_one": "Total · {{count}} load",
      "total_other": "Total · {{count}} loads",
      "empty": "No loads in this period.",
      "tonu": "TONU",
      "columns": {
        "loadNumber": "Load #",
        "status": "Status",
        "broker": "Broker",
        "pickup": "Pickup",
        "origin": "Origin",
        "delivery": "Delivered / Delivery",
        "destination": "Destination",
        "loadedMiles": "Loaded mi",
        "gross": "Gross",
        "agencyFee": "Dispatch fee",
        "carrierNet": "Carrier net",
        "agencyFeeEstimate": "Dispatch fee (estimated)",
        "carrierCut": "Carrier cut",
        "carrierCutPct": "Carrier %",
        "carrierCutEstimate": "Carrier cut (estimated)",
        "booked": "Booked",
        "route": "Route",
        "dates": "Pickup · Delivered",
        "tradingName": "Trading name"
      },
      "bucket": {
        "completed": "Completed",
        "pending": "Pending"
      },
      "rulePickup": "Loads picked up from {{from}} to {{to}}. Pickup days follow each stop's time zone, or the agency's ({{timeZone}}) when the stop has none.",
      "pendingRulePickup": "Pending: booked through in transit, picked up in the period, shown with their status as of now.",
      "estimated": "≈ {{amount}}",
      "estimatedTitle": "Estimated: the dispatch fee is earned when the POD is received",
      "estimateRule": "≈ marks an estimate: a load earns its dispatch fee when the POD is received. Until then the fee and the carrier net are worked out from the carrier's dispatch % and the rate, and totals show them on a second line, apart from what is already earned.",
      "carrierCutRule": "Carrier cut: what the carrier keeps, the lease commission minus your dispatch fee (for example 15% minus 5% leaves 10%). A truck without a lease is estimated from the agency default (Settings, Commissions); register the truck's lease to make it exact. A single load can carry its own commission.",
      "negativeCutTitle": "The estimate came out below zero: the carrier's dispatch % is above the agency default lease commission. Check the agency default in Settings, Commissions.",
      "estimateLegend": "≈ estimate until the POD",
      "rulesTitle": "How these loads are counted"
    },
    "export": {
      "label": "Export",
      "csv": "CSV (.csv)",
      "xlsx": "Excel (.xlsx)",
      "pdf": "PDF (.pdf)",
      "preparing": "Preparing the file…",
      "failed": "The file could not be created. Try again.",
      "metaCarrier": "Carrier: {{name}}",
      "metaDriver": "Driver: {{name}}",
      "metaScope": "Loads: {{scope}}",
      "metaDateBy": "Date by: {{basis}}",
      "metaStatuses": "Statuses: {{list}}"
    },
    "period": {
      "label": "Period",
      "this_week": "This week",
      "last_week": "Last week",
      "this_month": "This month",
      "last_month": "Last month",
      "work_week": "Work week",
      "last_work_week": "Last work week",
      "custom": "Custom range",
      "from": "From",
      "to": "To",
      "pickBoth": "Pick both a start and an end day.",
      "inverted": "The start day must be on or before the end day.",
      "tooLong": "A report covers at most two years."
    },
    "groups": {
      "carrier": "Carrier",
      "driver": "Driver",
      "truck": "Truck",
      "dispatcher": "Dispatcher",
      "broker": "Broker"
    },
    "unassigned": {
      "carrier": "No carrier",
      "driver": "No driver",
      "truck": "No truck",
      "dispatcher": "No dispatcher",
      "broker": "No broker"
    },
    "tiles": {
      "loads": "Loads (delivered + TONU)",
      "loadsSplit": "{{delivered}} delivered · {{tonu}} TONU",
      "gross": "Gross revenue",
      "rpm": "Avg. rate / mile",
      "rpmBase": "All miles, incl. deadhead",
      "loadedMiles": "Loaded miles",
      "deadheadMiles": "Deadhead miles",
      "deadheadPct": "{{pct}}% of total miles",
      "totalMiles": "Total miles",
      "agencyFee": "Dispatch fees",
      "carrierNet": "Carrier revenue",
      "invoicesIssued": "Invoiced",
      "invoicesPaid": "Received",
      "outstanding": "Outstanding",
      "overdue": "Overdue",
      "invoiceCount_one": "{{count}} invoice",
      "invoiceCount_other": "{{count}} invoices"
    },
    "columns": {
      "loads": "Loads",
      "trucks": "Trucks",
      "carriers": "Carriers",
      "gross": "Gross",
      "loadedMiles": "Loaded mi",
      "deadheadMiles": "Deadhead mi",
      "totalMiles": "Total mi",
      "rpmLoaded": "RPM (loaded)",
      "rpmTotal": "RPM (total)",
      "deadheadPct": "Deadhead %",
      "agencyFee": "Dispatch fee",
      "carrierNet": "Carrier net",
      "tradingName": "Trading name"
    },
    "basis": {
      "label": "Loads by",
      "activity": "Activity in the period",
      "booked": "Booked in the period",
      "delivered": "Delivered in the period",
      "help": {
        "activity": "Loads booked, picked up, delivered or canceled in the period, plus every load still open at its end.",
        "booked": "Only loads booked in the period (the first time they were booked; canceled included).",
        "delivered": "Only loads delivered in the period."
      }
    },
    "weekly": {
      "tableLabel": "Weekly loads by carrier and driver",
      "rule": "Loads booked {{from}} through {{to}} ({{timeZone}}), with the status they have now.",
      "help": "A load counts in the week it was booked, even if it was picked up or delivered later.",
      "empty": "No loads booked in this period with the selected statuses.",
      "hidden_one": "{{count}} more load hidden by the status filter.",
      "hidden_other": "{{count}} more loads hidden by the status filter.",
      "statuses": {
        "label": "Statuses",
        "reset": "Default statuses",
        "tonu": "Canceled (TONU)",
        "lastOne": "At least one status stays selected."
      }
    }
  },
  "dispatchPlan": {
    "menu": "Dispatch %",
    "carrierTitle": "Dispatch %",
    "truckTitle": "Dispatch % on this truck",
    "pct": "Dispatch %",
    "carrierHelp": "The agency's cut of this carrier's loads, applied when each POD is confirmed. Leave it empty if no plan is agreed yet; 0 means dispatched for free.",
    "truckHelp": "Overrides the carrier's {{pct}}% on this truck only. Leave it empty to use the carrier's.",
    "truckHelpNoCarrier": "Overrides the carrier's plan on this truck only. The carrier has no plan yet; leave it empty to follow the carrier's once it has one.",
    "carrierPlaceholder": "No plan",
    "truckPlaceholder": "Carrier's plan",
    "saved": "{{name}}: dispatch {{pct}}%",
    "removed": "{{name}}: dispatch plan removed",
    "readFailed": "Could not read the current plan. Close and try again."
  },
  "invoiceTiming": {
    "menu": "Invoice timing",
    "title": "Invoice timing",
    "label": "Bill loads in transit at the Friday close",
    "help": "By default the Friday close bills only loads whose POD was received, cut at Friday 00:00 ({{timeZone}}). Turn this on and the close also bills this carrier's loads already picked up (loaded, in transit or delivered without POD), marked provisional on the invoice. When the POD arrives, any difference in the fee goes on a later invoice as an adjustment. A load canceled after it was billed is credited, and a credit goes on the carrier's next invoice that has charges to offset it.",
    "exampleLabel": "Example",
    "example": "Friday 00:00: load 5512 was picked up Thursday and is still on the road. Its 8% commission, $160.00, goes on this Friday's invoice as provisional. The POD comes Monday with detention; the next invoice carries the difference.",
    "savedOn": "{{name}}: loads in transit are billed at the Friday close",
    "savedOff": "{{name}}: only loads with the POD received are billed at the Friday close",
    "readFailed": "Could not read the current setting. Close and try again.",
    "tag": "Bills in transit",
    "tagHelp": "Loads already picked up go on the Friday invoice as provisional."
  },
  "deductions": {
    "title": "Deductions",
    "help": "What comes out of his weekly settlement: recurring charges, one-off charges and advances he repays.",
    "readFailed": "Could not read his deductions.",
    "none": "No deductions yet.",
    "off": {
      "title": "Deductions are off for this driver",
      "what": "Deductions come out of the weekly settlement when your agency or an owner pays this driver.",
      "who": "Today his carriers pay him.",
      "action": "Open driver pay settings"
    },
    "kind": {
      "recurring": "Weekly",
      "one_off": "One-off",
      "advance": "Advance"
    },
    "kindOption": {
      "recurring": "Weekly (recurring)",
      "one_off": "One-off",
      "advance": "Advance (repaid in installments)"
    },
    "perWeek": "{{amount}} a week",
    "installment": "{{amount}} a week until repaid",
    "whole": "Taken whole on the next settlement",
    "recovered": "Recovered",
    "retired": "Retired",
    "owedAgency": "Owed to the agency",
    "owedOwner": "Owed to {{owner}}",
    "since": "from {{date}}",
    "between": "{{from}} to {{to}}",
    "withoutLoadsShort": "also in weeks without loads",
    "add": "Add deductions",
    "editLabel": "Edit {{label}}",
    "retire": "Retire",
    "retireLabel": "Retire {{label}}",
    "retireDialog": {
      "title": "Retire {{label}}?",
      "body": "It stops applying from the next settlement. The lines already on settlements stay as they are.",
      "optional": "Optional.",
      "done": "{{label}} retired."
    },
    "form": {
      "legend": "New deductions",
      "help": "One line per deduction. Start from the agency catalog or type it in.",
      "template": "From the catalog (line {{n}})",
      "templateNone": "Type it in",
      "kind": "Kind (line {{n}})",
      "label": "Label (line {{n}})",
      "amount": "Amount (line {{n}})",
      "amountWeekly": "Taken every week.",
      "amountTotal": "The total he owes.",
      "installment": "Installment (line {{n}})",
      "installmentHelp": "Taken each week. Empty takes the whole balance at once.",
      "installmentTooBig": "The installment cannot be more than the total.",
      "addLine": "Add a line",
      "removeLine": "Remove line {{n}}",
      "payer": "Owed to",
      "payerOption": {
        "agency": "The agency",
        "owner": "The truck owner"
      },
      "owner": "Owner",
      "ownerPick": "Pick the owner",
      "startsOn": "First week",
      "startsOnHelp": "The week holding this date is the first one charged (agency time, {{timeZone}}).",
      "withoutLoads": "Charge the weekly lines even in a week without loads",
      "save": "Save deductions",
      "saved_one": "{{count}} deduction added.",
      "saved_other": "{{count}} deductions added."
    },
    "editDialog": {
      "title": "Edit {{label}}",
      "body": "Changes apply from the next settlement. Lines already on settlements stay as they are.",
      "label": "Label",
      "weekly": "Weekly amount",
      "installment": "Installment",
      "endsOn": "Last week",
      "endsOnHelp": "Empty keeps it open.",
      "endsBeforeStart": "The last week cannot be before the first one.",
      "notes": "Notes",
      "done": "{{label}} saved."
    }
  },
  "driverSettlements": {
    "noAccess": "Driver settlements are visible to the admin and accounting.",
    "loading": "Loading driver settlements…",
    "error": "Could not load the driver settlements.",
    "empty": "No driver settlements this week.",
    "emptyFiltered": "No settlement matches these filters.",
    "cardsLabel": "Driver settlements",
    "totals": "Totals",
    "off": {
      "title": "Weekly driver settlements are off",
      "what": "Every week Coreway builds one settlement per driver with his loads and deductions, for you to review, finalize and pay.",
      "who": "For agencies that pay company drivers themselves, or for a truck owner. Today every carrier pays its own drivers.",
      "action": "Open driver pay settings",
      "perCarrier": "You can also choose who pays per carrier: Carriers › row menu › Driver pay."
    },
    "weekRule": {
      "4": "A week runs Monday to Sunday and closes on Friday 00:00 (agency time, {{timeZone}}). Loads earned after the close go on the next week.",
      "5": "A week runs Monday to Sunday and closes on Saturday 00:00 (agency time, {{timeZone}}). Loads earned after the close go on the next week.",
      "6": "A week runs Monday to Sunday and closes on Sunday 00:00 (agency time, {{timeZone}}). Loads earned after the close go on the next week.",
      "7": "A week runs Monday to Sunday and closes on the next Monday 00:00 (agency time, {{timeZone}})."
    },
    "status": {
      "draft": "Draft",
      "final": "Final",
      "paid": "Paid",
      "canceled": "Canceled"
    },
    "payer": {
      "agency": "Agency",
      "owner": "Truck owner"
    },
    "filters": {
      "week": "Week",
      "allWeeks": "All weeks",
      "payer": "Paid by",
      "driver": "Driver",
      "status": "Status",
      "all": "All"
    },
    "columns": {
      "number": "Number",
      "week": "Week",
      "driver": "Driver",
      "payer": "Paid by",
      "loads": "Loads",
      "deductions": "Deductions",
      "adjustments": "Adjustments",
      "balanceForward": "Balance forward",
      "net": "Net",
      "status": "Status"
    },
    "orphans": {
      "title": "Loads with no owner to pay the driver",
      "body": "These loads were earned on a carrier whose drivers the truck owner pays, but the truck has no owner on file, so the driver's share stayed with the carrier. Set the truck's owner so the next loads go on a settlement."
    },
    "generate": {
      "action": "Generate settlement",
      "title": "Generate a driver settlement",
      "body": "Builds the week's settlement for one driver, or adds what is new to its draft. The weekly close builds the rest on its own.",
      "driver": "Driver",
      "driverPick": "Pick a driver",
      "payer": "Paid by",
      "owner": "Owner",
      "ownerPick": "Pick the owner",
      "week": "Week",
      "weekHelp": "Any day of the week; the settlement covers Monday to Sunday (agency time, {{timeZone}}).",
      "weekFuture": "That week has not started yet.",
      "confirm": "Generate",
      "done": "Settlement ready.",
      "nothing": "Nothing to settle for that driver and week."
    },
    "how": {
      "perMile": "{{miles}} mi × ${{rate}}",
      "hourly": "{{hours}} h × ${{rate}}/h",
      "hourlyMissing": "Hours not entered yet (${{rate}}/h)",
      "flat": "Flat per load",
      "percent": "{{pct}}% of the linehaul",
      "percentAll": "{{pct}}% of the linehaul and accessorials",
      "truckNet": "Truck net"
    },
    "hours": {
      "label": "Hours on {{load}}",
      "saveLabel": "Save the hours of {{load}}",
      "invalid": "Above 0 and at most 200, with up to two decimals.",
      "saved": "Hours of {{load}} saved."
    },
    "page": {
      "back": "All driver settlements",
      "error": "Could not load this settlement.",
      "notFound": "This settlement does not exist or is not yours to see.",
      "byAgency": "{{driver}} · paid by the agency",
      "byOwner": "{{driver}} · paid by {{owner}}",
      "weekRange": "Week of {{from}} to {{to}}",
      "finalNote": "Finalized {{date}}.",
      "paidNote": "Paid on {{date}} by {{method}}",
      "paidNoteRef": "Paid on {{date}} by {{method}} · {{reference}}",
      "canceledNote": "Canceled: {{reason}}",
      "carriedNote": "Its negative balance went on a later settlement.",
      "refresh": "Refresh",
      "refreshed": "Settlement refreshed.",
      "finalize": "Finalize",
      "cancel": "Cancel settlement",
      "print": "Print",
      "csv": "Export CSV",
      "sections": {
        "loads": "Loads",
        "deductions": "Deductions",
        "adjustments": "Adjustments",
        "balanceForward": "Balance forward",
        "totals": "Totals",
        "reimbursements": "Reimbursements"
      },
      "none": "None.",
      "feeDisputed": "Fee disputed",
      "defer": "Move to next week",
      "deferred": "{{load}} moved to next week.",
      "stillOwed": "{{amount}} still owed after this one",
      "repaid": "Fully repaid with this one",
      "edited": "Edited, was {{amount}}",
      "editAmount": "Change amount",
      "waive": "Waive",
      "waived": "Line waived.",
      "waivedTag": "Waived",
      "restore": "Restore",
      "restored": "Line restored.",
      "remove": "Remove",
      "removed": "Adjustment removed.",
      "pendingPod_one": "Not in this week: {{count}} delivered load without POD.",
      "pendingPod_other": "Not in this week: {{count}} delivered loads without POD.",
      "pendingPodHelp": "Driver pay counts when the POD is received; they go to a later settlement.",
      "pendingPodLink": "See the loads",
      "reimbursementsHelp": "Lumper the driver paid, from the load's accessorials. Change it on the load."
    },
    "formula": {
      "loads": "Loads",
      "deductions": "Deductions",
      "adjustments": "Adjustments",
      "balanceForward": "Balance forward",
      "pay": "Pay {{driver}}",
      "deficit": "{{driver}} carries {{amount}} to next week",
      "reimbursements": "Reimbursements"
    },
    "finalize": {
      "title": "Finalize {{number}}?",
      "body": "Net {{net}}. A final settlement is frozen: its loads, deductions and amounts no longer change. Cancel it to correct it.",
      "done": "{{number}} finalized."
    },
    "cancel": {
      "title": "Cancel {{number}}?",
      "body": "Its loads and deductions go back to the next settlement. The number is never reused.",
      "confirm": "Cancel settlement",
      "done": "{{number}} canceled."
    },
    "markPaid": {
      "action": "Mark paid",
      "title": "Mark {{number}} paid",
      "body": "Record that the driver was paid {{net}}.",
      "paidOn": "Paid on",
      "paidOnHelp": "Agency time, {{timeZone}}.",
      "future": "The paid date cannot be in the future.",
      "method": "Method",
      "methodPick": "Pick a method",
      "reference": "Reference",
      "confirm": "Mark paid",
      "done": "{{number}} marked paid."
    },
    "unmark": {
      "action": "Unmark paid",
      "title": "Unmark {{number}} as paid?",
      "body": "The paid date, method and reference are cleared. The settlement stays final.",
      "done": "{{number}} is no longer marked paid."
    },
    "adjustment": {
      "action": "Add adjustment",
      "title": "Add an adjustment",
      "body": "A manual line on this draft: a bonus, a reimbursement, or something to take back.",
      "direction": "Direction",
      "add": "Add to his pay",
      "take": "Take from his pay",
      "description": "Description",
      "amount": "Amount",
      "confirm": "Add",
      "done": "Adjustment added."
    },
    "amount": {
      "body": "A new amount for {{line}} on this settlement only. The deduction itself does not change.",
      "reason": "Reason",
      "done": "Amount changed."
    },
    "errors": {
      "needsHours": "Enter the hours of load {{load}} before finalizing.",
      "feeDisputed": "The fee of load {{load}} is disputed: resolve it or move the load to next week before finalizing.",
      "unmarkFirst": "This settlement is marked paid: unmark it before canceling.",
      "carried": "A later settlement carries this one's balance: cancel {{number}} first.",
      "weekFinal": "That driver's settlement for the week is already final.",
      "notDraft": "Only a draft settlement can change.",
      "overRemaining": "That is more than what is still owed on this deduction.",
      "notHourly": "That load is not paid by the hour.",
      "onFinal": "This load is on a final driver settlement. Cancel the settlement first."
    },
    "print": {
      "back": "Back to the settlement",
      "language": "Copy language",
      "print": "Print",
      "title": "Driver settlement",
      "from": "From",
      "to": "To",
      "period": "Period",
      "description": "Description",
      "how": "How",
      "amount": "Amount",
      "generatedOn": "Generated on {{date}}."
    }
  },
  "payPlan": {
    "title": "Pay plan",
    "help": "How this driver is paid on each carrier he drives for. It applies to loads whose POD is confirmed from now on.",
    "noSeats": "He holds no active seat, so there is no plan to set.",
    "readFailed": "Could not read his pay plan.",
    "kindLabel": "Pay plan on {{carrier}}",
    "saveLabel": "Save the pay plan on {{carrier}}",
    "saved": "Pay plan on {{carrier}} saved",
    "defaultIs": "{{pct}}% of {{base}}",
    "defaultUnset": "the agency's default percent",
    "base": {
      "linehaul": "linehaul",
      "linehaul_accessorial": "linehaul plus accessorials"
    },
    "kind": {
      "default": "Agency default ({{value}})"
    },
    "explain": {
      "default": "He gets the agency default: {{value}}."
    }
  },
  "company": {
    "gaps": {
      "payment": "Your invoices have no payment instructions yet.",
      "address": "Your invoices have no company address yet.",
      "both": "Your invoices have no payment instructions and no company address yet.",
      "fixInSettings": "Add them in Settings > Company",
      "fixBelow": "Invoices still go out without them. Add them below."
    },
    "title": "Company details on invoices",
    "help": "What your carriers and brokers see on every invoice Coreway sends for you.",
    "noAccess": "The company details are for the admin and accounting only.",
    "readOnly": "Only the agency admin can change these details.",
    "saved": "Company details saved",
    "loadError": "The company details could not be loaded.",
    "defaultNote": "Nothing saved yet: invoices print only {{name}}.",
    "sections": {
      "identity": "Name and address",
      "contact": "Contact and authority",
      "payment": "Payment"
    },
    "fields": {
      "legalName": "Legal name",
      "legalNameHelp": "Printed at the top of every invoice. Empty: {{name}}.",
      "billingEmail": "Billing email",
      "billingEmailHelp": "Carriers reply to this address.",
      "paymentInstructions": "How to pay you",
      "paymentInstructionsHelp": "Printed on every weekly invoice. Example: Zelle to billing@youragency.com, or bank, routing and account.",
      "invoiceNote": "Note under the totals",
      "invoiceNoteHelp": "Terms or a thank you line, printed under the totals of the weekly invoice."
    },
    "logo": {
      "title": "Logo",
      "upload": "Upload logo",
      "replace": "Replace logo",
      "remove": "Remove logo",
      "rules": "PNG or JPEG, 1 MB at most.",
      "uploadFirst": "Upload the logo first (PNG or JPEG, 1 MB at most).",
      "alt": "Company logo",
      "none": "No logo yet. Invoices print your name instead.",
      "uploaded": "Logo updated",
      "removed": "Logo removed"
    }
  },
  "delivery": {
    "title": "Invoice delivery",
    "saved": "Saved",
    "exampleLabel": "Example",
    "autoSend": {
      "label": "Email invoices at the Friday close",
      "help": "Each carrier gets its invoice as a PDF at its billing email. Carriers without an email get a task instead. The close bills loads whose POD was received; carriers set to bill in transit (Carriers, row menu, Invoice timing) also get their loads already picked up.",
      "example": "Friday at midnight, Panthers Freight gets INV-1004 at its billing email; a carrier with no email gets a task for the office."
    },
    "locale": {
      "label": "Default document language",
      "help": "Used when a carrier has no language of its own.",
      "example": "A carrier set to Spanish gets its invoice in Spanish whatever this says; the others get this language."
    },
    "locales": {
      "en": "English",
      "es": "Spanish"
    }
  },
  "billing": {
    "title": "Plan and billing",
    "intro": "What Coreway charges this agency each month, sized by its active trucks.",
    "noAccess": "Plan and billing are for the agency admin, or a role the admin allows.",
    "loadError": "Could not load the plan and billing.",
    "fields": {
      "plan": "Plan",
      "status": "Status",
      "trucks": "Active trucks",
      "band": "Band for the next renewal",
      "price": "Price",
      "renewal": "Next renewal",
      "trial": "Trial",
      "graceEnds": "Pay by"
    },
    "perMonth": "{{amount}} per month",
    "trucksValue": "{{now}} now, {{peak}} at the peak of this period",
    "capUsage": "{{now}} of the {{cap}} active trucks your plan covers",
    "capReached": "Your plan covers up to {{cap}} active trucks. Contact us for an Enterprise plan to add more.",
    "bandRange": "{{name}} ({{min}} to {{max}} trucks)",
    "bandFrom": "{{name}} ({{min}} trucks or more)",
    "nextPrice": "From the next renewal: {{band}} at {{amount}} per month",
    "noPlanYet": "Set when the agency subscribes",
    "trialLeft_one": "{{count}} day left, until {{date}}",
    "trialLeft_other": "{{count}} days left, until {{date}}",
    "endsOn": "Ends on {{date}}, canceled at the end of the period",
    "pendingChange": "A new price takes effect at the first renewal after {{date}}.",
    "comp": "Coreway does not charge this agency.",
    "trialFree": {
      "headline": "Your free trial runs until {{date}}.",
      "body": "You'll be asked for a card when it ends. Nothing to do now.",
      "price": "After the trial: {{band}} at {{amount}} per month for your active trucks.",
      "subscribeHelp": "Optional. You can subscribe now to keep the plan without a break."
    },
    "confirm": {
      "title": "Before you go to Stripe",
      "price": "{{band}} at {{amount}} per month.",
      "deferred": "Your card is not charged until {{date}}. Your trial stays free until then.",
      "now": "Your trial ends in less than two days, so Stripe charges the first month today.",
      "continue": "Continue to Stripe",
      "cancel": "Not now"
    },
    "subscribe": "Subscribe and add a card",
    "subscribeHelp": "Opens the secure payment page of Stripe, the payment processor Coreway uses.",
    "manage": "Manage billing",
    "manageHelp": "Change the card, download receipts or cancel the plan on the Stripe billing page.",
    "opening": "Opening the payment page…",
    "invoices": {
      "title": "Invoices",
      "empty": "No invoices yet.",
      "number": "Number",
      "period": "Period",
      "total": "Total",
      "status": "Status",
      "link": "Invoice",
      "view": "View",
      "viewAria": "View invoice {{number}}",
      "periodRange": "{{from}} to {{to}}",
      "noNumber": "Not numbered yet"
    },
    "status": {
      "trialing": "Free trial",
      "trial_expired": "Trial ended",
      "active": "Active",
      "past_due": "Past due",
      "suspended": "Suspended",
      "canceled": "Canceled",
      "comp": "Complimentary"
    },
    "invoiceStatus": {
      "draft": "Draft",
      "open": "Open",
      "paid": "Paid",
      "void": "Void",
      "uncollectible": "Uncollectible"
    },
    "pastDue": {
      "label": "Payment past due",
      "banner": "The payment for {{agency}} is past due. Pay {{amount}} by {{date}} to keep access.",
      "bannerNoAmount": "The payment for {{agency}} is past due. Pay by {{date}} to keep access.",
      "bannerShort": "The payment for {{agency}} is past due. Pay it to keep access.",
      "payNow": "Pay now",
      "open": "Open billing"
    },
    "errors": {
      "notAllowed": "Only the agency admin, or a role the admin allows, can manage billing.",
      "checkoutOff": "Subscribing from the portal is not open yet. Coreway will send you a payment link.",
      "notCharged": "Coreway does not charge this agency, so there is nothing to pay.",
      "alreadySubscribed": "This agency already has a subscription. Use Manage billing to change the card.",
      "notOpenYet": "Subscriptions are not open yet. Coreway will write to you when they are.",
      "checkoutPending": "A payment page is already being prepared. Wait a minute and try again.",
      "portalOff": "The billing page is not open yet. Write to Coreway support to change the card or pay.",
      "noCustomer": "This agency has no card on file yet. Subscribe first.",
      "selfSignupOff": "Creating an agency from here is not open yet.",
      "verifiedEmail": "Confirm your email address before you create an agency.",
      "alreadyCreated": "This account already created an agency.",
      "timeZone": "Choose the agency's time zone.",
      "prefix": "The load number prefix must be 2 to 5 letters or digits.",
      "requestFailed": "The payment page could not be opened. Try again in a minute.",
      "requestTimeout": "The payment page is taking too long to open. Try again in a minute.",
      "captchaRequired": "The security check expired or was already used. Complete it again and retry.",
      "dailyLimit": "Too many agencies were created today. Try again tomorrow, or write to Coreway support.",
      "captchaFailed": "The security check did not pass. Complete it again and retry.",
      "captchaUnavailable": "The security check is not available right now. Try again in a few minutes."
    }
  },
  "dunning": {
    "title": "Overdue reminders",
    "saved": "Saved",
    "label": "Send the carrier a reminder when a weekly invoice is overdue",
    "help": "Off by default. When on, a carrier whose weekly invoice is past due gets a short, polite email with the amount, the due date and the invoice attached (how to pay is on it). At most two reminders per invoice; they stop as soon as the invoice is paid or voided. The office task for overdue invoices comes either way.",
    "firstDay": "First email",
    "secondDay": "Second email",
    "daysHelp": "Whole days, 1 to 60, counted in the agency's time zone. The second comes after the first. Turned on for an invoice already late, the carrier gets one reminder, not both.",
    "example": "An invoice due Monday: the carrier gets a reminder {{first}} day(s) later and another {{second}} days after the due date, unless it is paid first.",
    "secondAfterFirst": "The second reminder must come after the first.",
    "daysTitle": "First and second reminder",
    "daysUnit": "days after due",
    "save": "Save reminder days"
  },
  "dispatcherPay": {
    "basis": {
      "pct_of_fee": "% of the dispatch fee",
      "pct_of_gross": "% of the load gross",
      "flat_per_load": "Flat per load",
      "weekly_salary": "Weekly salary"
    },
    "basisHelp": {
      "pct_of_fee": "A share of the agency's fee on each load the dispatcher runs. The most common plan.",
      "pct_of_gross": "A share of the load's gross (linehaul plus extras) on each load the dispatcher runs.",
      "flat_per_load": "The same dollar amount for every load the dispatcher runs.",
      "weekly_salary": "A fixed amount per week, counted day by day while the plan is in force."
    },
    "plan": {
      "title": "Pay",
      "basis": "Pay basis",
      "newBasis": "Change the plan",
      "noPlan": "No plan",
      "none": "No pay",
      "noPlanYet": "No pay plan yet.",
      "ratePct": "Percentage",
      "rateAmount": "Amount",
      "effectiveFrom": "Starts on",
      "effectiveHelp": "Today or later. Loads already earned keep the rate they were paid with.",
      "noBackdate": "A plan change starts today or later.",
      "save": "Save plan",
      "saved": "Pay plan saved.",
      "history": "Plan history",
      "startsOn": "From {{date}}: {{plan}}",
      "line": {
        "pct_of_fee": "{{rate}} of the dispatch fee",
        "pct_of_gross": "{{rate}} of the load gross",
        "flat_per_load": "{{rate}} per load",
        "weekly_salary": "{{rate}} per week"
      }
    },
    "invite": {
      "title": "Pay plan",
      "help": "Starts the day they join. Leave it as No plan to use the agency default."
    },
    "settings": {
      "title": "Dispatcher pay",
      "intro": "How the agency pays its dispatchers. The plan pickers offer only the bases you use here; turning one off never changes a plan already given.",
      "bases": "Pay bases the agency uses",
      "atLeastOne": "Keep at least one basis.",
      "default": "Default plan for new dispatchers",
      "defaultHelp": "Given to a dispatcher invited without a plan, from the day they join.",
      "defaultOff": "The default plan uses a basis that is turned off.",
      "saved": "Dispatcher pay settings saved."
    },
    "columns": {
      "dispatcher": "Dispatcher",
      "week": "Week of",
      "loads": "Loads",
      "commission": "Commission",
      "held": "Held",
      "salary": "Salary",
      "earned": "Earned",
      "paid": "Paid",
      "balance": "Balance",
      "actions": "Actions"
    },
    "summary": {
      "earned": "Earned",
      "paid": "Paid",
      "balance": "Balance",
      "held": "Held (fee disputed)"
    },
    "filters": {
      "range": "Weeks",
      "lastWeeks_one": "Last week",
      "lastWeeks_other": "Last {{count}} weeks",
      "dispatcher": "Dispatcher",
      "all": "All dispatchers"
    },
    "empty": "No pay earned in these weeks.",
    "emptyOwn": "Nothing earned in these weeks.",
    "ownOnly": "You see your own pay only.",
    "week": {
      "range": "Week of {{from}} to {{to}}",
      "loads": "Loads",
      "noLoads": "No loads this week.",
      "held": "Held: the dispatch fee is disputed",
      "payments": "Payments",
      "noPayments": "No payments yet."
    },
    "record": {
      "action": "Mark paid",
      "actionFor": "Mark {{name}} paid for the week of {{week}}",
      "title": "Pay {{name}}",
      "description": "Week of {{week}}. Balance {{balance}}.",
      "amount": "Amount",
      "amountHelp": "Less than the balance is a partial payment.",
      "paidOn": "Paid on",
      "method": "Method",
      "note": "Note",
      "submit": "Record payment",
      "saved": "Payment recorded."
    },
    "reverse": {
      "action": "Reverse",
      "reason": "Reason",
      "confirm": "Reverse payment",
      "saved": "Payment reversed.",
      "reversed": "Reversed: {{reason}}"
    },
    "method": {
      "ach": "ACH",
      "check": "Check",
      "zelle": "Zelle",
      "cash": "Cash",
      "wire": "Wire",
      "other": "Other"
    },
    "matrixMoneyOnly": "{{role}}: not available. Dispatcher pay is for the admin and accounting only.",
    "noPlans": {
      "title": "No dispatcher has a pay plan yet",
      "body": "Pay appears here week by week once a dispatcher has a plan (percent of the fee, percent of the gross, flat per load or weekly salary).",
      "team": "Set a plan in Team",
      "settings": "Dispatcher pay settings"
    },
    "rangeLine": "{{from}} to {{to}} · agency time",
    "totalsLabel": "Totals",
    "totalsScope_one": "Totals · last week · {{scope}}",
    "totalsScope_other": "Totals · last {{count}} weeks · {{scope}}",
    "total": "Total"
  },
  "driverPay": {
    "matrixMoneyOnly": "{{role}}: not available. Driver pay is for the admin and accounting only.",
    "moneyOnly": "Driver pay is visible to the admin and accounting only.",
    "readFailed": "Could not read the driver pay settings.",
    "kind": {
      "percent": "Percent of the load",
      "per_mile": "Per mile",
      "flat": "Flat per load",
      "hourly": "Hourly",
      "truck_net": "Truck net (owner-operator)",
      "unknown": "Unknown kind"
    },
    "base": {
      "linehaul": "Linehaul",
      "linehaul_accessorial": "Linehaul plus accessorials"
    },
    "milesBase": {
      "loaded": "Loaded miles",
      "loaded_deadhead": "Loaded plus empty miles"
    },
    "fields": {
      "pct": "Driver percentage",
      "base": "Percentage of",
      "milesBase": "Miles paid",
      "rate": {
        "per_mile": "Rate per mile",
        "flat": "Amount per load",
        "hourly": "Rate per hour"
      }
    },
    "pct": {
      "invalid": "Enter a percentage from 0 to 100."
    },
    "rate": {
      "required": "Enter the rate.",
      "invalid": "Enter a number with up to {{decimals}} decimals.",
      "range": "Up to {{max}}."
    },
    "example": {
      "load": "On a 1,200 mi, $3,000 load this driver earns {{amount}}.",
      "deadhead": "On a 1,200 mi load with 150 empty miles, $3,000, this driver earns {{amount}}.",
      "hourly": "On a load that takes 10 hours this driver earns {{amount}}.",
      "truckNet": "This driver keeps the carrier net of each load (on a leased truck, minus the owner commission).",
      "incomplete": "Enter the rate to see what a load pays."
    },
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "weekdayShort": {
      "1": "Mon",
      "2": "Tue",
      "3": "Wed",
      "4": "Thu",
      "5": "Fri",
      "6": "Sat",
      "7": "Sun"
    },
    "whoPays": {
      "title": "Who pays the driver",
      "intro": "Choose who pays your drivers. It applies to every carrier unless you set an exception on the carrier.",
      "carrier": {
        "title": "Carrier",
        "description": "The carrier pays its drivers. Coreway shows each driver what he earned and when; no settlement."
      },
      "agency": {
        "title": "Agency",
        "description": "Your agency pays the drivers. Every week Coreway builds a settlement per driver with his loads and deductions for you to review and pay."
      },
      "owner": {
        "title": "Owner",
        "description": "The truck owner pays the driver. Coreway prepares the weekly settlement in the owner's name."
      },
      "noExceptions": "Every carrier follows this choice. Set an exception for one carrier from",
      "exceptions_one": "{{count}} carrier has its own choice. See it in",
      "exceptions_other": "{{count}} carriers have their own choice. See them in",
      "carriersLink": "Carriers",
      "changeNote": "From the next delivered load on, Coreway records the new payer. Loads already delivered keep the payer they had.",
      "save": "Save who pays",
      "saved": "Saved who pays the drivers."
    },
    "defaults": {
      "title": "Default driver pay",
      "intro": "What a driver earns when he has no pay plan of his own. Change one driver from his sheet in Drivers.",
      "kind": "Default pay",
      "unknownKind": "This agency's default pay is set in a newer version of Coreway. Reload the page to see it, or choose a kind to replace it.",
      "payDays": "Pay days",
      "payDaysHelp": "A load is paid on the first pay day on or after its POD is confirmed.",
      "atLeastOneDay": "Pick at least one pay day.",
      "cutoff": "Quick pay cutoff",
      "cutoffHelp": "A quick pay asked before this time (your agency's time zone) is paid the same day; after it, the next day.",
      "cutoffInvalid": "Enter a time.",
      "seeGross": "Drivers see the load gross",
      "seeGrossHelp": "Off: the driver app shows his pay without the broker rate.",
      "seeDeductionNotes": "Drivers see deduction notes",
      "seeDeductionNotesHelp": "Off: the driver sees each deduction and its balance, not the office note or why it was retired. On: he sees both.",
      "save": "Save defaults",
      "saved": "Default driver pay saved."
    },
    "settlements": {
      "offTitle": "Weekly driver settlements are off",
      "offWhat": "Weekly settlements run only for drivers your agency or an owner pays.",
      "offWho": "Today the carriers pay their drivers, so there is nothing to settle here.",
      "offAction": "Choose who pays",
      "title": "Weekly driver settlements",
      "intro": "Every week Coreway builds one settlement per driver your agency or an owner pays: his loads, minus his deductions.",
      "cut": "Close the week on",
      "cutHelp": "Loads delivered before this moment (your agency's time zone) go in that week's settlement.",
      "cutOption": {
        "4": "Friday at 12:00 AM",
        "5": "Saturday at 12:00 AM",
        "6": "Sunday at 12:00 AM",
        "7": "Monday at 12:00 AM"
      },
      "auto": "Finalize automatically",
      "autoHelp": "Off: each settlement waits as a draft until someone reviews and finalizes it.",
      "carry": "Carry a negative balance to next week",
      "carryHelp": "When deductions are larger than the loads, the difference comes out of the next settlement.",
      "save": "Save settlement rules",
      "saved": "Settlement rules saved."
    },
    "catalog": {
      "title": "Deductions catalog",
      "intro": "Deductions your agency reuses on drivers, with a default amount. They come out of weekly settlements, so they only apply to drivers your agency or an owner pays.",
      "readFailed": "Could not read the deductions catalog.",
      "empty": "No deductions in the catalog yet. Start from a common one:",
      "emptyReadOnly": "No deductions in the catalog yet.",
      "legend": "Deductions",
      "label": "Name",
      "kindLabel": "Kind",
      "amount": "Default amount",
      "kind": {
        "recurring": "Every week",
        "one_off": "Once",
        "advance": "Advance (paid back)"
      },
      "suggestion": {
        "insurance": "Insurance",
        "escrow": "Escrow",
        "leasePurchase": "Lease purchase",
        "advance": "Advance"
      },
      "addSuggestion": "Add {{label}}",
      "add": "Add a deduction",
      "remove": "Remove {{label}}",
      "unnamed": "this deduction",
      "labelInvalid": "Name it (up to 60 characters).",
      "save": "Save catalog",
      "saved": "Deductions catalog saved."
    },
    "payer": {
      "menu": "Driver pay…",
      "title": "Who pays the drivers",
      "readFailed": "Could not read who pays the drivers of this carrier.",
      "inherit": "Agency default ({{value}})",
      "inheritHelp": "Follows Settings > Driver pay, and changes when the agency default changes.",
      "saved": "Saved who pays the drivers of {{name}}.",
      "badge": {
        "agency": "Agency pays drivers",
        "owner": "Owner pays drivers"
      }
    },
    "summary": {
      "perMileLoaded": "{{rate}} a loaded mile",
      "perMileAll": "{{rate}} a mile, loaded plus empty",
      "flat": "{{amount}} a load",
      "hourly": "{{amount}} an hour"
    },
    "plan": {
      "unknownNote": "This plan uses a kind this version of Coreway does not know. Reload the page to see it, or choose another kind to replace it."
    },
    "baseLumperHelp": "Accessorials include the lumper. A driver on this base already earns his percentage of it; a lumper he paid himself is reimbursed in full on top (settlement)."
  },
  "factoring": {
    "title": "Factoring companies",
    "intro": "The companies your carriers sell their broker invoices to. A carrier picks one in its sheet; the broker invoice of a factored load tells the broker to pay it.",
    "new": "New factoring company",
    "createTitle": "New factoring company",
    "editTitle": "Edit factoring company",
    "saved": "Factoring company saved",
    "created": "Factoring company created",
    "sections": {
      "company": "Company and remit-to",
      "noa": "Notice of assignment",
      "notes": "Notes",
      "fee": "Fee"
    },
    "noaHelp": "Tick it when you hold the signed NOA that tells brokers to pay this company.",
    "col": {
      "name": "Company",
      "remitTo": "Remit to",
      "noa": "NOA",
      "carriers": "Carriers",
      "status": "Status",
      "actions": "Actions",
      "fee": "Fee %"
    },
    "empty": "No factoring companies yet. Add the first one to pick it on a carrier.",
    "emptyReadOnly": "No factoring companies yet.",
    "noAddress": "No address yet",
    "noaOnFile": "On file",
    "noaOnFileSince": "On file since {{date}}",
    "noaMissing": "Not on file",
    "active": "Active",
    "inactive": "Inactive",
    "deactivate": "Deactivate",
    "reactivate": "Reactivate",
    "deactivated": "Factoring company deactivated",
    "reactivated": "Factoring company reactivated",
    "deactivateTitle": "Deactivate {{name}}?",
    "deactivateBody": "It leaves the list carriers pick from. Invoices already issued keep printing it. A company still assigned to an active carrier cannot be deactivated.",
    "errors": {
      "notFound": "That factoring company no longer exists. Reload the page.",
      "inactive": "That factoring company is inactive. Reactivate it in Settings > Factoring or pick another.",
      "duplicate": "A factoring company with this name already exists.",
      "assigned": "Still assigned to {{count}} active carrier(s). Pick another factoring company on them first.",
      "noaFuture": "The NOA date cannot be in the future."
    },
    "feeValue": "{{pct}} %",
    "feeHelp": "What this factor keeps from each invoice it buys, in percent (up to 3 decimals). Information only: Coreway shows an estimate on factored receivables; it never changes the balance or your dispatch fee."
  },
  "brokerReport": {
    "title": "Broker report",
    "open": "Report",
    "openHint": "Open the printable broker report",
    "loading": "Loading the report…",
    "error": "The report could not be read.",
    "notFound": "This broker is not in your agency, or it was deleted.",
    "backToBrokers": "Back to brokers",
    "back": "Back",
    "print": "Print",
    "knownAs": "Known in Coreway as {{name}}",
    "date": "Date",
    "currency": "Currency",
    "by": "By",
    "riskScore": "Risk score",
    "noScore": "No score",
    "recordCheck": "Record a credit check",
    "scoreFrom": "{{source}} check of {{date}}",
    "lastCheck": "Latest check: {{source}}, {{value}}, {{date}}",
    "band": {
      "high": "High risk",
      "med": "Medium risk",
      "low": "Low risk"
    },
    "bandRisk": {
      "high": "High risk",
      "med": "Medium risk",
      "low": "Low risk"
    },
    "identity": "Broker details",
    "address": "Address",
    "phone": "Phone",
    "email": "Email",
    "loads": "Your loads with this broker",
    "noFmcsa": "FMCSA has not been checked for this broker yet.",
    "ledger": "Payment history (your carriers)",
    "noInvoices": "No invoice to this broker yet: the charts start with the first one.",
    "noMoneyRole": "Your role does not show receivables, so the money figures and the balance and days-to-pay charts are left out.",
    "kpi": {
      "invoiced": "Invoiced",
      "invoices_one": "{{count}} invoice",
      "invoices_other": "{{count}} invoices",
      "received": "Received",
      "closed_one": "{{count}} closed",
      "closed_other": "{{count}} closed",
      "outstanding": "Outstanding",
      "open_one": "{{count}} open",
      "open_other": "{{count}} open",
      "avgDays": "Avg days to pay",
      "lastPaid": "Last paid {{date}}",
      "overdue": "Overdue",
      "shortPays": "Short pays",
      "disputes": "Disputes"
    },
    "trends": "Trends, last {{count}} months",
    "balanceTitle": "Balance in dollars",
    "balanceHelp": "What this broker still owed your carriers at each month end",
    "daysTitle": "Days to pay",
    "daysHelp": "Average days from invoice to payment, by month paid",
    "scoreTitle": "Score history",
    "scoreHelp": "The latest credit check score of each month",
    "noScores": "No credit check with a score in these months.",
    "noPayments": "No invoice paid in these months.",
    "noScoreMonth": "No score",
    "noPaymentMonth": "No payment",
    "daysValue_one": "{{count}} day",
    "daysValue_other": "{{count}} days",
    "checksInMonth_one": "{{count}} check this month",
    "checksInMonth_other": "{{count}} checks this month",
    "invoicedInMonth_one": "{{count}} invoice this month, {{amount}}",
    "invoicedInMonth_other": "{{count}} invoices this month, {{amount}}",
    "closedInMonth_one": "{{count}} invoice paid",
    "closedInMonth_other": "{{count}} invoices paid",
    "theAgency": "the agency",
    "disclaimer": "Built from {{agency}}'s own records in Coreway: its credit checks, its FMCSA lookups and the invoices of its carriers. It is not a credit bureau report. A good score does not guarantee payment by this broker, now or in the future.",
    "plotLabel": "{{title}}, last {{count}} months. Use the left and right arrow keys to move between months.",
    "tableMonth": "Month",
    "tableValue": "Value"
  },
  "announcements": {
    "label": "Announcements from Coreway",
    "dismiss": "Dismiss this announcement",
    "dismissFailed": "Could not dismiss the announcement. It is back on screen; try again.",
    "kind": {
      "info": "Notice",
      "maintenance": "Scheduled maintenance",
      "terms": "Terms update",
      "pricing": "Pricing",
      "release": "What's new"
    },
    "activeUntil": "{{start}} · active until {{end}}",
    "endedOn": "{{start}} · ended {{end}}",
    "unread": "Unread",
    "markRead": "Mark as read",
    "markReadFailed": "Could not mark the announcement as read. Try again.",
    "page": {
      "title": "Announcements",
      "blurb": "Everything the Coreway team sent you: news, maintenance windows, and changes to terms and prices. Read or not, it stays here.",
      "tabs": "Show",
      "all": "All",
      "unread": "Unread",
      "markAll": "Mark all as read",
      "markAllDone": "All announcements marked as read.",
      "markAllFailed": "Some announcements could not be marked as read. Try again.",
      "emptyTitle": "No announcements yet",
      "empty": "News, maintenance windows and changes to terms from the Coreway team show up here.",
      "emptyUnreadTitle": "You are all caught up",
      "emptyUnread": "Every announcement is read. The All tab keeps them.",
      "error": "The announcements could not be loaded.",
      "retry": "Try again",
      "loadMore": "Show older announcements",
      "loading": "Loading announcements"
    },
    "button": {
      "label": "Announcements",
      "unread_one": "Announcements, {{count}} unread",
      "unread_other": "Announcements, {{count}} unread"
    }
  },
  "activity": {
    "kinds": {
      "load_events": {
        "created": "Load created",
        "transition": "Status changed to {{status}}",
        "declined": "Driver declined the load",
        "unassigned": "Load taken back from the driver",
        "updated": "Load details edited",
        "repriced": "Load repriced",
        "stop_added": "Stop added: {{stop}}",
        "stop_removed": "Stop removed: {{stop}}",
        "stop_rescheduled": "Appointment changed at {{stop}}",
        "stop_arrived": "Arrived at {{stop}}",
        "stop_departed": "Left {{stop}}",
        "document_added": "Document uploaded",
        "document_replaced": "Document replaced",
        "document_archived": "Document archived",
        "document_invoice_flag": "Receipt marked for the broker invoice",
        "fee_disputed": "Fee disputed",
        "fee_dispute_cleared": "Fee dispute cleared",
        "quick_pay_requested": "Quick pay requested",
        "fee_reversed": "Fee reversed",
        "pod_reminder_sent": "POD reminder sent to the driver",
        "stop_restamped": "Corrected a time at {{stop}}",
        "accessorial_changed": "Accessorial changed"
      },
      "activity_log": {
        "load": {
          "updated": "Load edited",
          "priced": "Load price set",
          "owner_commission_set": "Owner commission set on a load",
          "owner_commission_cleared": "Owner commission removed from a load",
          "driver_hours_set": "Driver hours entered on a load"
        },
        "receivable": {
          "invoiced": "Marked invoiced to the broker",
          "invoice_emailed": "Broker invoice emailed",
          "payment_recorded": "Broker payment recorded",
          "payment_reversed": "Broker payment reversed",
          "disputed": "Broker payment disputed",
          "dispute_cleared": "Broker dispute cleared",
          "reopened": "Broker receivable reopened",
          "unmarked": "Invoiced mark removed",
          "updated": "Broker receivable corrected"
        },
        "document": {
          "added": "Document uploaded",
          "replaced": "Document replaced",
          "archived": "Document archived",
          "dates_set": "Document dates set"
        },
        "carrier": {
          "created": "Carrier added",
          "updated": "Carrier updated",
          "status_changed": "Carrier status changed",
          "dispatch_plan_set": "Carrier dispatch percentage set",
          "dispatch_plan_removed": "Carrier dispatch percentage removed",
          "invoice_settings_updated": "Carrier invoice settings updated",
          "driver_payer_set": "Who pays the carrier's drivers changed"
        },
        "truck": {
          "created": "Truck added",
          "updated": "Truck updated",
          "status_changed": "Truck status changed",
          "driver_assigned": "Driver assigned to a truck",
          "driver_unassigned": "Driver removed from a truck",
          "dispatch_plan_set": "Truck dispatch percentage set",
          "dispatch_plan_removed": "Truck dispatch percentage removed",
          "maintenance_tracking_set": "Truck maintenance tracking turned on or off",
          "odometer_recorded": "Odometer reading recorded",
          "odometer_voided": "Odometer reading voided",
          "maintenance_plan_saved": "Truck service plan saved",
          "maintenance_plan_retired": "Truck service plan retired",
          "maintenance_event_recorded": "Truck service recorded",
          "maintenance_event_voided": "Truck service voided"
        },
        "driver": {
          "created": "Driver added",
          "updated": "Driver updated",
          "status_changed": "Driver status changed",
          "seat_added": "Driver added to a carrier",
          "seat_ended": "Driver left a carrier",
          "linked": "Driver joined the app",
          "invite_created": "App code created for a driver",
          "invite_revoked": "App code revoked",
          "account_deleted": "Driver deleted his app account",
          "pay_plan_set": "Driver pay plan set",
          "pay_plan_removed": "Driver pay plan removed",
          "deduction_created": "Driver deduction added",
          "deduction_updated": "Driver deduction changed",
          "deduction_retired": "Driver deduction retired"
        },
        "owner": {
          "created": "Owner added",
          "updated": "Owner updated",
          "status_changed": "Owner status changed"
        },
        "broker_setup": {
          "created": "Broker setup started",
          "updated": "Broker setup updated"
        },
        "broker_incident": {
          "recorded": "Broker incident recorded",
          "resolved": "Broker incident resolved",
          "reopened": "Broker incident reopened"
        },
        "broker": {
          "created": "Broker added",
          "updated": "Broker updated"
        },
        "broker_credit": {
          "checked": "Broker credit checked",
          "fmcsa_lookup": "Broker looked up in FMCSA",
          "overridden": "Blocked broker allowed by the admin"
        },
        "factoring": {
          "created": "Factoring company added",
          "updated": "Factoring company updated",
          "deactivated": "Factoring company deactivated"
        },
        "dispatcher": {
          "carrier_assigned": "Carrier assigned to a dispatcher",
          "carrier_unassigned": "Carrier removed from a dispatcher"
        },
        "member": {
          "invited": "Team member invited",
          "invite_resent": "Team invitation sent again",
          "invite_revoked": "Team invitation revoked",
          "invite_declined": "Team invitation declined",
          "joined": "New team member joined",
          "role_changed": "Team member role changed",
          "status_changed": "Team member status changed"
        },
        "permission": {
          "changed": "Permissions changed"
        },
        "dispatcher_pay": {
          "plan_set": "Dispatcher pay plan set",
          "payment_recorded": "Dispatcher payment recorded",
          "payment_reversed": "Dispatcher payment reversed",
          "settings_set": "Dispatcher pay settings changed"
        },
        "agency": {
          "created": "Agency created",
          "profile_updated": "Company details updated",
          "settings_updated": "Agency settings updated",
          "document_requirement_set": "Required documents changed",
          "suspended": "Agency suspended",
          "reactivated": "Agency reactivated",
          "closed": "Agency closed",
          "flag_set": "Agency feature changed by Coreway",
          "fee_settings_updated": "Fee settings updated",
          "pay_settings_updated": "Pay settings updated",
          "deduction_template_saved": "Deduction catalog entry saved",
          "deduction_template_retired": "Deduction catalog entry retired"
        },
        "invoice": {
          "raised": "Carrier invoice raised",
          "charge_raised": "Charge added to a carrier invoice",
          "line_added": "Line added to a carrier invoice",
          "email_requested": "Carrier invoice emailed",
          "payment_recorded": "Carrier payment recorded",
          "payment_reversed": "Carrier payment reversed",
          "written_off": "Carrier invoice written off"
        },
        "owner_statement": {
          "generated": "Owner statement generated",
          "finalized": "Owner statement finalized",
          "canceled": "Owner statement canceled",
          "line_added": "Line added to an owner statement",
          "line_amount_set": "Owner statement line changed",
          "line_removed": "Line removed from an owner statement",
          "line_restored": "Line restored on an owner statement"
        },
        "truck_lease": {
          "created": "Truck lease created",
          "updated": "Truck lease updated",
          "ended": "Truck lease ended"
        },
        "driver_settlement": {
          "generated": "Driver settlement built",
          "line_added": "Adjustment added to a driver settlement",
          "line_removed": "Line removed from a driver settlement",
          "line_restored": "Line restored on a driver settlement",
          "line_amount_set": "Deduction amount changed on a driver settlement",
          "finalized": "Driver settlement finalized",
          "canceled": "Driver settlement canceled",
          "paid_marked": "Driver settlement marked paid",
          "paid_unmarked": "Driver settlement payment undone"
        },
        "facility": {
          "created": "Facility added",
          "updated": "Facility edited",
          "retired": "Facility retired"
        }
      },
      "other": "Other activity"
    },
    "stop": {
      "pickup": "the pickup",
      "delivery": "the delivery",
      "any": "a stop"
    },
    "groups": {
      "load_lifecycle": "Load status",
      "load_changes": "Load edits",
      "load_tracking": "Arrivals and departures",
      "documents": "Documents",
      "receivables": "Broker payments",
      "fleet": "Carriers, trucks and drivers",
      "brokers": "Brokers",
      "team": "Team",
      "agency": "Agency settings",
      "money": "Money",
      "other": "Other activity"
    },
    "actor": {
      "system": "Coreway",
      "operator": "Coreway support",
      "former": "Former member",
      "onBehalf": "for {{name}}",
      "driver": "Driver"
    },
    "col": {
      "when": "When",
      "who": "Who",
      "what": "What",
      "driver": "Driver",
      "carrier": "Carrier",
      "time": "Time"
    },
    "filters": {
      "label": "Filter the activity",
      "person": "Person",
      "allPeople": "Everyone",
      "driver": "Driver",
      "allDrivers": "All drivers",
      "group": "Kind",
      "allGroups": "All activity",
      "from": "From",
      "to": "To",
      "clear": "Clear filters"
    },
    "dispatcher": "Dispatcher",
    "loadMore": "Load more",
    "newActivity": "New activity. Refresh",
    "empty": "No activity yet.",
    "emptyFiltered": "No activity matches these filters.",
    "noAccess": "Team activity is not enabled for your role. An admin can turn it on in Settings, Permissions.",
    "prefs": {
      "title": "Activity notifications",
      "description": "Muted groups do not ring the bell. The Activity page always shows everything you are allowed to see.",
      "groupLabel": "Notify me about {{group}}",
      "save": "Save notifications",
      "saved": "Activity notifications saved",
      "master": "Activity notifications",
      "masterOnHint": "On: the bell counts what the team does, by the groups below.",
      "masterOffHint": "Off: the bell does not count team activity. Your group choices are kept for when you turn it back on.",
      "masterOn": "Activity notifications turned on",
      "masterOff": "Activity notifications turned off"
    },
    "dates": {
      "label": "Dates",
      "any": "Any date",
      "range": "{{from}} – {{to}}",
      "since": "Since {{date}}",
      "until": "Until {{date}}",
      "today": "Today",
      "last7": "Last 7 days",
      "last30": "Last 30 days",
      "from": "From",
      "to": "To"
    },
    "run": {
      "show": "×{{count}}",
      "showLabel": "Show the {{count}} identical events",
      "hideLabel": "Fold the {{count}} identical events"
    }
  },
  "maintenance": {
    "state": {
      "off": "Off",
      "no_plan": "No plan",
      "ok": "OK",
      "due_soon": "Due soon",
      "overdue": "Overdue",
      "unknown": "No reading"
    },
    "switch": {
      "label": "Maintenance tracking",
      "help": "Plans, odometer and service history for this truck. Reminders arrive as tasks.",
      "turnOn": "Turn on maintenance tracking",
      "turnOnShort": "Turn on",
      "turnedOn": "Maintenance tracking is on for unit {{unit}}.",
      "turnedOff": "Maintenance tracking is off for unit {{unit}}."
    },
    "off": {
      "title": "Maintenance tracking is off",
      "what": "Track service by miles or days and get a task before it is due.",
      "who": "For trucks your agency or its owners run. Owner-operators usually keep their own.",
      "askManager": "An admin, manager or dispatcher can turn it on."
    },
    "tabs": {
      "label": "Truck sections",
      "plan": "Plan",
      "history": "History",
      "odometer": "Odometer",
      "documents": "Documents"
    },
    "readFailed": "Could not load the maintenance of this truck.",
    "plan": {
      "intro": "Service rules by miles, days or both. A task arrives before each one is due.",
      "add": "Add plan",
      "editTitle": "Edit plan",
      "dialogHelp": "The interval counts from today and the current odometer. Logging a service on the plan restarts it.",
      "presets": "Start from a preset",
      "label": "Name",
      "labelTooLong": "Up to 60 characters.",
      "everyMiles": "Every (miles)",
      "everyMilesHelp": "Leave blank for a rule by days only.",
      "everyDays": "Every (days)",
      "everyDaysHelp": "Leave blank for a rule by miles only.",
      "warnMiles": "Warn this many miles before",
      "warnDays": "Warn this many days before",
      "milesRange": "Between 500 and 1,000,000 miles.",
      "daysRange": "Between 1 and 3,650 days.",
      "needRule": "Set every how many miles, days, or both.",
      "warnMilesRange": "Between 0 and 100,000 miles.",
      "warnDaysRange": "Between 0 and 365 days.",
      "needsReading": "A miles rule counts from the current odometer: add a reading on the Odometer tab first.",
      "save": "Save plan",
      "saved": "Plan saved.",
      "ruleBoth_one": "Every {{miles}} mi or {{count}} day",
      "ruleBoth_other": "Every {{miles}} mi or {{count}} days",
      "ruleMiles": "Every {{miles}} mi",
      "ruleDays_one": "Every {{count}} day",
      "ruleDays_other": "Every {{count}} days",
      "nextAt": "Next service at {{miles}} mi",
      "dueToday": "Due today, {{date}}",
      "inDays_one": "Due in {{count}} day, {{date}}",
      "inDays_other": "Due in {{count}} days, {{date}}",
      "daysOverdue_one": "{{count}} day overdue, since {{date}}",
      "daysOverdue_other": "{{count}} days overdue, since {{date}}",
      "logService": "Log service",
      "editNamed": "Edit {{label}}",
      "retire": "Retire",
      "retireNamed": "Retire {{label}}",
      "retireTitle": "Retire {{label}}?",
      "retireBody": "The plan stops sending reminders. Its past services stay in the history.",
      "retired": "Plan retired.",
      "emptyTitle": "No plans yet",
      "emptyText": "Add an oil change, an annual inspection or any rule by miles or days."
    },
    "presets": {
      "oil": "Oil change",
      "inspection": "Annual inspection",
      "tires": "Tires",
      "brakes": "Brakes"
    },
    "kinds": {
      "preventive": "Preventive",
      "repair": "Repair",
      "inspection": "Inspection",
      "tires": "Tires",
      "other": "Other"
    },
    "sources": {
      "office": "Office",
      "driver": "Driver",
      "maintenance_event": "Service"
    },
    "service": {
      "title": "Record service",
      "kind": "Kind",
      "date": "Date",
      "description": "What was done",
      "odometer": "Odometer",
      "odometerHelp": "Current: {{miles}} mi.",
      "cost": "Cost",
      "shop": "Shop",
      "plan": "Plan",
      "planHelp": "Restarts that plan's interval from this service.",
      "noPlan": "No plan",
      "file": "Invoice or work order",
      "fileHelp": "Optional. A PDF or a photo, up to 25 MB.",
      "save": "Save service",
      "saved": "Service recorded.",
      "future": "The date cannot be after today.",
      "costInvalid": "Enter an amount up to $1,000,000.00.",
      "fileKept": "The file is uploaded but the service was not saved. Save again: the file is not uploaded twice."
    },
    "history": {
      "intro": "Every service on this truck, newest first.",
      "emptyTitle": "No services yet",
      "emptyText": "Record an oil change, a repair or an inspection with its cost and its invoice.",
      "atMiles": "at {{miles}} mi",
      "openFile": "Open {{name}}",
      "void": "Void",
      "voidNamed": "Void {{what}}",
      "voidTitle": "Void this service?",
      "voidBody": "{{what}} leaves the history and the cost report. If it restarted a plan, the plan goes back to its previous count.",
      "voided": "Service voided.",
      "year": "This year: {{cost}} · {{perMile}} per mile",
      "yearNoMiles": "This year: {{cost}} · no miles yet"
    },
    "odometer": {
      "current": "Current odometer",
      "miles": "{{miles}} mi",
      "estimate": "est. {{miles}} mi",
      "estimateHelp": "Last reading on {{date}} plus the miles of the loads delivered since.",
      "none": "No reading yet. Add one so the rules by miles can count.",
      "reading": "Odometer reading",
      "date": "Date",
      "add": "Add reading",
      "saved": "Reading added.",
      "invalid": "Whole miles, like 123,450.",
      "list": "Readings",
      "empty": "No readings yet.",
      "voidNamed": "Void the reading of {{miles}} mi",
      "voidTitle": "Void this reading?",
      "voidBody": "The reading of {{miles}} mi stops counting toward the plans.",
      "voided": "Reading voided."
    },
    "list": {
      "column": "Maintenance",
      "odometer": "Odometer",
      "attention": "Needs attention",
      "menu": "Maintenance",
      "openNamed": "Maintenance of unit {{unit}}: {{state}}",
      "noAttention": "No truck needs attention.",
      "notTracked": "Not tracked"
    },
    "suggestion": {
      "label": "Maintenance tracking suggestion",
      "text_one": "{{count}} truck of carriers whose drivers you pay is not tracked.",
      "text_other": "{{count}} trucks of carriers whose drivers you pay are not tracked.",
      "help": "Tracking is off by default. Turn it on to get service reminders as tasks.",
      "action": "Turn on tracking",
      "dismiss": "Not now",
      "done_one": "Tracking is on for {{count}} truck.",
      "done_other": "Tracking is on for {{count}} trucks.",
      "partial": "Turned on {{done}} of {{total}} trucks. Open a truck to see why the rest failed."
    },
    "kpi": {
      "label": "Fleet attention",
      "hint": "{{service}} service · {{docs}} documents",
      "link": "Fleet attention: {{count}}, open the trucks that need it"
    },
    "due": {
      "title": "Service due",
      "viewAll": "View trucks",
      "empty": "No service due. Every tracked truck is on schedule.",
      "error": "Could not load the service due.",
      "line": "{{label}}",
      "plansDue_one": "{{count}} plan due",
      "plansDue_other": "{{count}} plans due"
    },
    "report": {
      "view": "Cost per mile",
      "tableLabel": "Cost per mile per truck",
      "chartLabel": "Cost per mile per truck, highest first",
      "unit": "Truck",
      "carrier": "Carrier",
      "miles": "Miles",
      "cost": "Maintenance cost",
      "events": "Services",
      "perMile": "$ per mile",
      "na": "n/a",
      "naHelp": "No miles in the period",
      "source": {
        "odometer": "Odometer",
        "loads": "Loads"
      },
      "sourceColumn": "Miles from",
      "sourceHelp": "Miles come from the odometer when there is a reading on or before the period start and one inside it, else from the delivered loads.",
      "total": "Total",
      "rule": "Services performed from {{from}} through {{to}}; miles in the same days ({{timeZone}} time).",
      "empty": "No tracked truck and no service in this period.",
      "offTitle": "No truck is tracked yet",
      "offWhat": "See what each truck costs per mile in service and repairs.",
      "offWho": "For agencies that run or pay for their trucks. Turn tracking on from a truck in the Trucks list.",
      "offAction": "Open trucks",
      "error": "Could not load the cost per mile.",
      "fileTitle": "Cost per mile"
    }
  },
  "invoicePackage": {
    "title": "Invoice packet and POD",
    "intro": "The required load documents are set under Documentation, Requirements, Loads (by default the rate confirmation, BOL and POD).",
    "policy": {
      "label": "When the packet is incomplete",
      "warn": "Warn",
      "block": "Block"
    },
    "policyHelp": {
      "warn": "The office sees what is missing and can mark the load invoiced anyway.",
      "block": "A load can't be marked invoiced, or its packet emailed, until the required documents are uploaded."
    },
    "podHours": {
      "label": "Ask for the POD after (hours)",
      "help": "Hours after delivery with no POD before the load's dispatcher gets a task (1 to 720). It reopens every 48 hours until the POD arrives; the driver gets a reminder when the app supports it.",
      "save": "Save hours"
    },
    "saved": "Saved."
  },
  "facilities": {
    "retiredNote": "Retired facilities leave this list and the stop picker; stops already filled keep their data.",
    "add": "Add facility",
    "edit": "Edit facility",
    "retire": "Retire",
    "retireTitle": "Retire {{name}}?",
    "retireConfirm": "It leaves the list and the stop picker. Stops already filled from it keep their data.",
    "retired": "Facility retired.",
    "created": "Facility added.",
    "saved": "Facility saved.",
    "empty": "No facilities yet. Add the shippers and receivers you use again.",
    "search": "Search facilities",
    "searchPlaceholder": "Name, company or city",
    "col": {
      "name": "Facility",
      "kind": "Kind",
      "place": "City",
      "contact": "Contact",
      "hours": "Hours",
      "actions": "Actions"
    },
    "kind": {
      "pickup": "Pickup",
      "delivery": "Delivery",
      "both": "Pickup and delivery"
    },
    "sections": {
      "place": "Place",
      "contact": "Contact and hours",
      "notes": "Notes"
    },
    "hoursHelp": "Receiving or shipping hours as the dock gives them. A stop filled from here gets them in its notes.",
    "zoneHelp": "The clock the hours are in. Blank: the state's.",
    "zoneFromState": "From the state",
    "errors": {
      "duplicate": "There is already a facility with this name."
    },
    "count_one": "{{count}} facility",
    "count_other": "{{count}} facilities",
    "sheetHelp": "Shippers and receivers you use again; a stop picks it to fill address, contact and hours."
  },
  "accessorials": {
    "kind": {
      "detention": "Detention",
      "lumper": "Lumper",
      "layover": "Layover",
      "stop_off": "Stop-off",
      "fuel_surcharge": "Fuel surcharge",
      "tarp": "Tarp",
      "other": "Other"
    },
    "fields": {
      "kind": "Kind",
      "amount": "Amount",
      "note": "Note",
      "paidByDriver": "Paid by the driver"
    },
    "paidByDriverHelp": "He paid it at the dock. Agency- or owner-paid drivers get it back in full on their settlement.",
    "errors": {
      "amountRequired": "Enter an amount above $0.00.",
      "noteTooLong": "A note takes at most 500 characters."
    }
  },
  "podReview": {
    "columns": {
      "paperwork": "Paperwork",
      "carrierDriver": "Carrier · driver"
    },
    "foot_one": "{{count}} delivered load waiting for paperwork · oldest delivery first",
    "foot_other": "{{count}} delivered loads waiting for paperwork · oldest delivery first",
    "review": "Review POD"
  }
}
